<template>
  <div>
    <div v-if="isSaving" class="loading-mask">
      Wating...
    </div>

    <PageHeader :title="sending?'メール送信中...':savingSubTask?'サブタスク保存中':'Request Post'" :class="sending||savingSubTask?'animate-pulse':''" :isUserMenu="!forCustomers" class="requestPostPageHeader-contents">
      <template #title-header-content>
        <div class="ml-auto flex items-center gap-2"  v-tooltip="!canEdit?'担当者と同じ部署・依頼主でないため、更新・完了はできません':''">

          <div v-if="isAlreadySent" class="text-white font-bold text-sm mr-10">
            発注メール送信済み
          </div>

          <div class="text-white font-bold text-sm mr-10" v-if="isShowCategoryItem('面接関連')&&requestPost.newGrad&&!requestPost.firstInterviewRes">
            一次合否決定前は必須項目未入力でも保存可能
          </div>

          <PrimaryButton v-if="!referenceMode && (mainAuth || (requestPost.category2[0] && requestPost.category2[0] == 'お客様直'))" :disabled="isSaving || saved || !canEdit" class="w-28 bg-green-600" :text="editMode ? '更新' : '登録'" @click="save(false)">
            <LoadingIcon v-if="isSaving" slot="before" class="h-4 w-4" />
            <Icon v-if="!isSaving" slot="before" class="h-4 w-4" />
          </PrimaryButton>

          <PrimaryButton :disabled="(isSaving || saved)" class="w-28 bg-light-blue-500" :text="'仮登録'" @click="save(true)" v-if="!forCustomers && mainAuth && !referenceMode && canEdit && (isShowCategoryItem('見積依頼')||isShowCategoryItem('面接関連')) && (!requestPost.interviewsResult || !requestPost.interviewsResult.length)">

            <LoadingIcon v-if="isSaving" slot="before" class="h-4 w-4" />
            <Icon v-else slot="before" iconName="Tag" class="h-4 w-4" />
          </PrimaryButton>

          <div v-if="isOrder" v-tooltip="purchaseTooltip">
            <PrimaryButton :disabled="!activePurchaseBtn || !canEdit" text="発注" class="w-28" :class="activePurchaseBtn?'dark-yellow':'bg-gray-400'" @click="purchaseMail()" v-if="!forCustomers">
              <Icon slot="before" iconName="Mail" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>

          <PrimaryButton text="一覧" class="w-28" @click="toList(1)" v-if="!forCustomers" :disabled="isSaving">
            <LoadingIcon v-if="isSaving" slot="before" class="h-5 w-5" />
            <Icon v-if="!isSaving" slot="before" iconName="ClipboardList" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>

          <PrimaryButton text="カレンダー" class="w-28 bg-blue-100 text-light-blue-700 border-light-blue-700 text-xs" @click="toList(2)" v-if="!forCustomers" :disabled="isSaving">
            <LoadingIcon v-if="isSaving" slot="before" class="h-5 w-5" />
            <Icon v-else slot="before" iconName="Calendar" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>

          <PrimaryButton :disabled="(isSaving || saved) || !isCompleteButtunActive || !canEdit" class="w-28" :class="isCompleteButtunActive ? 'bg-red-600':'bg-gray-400'" :text="'完了' " @click="statusDone" v-if="!forCustomers && mainAuth && editMode && !isOrder && !referenceMode">
            <LoadingIcon v-if="isSaving" slot="before" class="h-4 w-4" />
            <Icon v-if="!isSaving" slot="before" class="h-4 w-4" />
          </PrimaryButton>
        </div>
      </template>
    </PageHeader>
    <main class="absolute w-screen bottom-4 -mt-2 page-contents requestPostMain-contents">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-gray-100 rounded-md border border-gray-300 overflow-auto h-full">

          <div v-if="initialized" class="px-0">

            <div class="flex">
              <div class="flex-1 p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start">

                <div class="sm:col-span-full" v-if="!forCustomers">
                  <Category2Select
                    name="category2"
                    caption="社内/お客様"
                    v-model="requestPost.category2"
                    :required="isOutsideRequired"
                    :error="!validateCategory2.result"
                    :errorMessage="validateCategory2.message"
                    @change="category2Changed"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" id="inquiry-category">
                  <CategorySelect
                    name="category"
                    caption="お問い合わせカテゴリー(複数選択可)"
                    v-model="requestPost.category"
                    :required="true"
                    :error="!validateCategory.result"
                    :errorMessage="validateCategory.message"
                    @change="categoryChanged($event, true)"
                    :disabled="referenceMode || mode==6"
                  />
                </div>

                <div v-if="isShowCategoryItem('非公開依頼')" class="sm:col-span-full my-5 flex">
                  <!-- 非公開の始末書 -->
                  <input
                    type="checkbox"
                    id="apology"
                    class="h-5 w-5 self-center"
                    v-model="requestPost.apology"
                    :disabled="referenceMode||((requestPost.apology || requestPost.reflect)&&requestPost._id)"
                    :class="referenceMode||((requestPost.apology || requestPost.reflect)&&requestPost._id)?'cursor-not-allowed':''"
                    @change="changeApologyOrReflect(1)"
                  />
                  <label for="apology" class="py-1 px-2" :class="requestPost.apology?'font-bold text-blue-800':''"> 始末書 </label>

                  <!-- 非公開の反省文 -->
                  <input
                    type="checkbox"
                    id="reflect"
                    class="h-5 w-5  self-center ml-10"
                    v-model="requestPost.reflect"
                    :disabled="referenceMode||((requestPost.apology || requestPost.reflect)&&requestPost._id)"
                    :class="referenceMode||((requestPost.apology || requestPost.reflect)&&requestPost._id)?'cursor-not-allowed':''"
                    @change="changeApologyOrReflect(2)"
                  />
                  <label for="reflect" class="py-1 px-2" :class="requestPost.reflect?'font-bold text-blue-800':''"> 反省文 </label>
                </div>

                <SelectionOneValue
                  v-tooltip="requestPost.kubunLimitDisabled?'短期として一度保存されたので変更できません':''"
                  caption="期限区分"
                  v-model="requestPost.kubunLimit"
                  :list="[{ id: 1, name: '短期タスク（1ヶ月以内）' },{ id: 2, name: '長期タスク（1ヶ月超）' } ]"
                  :required="true"
                  :disabled="referenceMode||requestPost.kubunLimitDisabled"
                  class="mt-3 sm:col-span-full"
                  @change="changeKubunLimit"
                ></SelectionOneValue>

                <div class="sm:col-span-full">
                  <WmsTextInput
                    name="requestNo"
                    caption="お問い合わせ番号(登録時)"
                    :disabled="true"
                    v-model="requestPost.requestNo"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('追加依頼')">
                  <WmsTextInput
                    name="lastRequestNo"
                    caption="お問い合わせ番号(前回問い合わせ時の返信メールに記載がございます)"
                    v-model="requestPost.lastRequestNo"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-if="!forCustomers && !isTransmission">
                  <WmsTextInput
                    name="inquiry_title"
                    caption="タイトル"
                    :required="isOutsideRequired"
                    v-model="requestPost.inquiry_title"
                    :error="!validateInquiry_title.result"
                    :errorMessage="validateInquiry_title.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-if="!isTransmission && !isOrder && !isShowCategoryItem('面接関連') && !isShowCategoryItem('雇い入れ') && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）')">
                  <WmsTextInput
                    name="note"
                    caption="お問い合わせ内容"
                    :multiline="true"
                    :rows="5"
                    v-model="requestPost.note"
                    :disabled="referenceMode"
                    @change="noteChange()"
                  />
                </div>

                <div v-for="(link, index) in noteLinks" v-bind:key="index" class="note-link sm:col-span-full ml-2">
                  <a :href="link" target="_blank" rel="noopener noreferrer" class="text-sm text-indigo-600 hover:text-indigo-900 border-b border-indigo-600">{{ link }}</a>
                </div>

                <div class="sm:col-span-full" v-if="!isShowCategoryItem('雇い入れ') && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）') && !isShowCategoryItem('デンタツ') && !(isShowCategoryItem('面接関連') && this.requestPost.interviewsRegularStaff)">
                  <WmsSuggestInput
                    name="clientName"
                    caption="お客様会社名"
                    :required="((isClientRequired || requestPost.temporarySaveFlag) && isOutsideRequired)"
                    :selectionItems="clientLists"
                    :displayField="['clientName', 'clientDepartmentName']"
                    v-model="requestPost.clientName"
                    :disabled="forCustomers || referenceMode"
                    :error="!validateClientName.result"
                    :errorMessage="validateClientName.message"
                    :clearable="true"
                    @selected="clientSelected"
                    @change="clientNameChanged"
                  >
                    <template #addon-content v-if="!forCustomers">
                      <Icon
                        iconName="Search"
                        :clickable="true"
                        class="w-4 h-4 mr-0.5"
                        @click="openClientModal"
                      />
                    </template>
                  </WmsSuggestInput>
                </div>

                <div class="sm:col-span-full" v-if="!isTransmission && !isShowCategoryItem('面接関連') && !isShowCategoryItem('雇い入れ') && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）')">
                  <WmsTextInput
                    name="clientAddress1"
                    caption="お客様住所（都道府県・市区群・町村・番地）"
                    :disabled="referenceMode"
                    v-model="requestPost.clientAddress1"
                  />
                </div>

                <div class="sm:col-span-full" v-if="!isTransmission && !isShowCategoryItem('面接関連') && !isShowCategoryItem('雇い入れ') && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）')">
                  <WmsTextInput
                    name="clientAddress2"
                    caption="お客様住所（建物名）"
                    :disabled="referenceMode"
                    v-model="requestPost.clientAddress2"
                  />
                </div>

                <div class="sm:col-span-full" v-if="!isShowCategoryItem('面接関連') && !isShowCategoryItem('雇い入れ')  && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）') && !isShowCategoryItem('デンタツ')">
                  <WmsTextInput
                    name="clientPersonName"
                    caption="お客様担当者名"
                    :required="isClientRequired && isOutsideRequired"
                    v-model="requestPost.clientPersonName"
                    :error="!validateClientPersonName.result"
                    :errorMessage="validateClientPersonName.message"
                    :disabled="referenceMode"
                    @change="changeClientPersonName()"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('デンタツ')">
                  <WmsSuggestInput
                    name="employeeName"
                    caption="従業員名"
                    :selectionItems="akbsStaffList"
                    displayField="kana"
                    v-model="requestPost.employeeName"
                    :disabled="referenceMode"
                    @selected="staffSelected($event)"
                    @blur="staffChanged()"
                  >
                  </WmsSuggestInput>
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('デンタツ')">
                  <label class="block text-xs font-bold text-gray-700 relative">
                    電話番号
                    <span class="absolute -top-0.5 ml-1 text-red-500"> * </span>
                  </label>
                  <div class="mt-1 flex relative">
                    <InputIcon v-if="!validateTelephoneNumber.result" iconName="ExclamationCircle" iconColor="red" :message="validateTelephoneNumber.message" />
                    <input
                      type="tel"
                      name="interviewsMobile"
                      v-model="requestPost.telephoneNumber"
                      class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
                      @change="changeTel()"
                    />
                  </div>
                  <a
                    :href="`tel:${requestPost.telephoneNumber}`"
                    class="inline-block mt-1 ml-3 text-sm font-bold text-indigo-600 underline hover:text-indigo-800"
                    >{{ requestPost.telephoneNumber }}</a
                  >
                </div>

                <div class="sm:col-span-full flex" v-if="isShowCategoryItem('デンタツ') && requestPost.staffNumber">
                  <WmsTextInput
                    name="staffNumber"
                    caption="清掃員コード"
                    v-model="requestPost.staffNumber"
                    :disabled="true"
                    class="dccode"
                  />

                  <PrimaryButton size="xs" class="self-end mx-3" text="清掃員詳細を開く" @click="openAkbsStaff()"></PrimaryButton>
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('デンタツ')">
                  <WmsSuggestInput
                    name="clientName"
                    caption="お客様会社名（物件名）"
                    :selectionItems="akbsBuildingList"
                    displayField="name"
                    v-model="requestPost.clientName"
                    @blur="changeToMail()"
                    @selected="siteDentatsuSelectedForm($event)"
                  >
                    <template #addon-content>
                      <Icon
                        iconName="Search"
                        :clickable="true"
                        class="w-4 h-4 mr-0.5"
                        @click="siteDentatsuModal=true"
                      />
                    </template>
                  </WmsSuggestInput>
                  <div class="text-blue-700 text-xs font-bold">{{ requestPost.siteAddress }}</div>
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('デンタツ')">
                  <WmsTextInput
                    name="clientPersonName"
                    caption="お客様名"
                    v-model="requestPost.clientPersonName"
                    :error="!validateClientPersonName.result"
                    :errorMessage="validateClientPersonName.message"
                    :disabled="referenceMode"
                    @change="dentatsuClientName()"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('デンタツ')">
                  <WmsTextInput
                    name="inquiry_title"
                    caption="お問い合わせ内容（タイトル）"
                    v-model="requestPost.inquiry_title"
                    :disabled="referenceMode"
                    :multiline="true"
                    :rows="5"
                  />
                </div>

                <div class="sm:col-span-full" v-if="(!isShowCategoryItem('見積依頼') || this.requestPost.category2[0] == 'お客様直') && !isShowCategoryItem('面接関連') && !isShowCategoryItem('雇い入れ') && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）')">
                  <WmsTextInput
                    name="clientMail"
                    :caption="isTransmission ? 'メールアドレス' : 'メールアドレス(こちらのメールアドレスに回答が届きます)'"
                    :required="isClientRequired && isOutsideRequired"
                    v-model="requestPost.clientMail"
                    :error="!validateClientMail.result"
                    :errorMessage="validateClientMail.message"
                    :disabled="referenceMode"
                  />
                  <p v-if="emailInputCheck" class="emailInputCheck">メールアドレスの形式で入力してください。</p>
                </div>

                <!-- 見積りの場合のみ -->
                <div class="sm:col-span-full" v-else-if="isShowCategoryItem('見積依頼') && this.requestPost.category2[0] != 'お客様直'">
                  <WmsSuggestInput
                    name="clientMail"
                    caption="メールアドレス(こちらのメールアドレスに回答が届きます)"
                    :selectionItems="mailList"
                    :displayField="['clientName', 'clientName2', 'name', 'mail', 'siteName']"
                    :required="isClientRequired && isOutsideRequired"
                    :error="!validateClientMail.result"
                    :errorMessage="validateClientMail.message"
                    :disabled="referenceMode"
                    :clearable="true"
                    v-model="requestPost.clientMail"
                    @selected="selectedMail($event)"
                  >
                  </WmsSuggestInput>
                  <p v-if="emailInputCheck" class="emailInputCheck">メールアドレスの形式で入力してください。</p>
                </div>

                <div v-if="requestPost.overAttach" class="my-2 text-red-700 font-bold text-sm sm:col-span-full">{{ requestPost.overAttach }}</div>

                <div v-if="requestPost.fileNa" class="my-2 text-red-700 font-bold text-sm sm:col-span-full whitespace-pre-line">{{ requestPost.fileNa }}</div>

                <div v-if="requestPost.mailFailAttach" class="my-2 text-red-700 font-bold text-sm sm:col-span-full">{{ requestPost.mailFailAttach }}</div>

                <div class="sm:col-span-full" v-if="!isShowCategoryItem('面接関連') && !isShowCategoryItem('雇い入れ')  && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）')">
                  <label class="block text-xs font-bold text-gray-700">
                    {{ isShowCategoryItem('非公開依頼')&&requestPost.apology?'始末書（手書き）原本':isShowCategoryItem('非公開依頼')&&requestPost.reflect?'反省文（手書き）原本':'添付資料' }}
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="commonFile"
                        :value="requestPost.commonFile"
                        style="max-width: none!important;"
                        :class="isShowCategoryItem('非公開依頼')&&(requestPost.apology||requestPost.reflect)?'border-red-700':''"
                        @change="attachmentChange('commonFile', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <!-- 添付資料追加 -->
                <div class="sm:col-span-full" v-if="!referenceMode && !isShowCategoryItem('面接関連') && !isShowCategoryItem('雇い入れ')  && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）')">
                  <AddFileBtnSelect
                    name="addFileBtn"
                    v-model="requestPost.addFileBtn"
                  />
                </div>

                <div class="sm:col-span-full" v-if="isShowAddFileBtnItem('添付資料追加')">
                  <label class="block text-xs font-bold text-gray-700">
                    添付資料2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="commonFile2"
                        :value="requestPost.commonFile2"
                        style="max-width: none!important;"
                        @change="attachmentChange('commonFile2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-if="isShowAddFileBtnItem('添付資料追加')">
                  <label class="block text-xs font-bold text-gray-700">
                    添付資料3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="commonFile3"
                        :value="requestPost.commonFile3"
                        style="max-width: none!important;"
                        @change="attachmentChange('commonFile3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-if="isShowAddFileBtnItem('添付資料追加')">
                  <label class="block text-xs font-bold text-gray-700">
                    添付資料4
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="commonFile4"
                        :value="requestPost.commonFile4"
                        style="max-width: none!important;"
                        @change="attachmentChange('commonFile4', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-if="isShowAddFileBtnItem('添付資料追加')">
                  <label class="block text-xs font-bold text-gray-700">
                    添付資料5
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="commonFile5"
                        :value="requestPost.commonFile5"
                        style="max-width: none!important;"
                        @change="attachmentChange('commonFile5', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-if="!forCustomers && !isOrder && !(isShowCategoryItem('面接関連') && this.requestPost.interviewsRegularStaff)">
                  <div class="text-xs font-bold text-gray-700 mb-1">対応内容<span class="pl-5 text-red-700" v-if="isShowCategoryItem('面接関連') || isShowCategoryItem('雇い入れ（社員）') || isShowCategoryItem('雇い入れ（清掃員）')">右側の「連絡事項」をご利用ください</span></div>
                  <WmsTextInput
                    name="reason_note"
                    :multiline="true"
                    :rows="5"
                    v-model="requestPost.reason_note"
                    :disabled="referenceMode || isShowCategoryItem('面接関連') || isShowCategoryItem('雇い入れ') || isShowCategoryItem('雇い入れ（社員）') || isShowCategoryItem('雇い入れ（清掃員）')"
                  />
                </div>

                <div class="sm:col-span-3">
                  <WmsSearchSelect
                    name="toDepartment"
                    caption="アポロ管財依頼先部署"
                    :value="selectedToDepartment"
                    :options="toDepartmentList"
                    track-by="departmentId"
                    label="name"
                    :required="true"
                    :error="!validateToDepartment.result"
                    :errorMessage="validateToDepartment.message"
                    :disabled="referenceMode"
                    @input="onSelectToDepartment"
                  />
                </div>

                <div class="sm:col-span-3" style="margin-top: auto" v-if="!referenceMode">
                  <HelpBtnSelect
                    name="helpBtnSelect"
                    v-model="requestPost.helpBtnSelect"
                  />
                </div>

                <div class="sm:col-span-full" v-if="!forCustomers">
                  <div class="text-xs font-bold text-gray-700 mb-1 flex">
                    {{ isApology ? '担当者（始末書・反省文の対象者）' : '担当者' }}
                    <span class="ml-1 text-red-500"> * </span>
                    <div v-if="canMultiRegist" @click="openMultiStaff=true" class="text-blue-700 border-b border-blue-700 cursor-pointer ml-auto"> 複数人登録</div>
                    <div v-if="isShowCategoryItem('デンタツ')" @click="openUserArea=true" class="text-blue-700 border-b border-blue-700 cursor-pointer" :class="canMultiRegist?'ml-5':'ml-auto'"> 担当エリア編集（勤怠・建物）</div>
                  </div>
                  <WmsSearchSelect
                    name="toStaffName"
                    :value="selectedToStaff"
                    :options="toStaffNameList"
                    track-by="rowKey"
                    :custom-label="staffOptionLabel"
                    :selected-label="staffSelectedLabel"
                    :required="true"
                    :error="!validateToStaffName.result"
                    :errorMessage="validateToStaffName.message"
                    :disabled="referenceMode||(originalRequestPost && originalRequestPost.byUser && isApology && userId != originalRequestPost.byUserId)"
                    @input="onSelectToStaff"
                  />

                  <!-- 複数人登録で選択した社員 -->
                  <div v-if="multiStaffList.length" class="mt-2 p-2 border border-indigo-300 rounded bg-indigo-50">
                    <div class="flex items-center text-xs font-bold text-indigo-700 mb-1">
                      複数人登録：{{ multiStaffList.length }}名
                      <div v-if="!referenceMode" @click="clearMultiStaff" class="text-blue-700 border-b border-blue-700 cursor-pointer ml-auto font-normal">選択を解除</div>
                    </div>
                    <div class="flex flex-wrap gap-2">
                      <div v-for="(staff, i) in multiStaffList" :key="'multiStaff' + i" class="px-2 py-1 bg-white border border-indigo-200 rounded text-xs text-gray-700">
                        {{ staff.userName }}
                      </div>
                    </div>
                    <div class="text-xs text-gray-500 mt-1">＊保存すると、上記の社員それぞれに同じ内容のメインタスクを登録します。</div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="!forCustomers">
                  <WmsSearchSelect
                    name="byUser"
                    caption="依頼主"
                    :value="selectedByUser"
                    :options="$store.getters.userList"
                    track-by="id"
                    label="user_name"
                    :required="true"
                    :error="!validateByUser.result"
                    :errorMessage="validateByUser.message"
                    :disabled="referenceMode||(originalRequestPost && originalRequestPost.byUser && isApology && userId != originalRequestPost.byUserId)"
                    @input="onSelectByUser"
                  />
                </div>

                <div class="sm:col-span-full">
                  <WmsDateInput
                    name="requestDate"
                    caption="依頼日"
                    :disabled="true"
                    v-model="requestPost.requestDate"
                    :clearable="true"
                  />
                </div>

                <SelectionOneValue
                  v-tooltip="requestPost.kubunLimitDisabled?'短期として一度保存されたので変更できません':''"
                  caption="期限区分"
                  v-model="requestPost.kubunLimit"
                  :list="[{ id: 1, name: '短期タスク（1ヶ月以内）' },{ id: 2, name: '長期タスク（1ヶ月超）' } ]"
                  :required="true"
                  :disabled="referenceMode||requestPost.kubunLimitDisabled"
                  class="mt-3 sm:col-span-full"
                  @change="changeKubunLimit"
                ></SelectionOneValue>

                <div id="limitDate" class="sm:col-span-full">
                  <WmsDateInput
                    name="limitDate"
                    caption="期限"
                    :required="true"
                    :error="!validateLimitDate.result"
                    :errorMessage="validateLimitDate.message"
                    v-model="requestPost.limitDate"
                    :clearable="true"
                    :min="minLimitDate"
                    :max="requestPost.kubunLimit==1?maxLimitDate:''"
                    :disabled="referenceMode"
                  />

                  <div v-if="requestPost.limitDateHistory&&requestPost.limitDateHistory.length" class="text-sm mt-2 border border-blue-100 bg-blue-50 p-2 text-gray-600">
                    <div class="font-bold text-blue-500 text-xs">期限日変更履歴</div>
                    <div v-for="(limit , i) in requestPost.limitDateHistory" :key="'l'+i" class="mt-2">
                      {{ limit }}
                    </div>
                  </div>
                </div>

              </div>

              <div class="p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start" :class="isCategory && !isShowCategoryItem('雇い入れ')  && !isShowCategoryItem('雇い入れ（社員）') && !isShowCategoryItem('雇い入れ（清掃員）') && !isShowCategoryItem('面接関連') && !isShowCategoryItem('変更処理（解約・変更）') && !isShowCategoryItem('業務依頼') ? 'rp-estimate' : 'rp-no-estimate'">

                <!-- 確認・質問：AKBS登録時に「確認メインタスクを作る」を選んだ休み・代勤・振替（AKBS入力画面と同じ表。閲覧のみ） -->
                <div v-if="isShowCategoryItem('確認・質問') && akbsCheckGroups.length" class="sm:col-span-full bg-white border border-indigo-200 rounded shadow">
                  <div class="text-sm font-bold text-indigo-900 bg-indigo-50 rounded-t px-3 py-2 border-b border-indigo-200">
                    AKBS登録時に確認が必要と判断した休み・代勤・振替
                    <span v-if="requestPost.akbsStaffName" class="ml-3 text-xs font-normal text-gray-500">{{ requestPost.akbsStaffName }} さん</span>
                    <!-- 操作した日時・人（もう操作できないことが分かるように。古いタスクには無い） -->
                    <div v-if="requestPost.akbsCheckDate" class="text-xs font-normal text-gray-600 mt-1">
                      {{ requestPost.akbsCheckDate }} に{{ requestPost.akbsCheckUser ? ` ${requestPost.akbsCheckUser} さんが` : '' }}操作した内容です。
                    </div>
                    <!-- AKBS の稼働管理（確認する日の範囲・この清掃員で絞った状態）を別タブで開く -->
                    <!-- 何の URL か分かるよう、先頭に「AKBS：」と画面名を付ける -->
                    <div v-if="akbsOperationUrl" class="text-xs font-normal mt-1">
                      <span class="font-bold text-gray-700">AKBS（稼働管理）：</span>
                      <a :href="akbsOperationUrl" target="_blank" rel="noopener noreferrer" class="text-blue-700 border-b border-blue-700">{{ akbsOperationUrl }}</a>
                    </div>
                  </div>
                  <div class="px-3 pb-3">
                    <WorkingCheckCard
                      v-for="g in akbsCheckGroups"
                      :key="g.key"
                      :list="g.rows"
                      :caption="g.caption"
                      :radioName="'rp' + g.key"
                      :disabled="true"
                      :staffName="requestPost.akbsStaffName || ''"
                    />
                  </div>
                </div>

                <!-- AKBS録音確認：AKBS の休み登録のたびに同じ清掃員の未完了タスクへ足される履歴（古い順。閲覧のみ。お問い合わせ内容は1回目の分だけで、利用者が書き換えられるのでこちらを正とする） -->
                <div v-if="isShowCategoryItem('AKBS録音確認') && requestPost.akbsRecords && requestPost.akbsRecords.length" class="sm:col-span-full bg-white border border-indigo-200 rounded shadow">
                  <div class="text-sm font-bold text-indigo-900 bg-indigo-50 rounded-t px-3 py-2 border-b border-indigo-200">
                    AKBS 休み登録の履歴（録音確認）
                    <span class="ml-3 text-xs font-normal text-gray-500">太枠が最新です。全部で {{ requestPost.akbsRecords.length }} 回更新あり。</span>
                  </div>
                  <div class="px-3 pb-3 text-sm">
                    <div v-for="(r, i) in requestPost.akbsRecords" :key="'akbsRecord' + i">
                      <div v-if="i > 0" class="text-center text-gray-400 text-xl leading-none my-1">↓</div>
                      <div class="rounded p-2" :class="i == requestPost.akbsRecords.length - 1 ? 'border-2 border-indigo-600 bg-indigo-50' : 'border border-gray-300'">
                        <div class="text-xs text-gray-600 font-bold">{{ r.registeredAt }}<span class="ml-3">登録：{{ r.registeredBy }}</span></div>
                        <div class="mt-1">清掃員：{{ r.staffName }}<span v-if="r.kana" class="text-xs text-gray-500">（{{ r.kana }}）</span><span v-if="r.tel" class="ml-2 text-xs">TEL：{{ r.tel }}</span></div>
                        <div v-for="(s, j) in (r.sites || [])" :key="'akbsRecordSite' + i + '-' + j" class="mt-1">
                          <div class="font-bold">● {{ s.nameSite }}</div>
                          <div v-for="(l, k) in (s.lines || [])" :key="'akbsRecordLine' + i + '-' + j + '-' + k" class="ml-4 whitespace-pre-wrap">{{ l }}</div>
                        </div>
                        <div v-if="r.note" class="mt-1 whitespace-pre-wrap">メモ：{{ r.note }}</div>
                        <div v-if="r.note2" class="whitespace-pre-wrap">録音確認用メモ：{{ r.note2 }}</div>
                        <div v-if="r.url" class="mt-1">
                          <a :href="r.url" target="_blank" rel="noopener noreferrer" class="text-xs text-blue-700 border-b border-blue-700">稼働管理を開く（この回の期間・この清掃員）</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <InputGroupSubLabel
                  name="dentatsuRequest"
                  caption="デンタツ依頼"
                  class="sm:col-span-full"
                  v-show="isShowCategoryItem('デンタツ')"
                />

                <div class="sm:col-span-full" v-show="isShowCategoryItem('デンタツ')">
                  <DentatsuCategorySelect
                    name="dentatsuCategory"
                    caption="デンタツ詳細カテゴリー"
                    v-model="requestPost.dentatsuCategory"
                    @change="changeDentatsuCate()"
                  />
                </div>

                <!-- デンタツ＆詳細カテゴリー選択済み -->
                <div v-if="isShowCategoryItem('デンタツ')&&requestPost.dentatsuCategory" class="sm:col-span-full">
                  <div v-if="requestPost.dentatsuCategory.includes('再通知')" class="w-full text-red-700 font-bold text-xs">※再通知用のチャットを送信します。</div>

                  <WmsTextInput
                    v-if="requestPost.dentatsuCategory.includes('再通知')"
                    name="chatMessage"
                    caption="チャットに追加したいメッセージがあればご記入ください。"
                    :multiline="true"
                    :rows="3"
                    v-model="requestPost.chatMessage"
                    :disabled="referenceMode"
                    class="mb-3"
                  />

                  <div v-if="requestPost.dentatsuCategory.includes('清掃員（退職）')&&!requestPost._id" class="w-full text-red-700 font-bold text-xs">※新規登録時にサブタスクに遷移します。</div>

                  <DentatsuMail
                    v-if="requestPost.dentatsuCategory.includes('協力会社')"
                    ref="dentatsuMail"
                    :mail="requestPost.mail"
                    :requestPost="requestPost"
                    :referenceMode="referenceMode"
                    :beforeSend="validateBeforeDentatsuMail"
                    @setDentatsuSubject="setDentatsuSubject()"
                    @sendingStart="sendingStart()"
                    @sendmailRes="sendmailRes"
                  />
                </div>

                <div id="estimation-clean-category" class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <EstimationCleanCategorySelect
                    name="estimationCleanCategory"
                    caption="御見積_清掃カテゴリー(複数選択可)"
                    v-model="requestPost.estimationCleanCategory"
                    :disabled="referenceMode"
                  />
                </div>

                <div id="estimation-clean-category" class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <EstimationInspectCategorySelect
                    name="estimationInspectCategory"
                    caption="御見積_点検カテゴリー(複数選択可)"
                    v-model="requestPost.estimationInspectCategory"
                    :disabled="referenceMode"
                  />
                </div>

                <div id="estimation-clean-category" class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <EstimationOtherCategorySelect
                    name="estimationOtherCategory"
                    caption="御見積_その他カテゴリー"
                    v-model="requestPost.estimationOtherCategory"
                    @change="estimationOtherCategoryChanged"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <NewNowFlagSelect
                    name="newNowFlag"
                    caption="契約無/契約有"
                    v-model="requestPost.newNowFlag"
                    :required="true"
                    :error="!validateNewNowFlag.result"
                    :errorMessage="validateNewNowFlag.message"
                    @change="newNowFlagChanged"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <NewClassSelect
                    name="newClass"
                    caption="新規区分"
                    v-model="requestPost.newClass"
                    :required="true"
                    :error="!validateNewClass.result"
                    :errorMessage="validateNewClass.message"
                    :disabled="isDisabledNewClass || referenceMode"
                    @change="newClassChanged"
                  />
                </div>

                <InputGroupLabel
                  name="estimationBasicLabel"
                  caption="見積基本情報"
                  class="mt-4"
                  v-show="isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <!-- <WmsTextInput
                    name="buildingName"
                    caption="建物名"
                    :required="true"
                    v-model="requestPost.buildingName"
                    :error="!validateBuildingName.result"
                    :errorMessage="validateBuildingName.message"
                    @change="siteNameChanged"
                    :disabled="referenceMode"
                  /> -->
                  <WmsSuggestInput
                    name="buildingName"
                    caption="建物名"
                    :required="true"
                    :displayField="['site1', 'site2', 'address1', 'address2', 'agreementFlg']"
                    :selectionItems="buildingListByClient"
                    v-model="requestPost.buildingName"
                    :error="!validateBuildingName.result"
                    :errorMessage="validateBuildingName.message"
                    @selected="siteSelected($event)"
                    @blur="siteNameChanged()"
                    :disabled="referenceMode"
                  >
                    <!-- 検索アイコン -->
                    <template #addon-content>
                      <Icon
                        iconName="Search"
                        :clickable="true"
                        class="w-4 h-4 mr-0.5"
                        @click="openSiteModal()"
                      />
                    </template>
                  </WmsSuggestInput>
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <div v-if="requestPost.siteCode" class="text-xs font-bold text-blue-700">
                    物件コード：{{ requestPost.siteCode }}
                  </div>
                </div>

                <InputGroupLabel
                  name="buildingAddressLabel"
                  caption="所在地"
                  class="mt-4"
                  v-show="isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-3" v-show="isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="postalCode"
                    caption="郵便番号"
                    placeholder="000-0000"
                    v-model="requestPost.postalCode"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3 mt-auto" v-show="isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                  <PrimaryButton text="住所検索" class="w-40 mx-2 bg-green-500" @click="addressSearch()">
                  </PrimaryButton>

                  <PrimaryButton text="住所から取得" class="w-40 bg-green-500" @click="postalCodeSearch()">
                  </PrimaryButton>
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="state"
                    caption="都道府県"
                    placeholder="都道府県"
                    :required="isBuildingDetailsRequired"
                    v-model="requestPost.state"
                    :error="!validateState.result"
                    :errorMessage="validateState.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="city"
                    caption="市区郡"
                    placeholder="市区"
                    :required="isBuildingDetailsRequired"
                    v-model="requestPost.city"
                    :error="!validateCity.result"
                    :errorMessage="validateCity.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="street"
                    caption="町村・番地"
                    placeholder="町村・番地"
                    v-model="requestPost.street"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="building"
                    caption="建物名"
                    placeholder="ビル名"
                    v-model="requestPost.building"
                    @change="buildingChanged"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-2" v-show="isShowCategoryItem('見積依頼')">
                  <NumericTextInput2
                    name="stairs"
                    caption="階数"
                    v-model="requestPost.stairs"
                    :required="isBuildingDetailsRequired"
                    :error="!validateStairs.result"
                    :errorMessage="validateStairs.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-2" v-show="isShowCategoryItem('見積依頼')">
                  <NumericTextInput2
                    name="basement"
                    caption="地下"
                    v-model="requestPost.basement"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-2" v-show="isShowCategoryItem('見積依頼')">
                  <NumericTextInput2
                    name="households"
                    caption="戸数"
                    v-model="requestPost.households"
                    :required="isBuildingDetailsRequired"
                    :error="!validateHouseholds.result"
                    :errorMessage="validateHouseholds.message"
                    @change="houseHoldsChange"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <div v-if="requestPost.householdsNote" class="text-xs text-blue-700 whitespace-pre-line">
                    （物件概要書 世帯数備考）{{ requestPost.householdsNote }}
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="estimationReason"
                    caption="見積理由(新規・業者の切り替え・リプレイスなど)"
                    :multiline="true"
                    :rows="5"
                    v-model="requestPost.estimationReason"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <!-- 過去履歴検索 -->
                  <EstimateHistorySearchBtn
                    :fromMainTask="true"
                    :target="requestPost"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <AvailablePowerFlagSelect
                    name="availablePowerFlag"
                    caption="使用できる電源の有無"
                    v-model="requestPost.availablePowerFlag"
                    :required="isBuildingEquipmentRequired"
                    :error="!validateAvailablePowerFlag.result"
                    :errorMessage="validateAvailablePowerFlag.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <ParkingFlagSelect
                    name="parkingFlag"
                    caption="車の駐車スペースの有無"
                    v-model="requestPost.parkingFlag"
                    :required="isBuildingEquipmentRequired"
                    :error="!validateParkingFlag.result"
                    :errorMessage="validateParkingFlag.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <AvailableToiletFlagSelect
                    name="availableToiletFlag"
                    caption="使用可能なトイレの有無"
                    v-model="requestPost.availableToiletFlag"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼')">
                  <ApartmentTypeSelect
                    name="apartmentType"
                    caption="マンションタイプ"
                    v-model="requestPost.apartmentType"
                    :disabled="referenceMode"
                  />
                </div>

                <InputGroupSubLabel
                  name="estimationRoundLabel"
                  caption="ラウンドサービス"
                  description="※バイク駐車スペースは見積もり作成の必須条件となります。"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('ラウンドサービス') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドサービス') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="roundServiceMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.roundServiceMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドサービス') && isShowCategoryItem('見積依頼') && ((requestPost.households !='' && Number(requestPost.households) > 0) || !this.isBuildingDetailsRequired)">
                  <CleanCountSelect
                    name="cleanCount"
                    caption="清掃希望回数(月〇回、週〇回など)"
                    :required="true"
                    v-model="requestPost.cleanCount"
                    :house="requestPost.households"
                    :error="!validateCleanCount.result"
                    :errorMessage="validateCleanCount.message"
                    :category2="requestPost.category2"
                    @change="changeCleanCountRls(requestPost.cleanCount)"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドサービス') && isShowCategoryItem('見積依頼')">

                  <DustRemovalSelect
                    name="dustRemoval"
                    :caption="dustCaptionRls"
                    :required="true"
                    v-model="requestPost.dustRemoval"
                    :error="!validateDustRemoval.result"
                    :errorMessage="validateDustRemoval.message"
                    :disabled="dustDisabledRls || referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドサービス') && isShowCategoryItem('見積依頼') && requestPost.dustRemoval && requestPost.dustRemoval[0]=='有'">
                  <DustCountSelect
                    name="dustCount"
                    caption="ゴミ搬出希望回数"
                    :required="true"
                    v-model="requestPost.dustCount"
                    :error="!validateDustCount.result"
                    :errorMessage="validateDustCount.message"
                    :category2="requestPost.category2"
                    :cleanCount="requestPost.cleanCount"
                    @change="changeCleanCountRls(requestPost.cleanCount)"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドサービス') && isShowCategoryItem('見積依頼')">
                  <ToiletCleaningSelect
                    name="toiletCleaning"
                    caption="有料トイレ清掃あり/有料トイレ清掃無し"
                    v-model="requestPost.rlsToiletCleaning"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3" v-show="isShowCategoryItem('見積依頼') && isShowtToilet(requestPost.rlsToiletCleaning, '有料トイレ清掃あり') && isShowEstimationCleanCategoryItem('ラウンドサービス')">
                  <NumericTextInput2
                    name="toiletTimes"
                    caption="有料トイレ清掃回数（回/週）"
                    placeholder="4"
                    v-model="requestPost.rlsToiletTimes"
                    :required="true"
                    :error="!validateRlsToiletTimes.result"
                    :errorMessage="validateRlsToiletTimes.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3" v-show="isShowCategoryItem('見積依頼') && isShowtToilet(requestPost.rlsToiletCleaning, '有料トイレ清掃あり') && isShowEstimationCleanCategoryItem('ラウンドサービス')">
                  <NumericTextInput2
                    name="toiletPlace"
                    caption="有料トイレ清掃箇所数"
                    v-model="requestPost.rlsToiletPlace"
                    :required="true"
                    :error="!validateRlsToiletPlace.result"
                    :errorMessage="validateRlsToiletPlace.message"
                    :disabled="referenceMode"
                  />
                </div>

                <InputGroupSubLabel
                  name="estimationRoundPlusLabel"
                  caption="ラウンドプラス"
                  description="※バイク駐車スペースは見積もり作成の必須条件となります。"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('ラウンドプラス') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドプラス') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="roundPlusMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.roundPlusMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドプラス') && isShowCategoryItem('見積依頼') && ((requestPost.households !='' && Number(requestPost.households) > 0) || !this.isBuildingDetailsRequired)">
                  <CleanCountSelect
                    name="plusCleanCount"
                    caption="清掃希望回数(月〇回、週〇回など)"
                    :required="true"
                    v-model="requestPost.plusCleanCount"
                    :house="requestPost.households"
                    :error="!validatePlusCleanCount.result"
                    :errorMessage="validatePlusCleanCount.message"
                    :category2="requestPost.category2"
                    @change="changeCleanCountPlus(requestPost.plusCleanCount)"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドプラス') && isShowCategoryItem('見積依頼')">
                  <PlusDustRemovalSelect
                    name="plusDustRemoval"
                    :caption="dustCaptionPlus"
                    :required="true"
                    v-model="requestPost.plusDustRemoval"
                    :error="!validatePlusDustRemoval.result"
                    :errorMessage="validatePlusDustRemoval.message"
                    :disabled="dustDisabledPlus || referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドプラス') && isShowCategoryItem('見積依頼') && requestPost.plusDustRemoval && requestPost.plusDustRemoval[0]=='有'">
                  <DustCountSelect
                    name="plusDustCount"
                    caption="ゴミ搬出希望回数"
                    :required="true"
                    v-model="requestPost.plusDustCount"
                    :error="!validatePlusDustCount.result"
                    :errorMessage="validatePlusDustCount.message"
                    :category2="requestPost.category2"
                    :cleanCount="requestPost.plusCleanCount"
                    @change="changeCleanCountPlus(requestPost.plusCleanCount)"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ラウンドプラス') && isShowCategoryItem('見積依頼')">
                  <ToiletCleaningSelect
                    name="toiletCleaning"
                    caption="巡回清掃"
                    v-model="requestPost.plusToiletCleaning"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3" v-show="isShowCategoryItem('見積依頼') && isShowtToilet(requestPost.plusToiletCleaning, '有料トイレ清掃あり') && isShowEstimationCleanCategoryItem('ラウンドプラス')">
                  <NumericTextInput2
                    name="toiletTimes"
                    caption="有料トイレ清掃回数（回/週）（巡回清掃）"
                    placeholder="4"
                    v-model="requestPost.plusToiletTimes"
                    :required="true"
                    :error="!validatePlusToiletTimes.result"
                    :errorMessage="validatePlusToiletTimes.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3" v-show="isShowCategoryItem('見積依頼') && isShowtToilet(requestPost.plusToiletCleaning, '有料トイレ清掃あり') && isShowEstimationCleanCategoryItem('ラウンドプラス')">
                  <NumericTextInput2
                    name="toiletPlace"
                    caption="有料トイレ清掃箇所数（巡回清掃）"
                    v-model="requestPost.plusToiletPlace"
                    :required="true"
                    :error="!validatePlusToiletPlace.result"
                    :errorMessage="validatePlusToiletPlace.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full mt-3" v-show="isShowEstimationCleanCategoryItem('ラウンドプラス') && isShowCategoryItem('見積依頼')">
                  <ToiletCleaningSelect
                    name="plusToiletCleaningNormal"
                    caption="固定清掃"
                    v-model="requestPost.plusToiletCleaningNormal"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3" v-show="isShowCategoryItem('見積依頼') && isShowtToilet(requestPost.plusToiletCleaningNormal, '有料トイレ清掃あり') && isShowEstimationCleanCategoryItem('ラウンドプラス')">
                  <NumericTextInput2
                    name="plusToiletTimesNormal"
                    caption="有料トイレ清掃回数（回/週）（固定清掃）"
                    placeholder="4"
                    v-model="requestPost.plusToiletTimesNormal"
                    :required="true"
                    :error="!validatePlusToiletTimesNormal.result"
                    :errorMessage="validatePlusToiletTimesNormal.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3" v-show="isShowCategoryItem('見積依頼') && isShowtToilet(requestPost.plusToiletCleaningNormal, '有料トイレ清掃あり') && isShowEstimationCleanCategoryItem('ラウンドプラス')">
                  <NumericTextInput2
                    name="plusToiletPlaceNormal"
                    caption="有料トイレ清掃箇所数（固定清掃）"
                    v-model="requestPost.plusToiletPlaceNormal"
                    :required="true"
                    :error="!validatePlusToiletPlaceNormal.result"
                    :errorMessage="validatePlusToiletPlaceNormal.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowCategoryItem('見積依頼') && (isShowEstimationCleanCategoryItem('ラウンドサービス') || isShowEstimationCleanCategoryItem('ラウンドプラス') || isShowEstimationCleanCategoryItem('ラウンドサブメニュー'))">
                  <ResidenceTypeSelect
                    name="residenceType"
                    caption="ファミリー/シングル"
                    v-model="requestPost.residenceType"
                    :disabled="referenceMode"
                  />
                </div>

                <InputGroupSubLabel
                  name="estimationEverydayLabel"
                  caption="日常清掃"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="everydayCleanMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.everydayCleanMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full">
                  <div v-for="(everydayClean, index) in requestPost.everydayCleans" v-bind:key="everydayClean.id">
                    <div class="mt-3" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')">
                      <label
                        name="everydayCleanLabel"
                        class="text-sm font-bold"
                      >
                        日常清掃{{ outputIndex(index) }}
                      </label>
                    </div>

                    <div class="flex mt-ec">
                      <div class="everydayCleanCount" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')">
                        <NumericTextInput2
                          name="everydayCleanCount"
                          caption="清掃希望回数（週〇回）"
                          placeholder="3"
                          :decimalPlace="deci"
                          :required="true"
                          v-model="everydayClean.everydayCleanCount"
                          :error="!validateEverydayCleanCount(index).result"
                          :errorMessage="validateEverydayCleanCount(index).message"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="everydayCleanHours" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')">
                        <NumericTextInput2
                          name="everydayCleanHours"
                          caption="清掃希望時間（〇時間）"
                          placeholder="2"
                          :decimalPlace="deci"
                          :required="true"
                          v-model="everydayClean.everydayCleanHours"
                          :error="!validateEverydayCleanHours(index).result"
                          :errorMessage="validateEverydayCleanHours(index).message"
                          :disabled="referenceMode"
                        />
                      </div>
                    </div>

                    <div class="sm:col-span-full mt-ec" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')">
                      <EverydayStartTimeFlagSelect
                        name="everydayStartTimeFlag"
                        caption="作業時間の指定の有無(開始時間は7:30から)"
                        :required="true"
                        v-model="everydayClean.everydayStartTimeFlag"
                        :error="!validateEverydayStartTimeFlag(index).result"
                        :errorMessage="validateEverydayStartTimeFlag(index).message"
                        :disabled="referenceMode"
                      />
                    </div>

                    <div class="flex mt-ec">
                      <div class="everydayStartTime" v-show="isShowEverydayStartTimeFlagItem('有', index) && isShowCategoryItem('見積依頼') && isShowEstimationCleanCategoryItem('日常清掃')">
                        <WmsTimeInput2
                          name="everydayStartTime"
                          caption="指定作業開始時間"
                          :clearable="true"
                          :required="true"
                          v-model="everydayClean.everydayStartTime"
                          :error="!validateEverydayStartTime(index).result"
                          :errorMessage="validateEverydayStartTime(index).message"
                          :hourItems="hourItems"
                          :minuteItems="minuteItems"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="everydayEndTime" v-show="isShowEverydayStartTimeFlagItem('有', index) && isShowCategoryItem('見積依頼') && isShowEstimationCleanCategoryItem('日常清掃')">
                        <WmsTimeInput2
                          name="everydayEndTime"
                          caption="指定作業終了時間"
                          :clearable="true"
                          v-model="everydayClean.everydayEndTime"
                          :hourItems="hourItems"
                          :minuteItems="minuteItems"
                          :disabled="referenceMode"
                        />
                      </div>
                    </div>

                    <div class="sm:col-span-full mt-ec" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')">
                      <EverydayHolidayFlagSelect
                        name="everydayHolidayFlag"
                        caption="祝日対応の有無"
                        v-model="everydayClean.everydayHolidayFlag"
                        :disabled="referenceMode"
                      />
                    </div>

                    <div class="sm:col-span-full mt-ec" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼') && isEverydayHolidayFlag(index)">
                      <EverydayHolidaySelect
                        name="everydayHoliday"
                        caption="祝日対応"
                        v-model="everydayClean.everydayHoliday"
                        :disabled="referenceMode"
                      />
                    </div>

                    <div class="sm:col-span-full mt-ec" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')">
                      <ToiletCleaningSelect
                        name="toiletCleaning"
                        caption="有料トイレ清掃あり/有料トイレ清掃無し"
                        v-model="everydayClean.toiletCleaning"
                        :disabled="referenceMode"
                      />
                    </div>

                    <div class="flex mt-ec">
                      <div class="toiletTimes" v-show="isShowCategoryItem('見積依頼') && isShowtToiletCleaningItem('有料トイレ清掃あり', index) && isShowEstimationCleanCategoryItem('日常清掃')">
                        <NumericTextInput2
                          name="toiletTimes"
                          caption="有料トイレ清掃回数（回/週）"
                          placeholder="4"
                          v-model="everydayClean.toiletTimes"
                          :required="true"
                          :error="!validateToiletTimes(index).result"
                          :errorMessage="validateToiletTimes(index).message"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="toiletPlace" v-show="isShowCategoryItem('見積依頼') && isShowtToiletCleaningItem('有料トイレ清掃あり', index) && isShowEstimationCleanCategoryItem('日常清掃')">
                        <NumericTextInput2
                          name="toiletPlace"
                          caption="有料トイレ清掃箇所数"
                          v-model="everydayClean.toiletPlace"
                          :required="true"
                          :error="!validateToiletPlace(index).result"
                          :errorMessage="validateToiletPlace(index).message"
                          :disabled="referenceMode"
                        />
                      </div>
                    </div>

                    <div class="everydayCleanDeleteButton" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                      <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeEverydayClean(index)">
                        <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                      </PrimaryButton>
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full addButton-contents" v-show="isShowEstimationCleanCategoryItem('日常清掃') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                  <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'日常清掃追加'" @click="addEverydayClean">
                    <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                  </PrimaryButton>
                </div>

                <InputGroupSubLabel
                  name="managerWorkLabel"
                  caption="管理員業務"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="managerWorkMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.managerWorkMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full">
                  <div v-for="(managerWork, index) in requestPost.managerWorks" v-bind:key="managerWork.id">
                    <div class="mt-3" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                      <label
                        name="managerWorkLabel"
                        class="text-sm font-bold"
                      >
                        管理員業務{{ outputIndex(index) }}
                      </label>
                    </div>

                    <div class="flex mt-mw">
                      <div class="managerWorkCount" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                        <NumericTextInput2
                          name="managerWorkCount"
                          caption="清掃希望回数（週〇回）"
                          placeholder="3"
                          :required="true"
                          :decimalPlace="deci"
                          v-model="managerWork.managerWorkCount"
                          :error="!validateManagerWorkCount(index).result"
                          :errorMessage="validateManagerWorkCount(index).message"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="managerWorkHours" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                        <NumericTextInput2
                          name="managerWorkHours"
                          caption="清掃希望時間（〇時間）"
                          placeholder="2"
                          :decimalPlace="deci"
                          :required="true"
                          v-model="managerWork.managerWorkHours"
                          :error="!validateManagerWorkHours(index).result"
                          :errorMessage="validateManagerWorkHours(index).message"
                          :disabled="referenceMode"
                        />
                      </div>
                    </div>

                    <div class="sm:col-span-full mt-mw" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                      <ManagerWorkTimeFlagSelect
                        name="managerWorkTimeFlag"
                        caption="作業時間の指定の有無(開始時間は7:30から)"
                        :required="true"
                        v-model="managerWork.managerWorkTimeFlag"
                        :error="!validateManagerWorkTimeFlag(index).result"
                        :errorMessage="validateManagerWorkTimeFlag(index).message"
                        :disabled="referenceMode"
                      />
                    </div>

                    <div class="flex mt-mw">
                      <div class="managerWorkTime" v-show="isShowManagerWorkTimeFlagItem('有', index) && isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                        <WmsTimeInput2
                          name="managerWorkTime"
                          caption="指定作業開始時間"
                          :clearable="true"
                          :required="true"
                          v-model="managerWork.managerWorkTime"
                          :error="!validateManagerWorkTime(index).result"
                          :errorMessage="validateManagerWorkTime(index).message"
                          :hourItems="hourItems"
                          :minuteItems="minuteItems"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="managerWorkEndTime" v-show="isShowManagerWorkTimeFlagItem('有', index) && isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                        <WmsTimeInput2
                          name="managerWorkEndTime"
                          caption="指定作業終了時間"
                          :clearable="true"
                          v-model="managerWork.managerWorkEndTime"
                          :hourItems="hourItems"
                          :minuteItems="minuteItems"
                          :disabled="referenceMode"
                        />
                      </div>
                    </div>

                    <div class="sm:col-span-full mt-mw" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')">
                      <ManagerWorkHolidayFlagSelect
                        name="managerWorkHolidayFlag"
                        caption="祝日対応の有無"
                        v-model="managerWork.managerWorkHolidayFlag"
                        :disabled="referenceMode"
                      />
                    </div>

                    <div class="sm:col-span-full mt-mw" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼') && isManagerWorkHolidayFlag(index)">
                      <ManagerWorkHolidaySelect
                        name="managerWorkHoliday"
                        caption="祝日対応"
                        v-model="managerWork.managerWorkHoliday"
                        :disabled="referenceMode"
                      />
                    </div>

                    <div class="managerWorkDeleteButton" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                      <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeManagerWork(index)">
                        <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                      </PrimaryButton>
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full addButton-contents" v-show="isShowEstimationCleanCategoryItem('管理員業務') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                  <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'管理員業務追加'" @click="addManagerWork">
                    <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                  </PrimaryButton>
                </div>

                <InputGroupSubLabel
                  name="regularCleanLabel"
                  caption="定期清掃"
                  description="※水栓の使用は見積もり作成の必須条件となります。"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="regularCleanMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.regularCleanMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full">
                  <div v-for="(regularClean, index) in requestPost.regularCleans" v-bind:key="regularClean.id">
                    <div class="mt-3" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                      <label
                        name="regularCleanLabel"
                        class="text-sm font-bold"
                      >
                        定期清掃{{ outputIndex(index) }}
                      </label>
                    </div>

                    <div class="flex">
                      <div class="mw-60 mt-1" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                        <WmsSuggestInput
                          name="regularCleanContent"
                          caption="依頼内容"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="regItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateRegularClean(index, 'regularCleanContent').result"
                          :errorMessage="validateRegularClean(index, 'regularCleanContent').message"
                          v-model="regularClean.regularCleanContent"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="mt-1" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                        <NumericTextInput2
                          name="regularCleanCount"
                          caption="希望回数"
                          :required="true"
                          v-model="regularClean.regularCleanCount"
                          :error="!validateRegularClean(index, 'regularCleanCount').result"
                          :errorMessage="validateRegularClean(index, 'regularCleanCount').message"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="mt-1" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                        <WmsSuggestInput
                          name="regularCleanUnitName"
                          caption="単位"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="unitNameItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateRegularClean(index, 'regularCleanUnitName').result"
                          :errorMessage="validateRegularClean(index, 'regularCleanUnitName').message"
                          v-model="regularClean.regularCleanUnitName"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="regularCleanDeleteButton" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                        <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeRegularClean(index)">
                          <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full addButton-contents" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                  <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'定期清掃追加'" @click="addRegularClean">
                    <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                  </PrimaryButton>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    図面(定期平面)
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="regularCleanImage"
                        caption="図面(定期平面)"
                        :value="requestPost.regularCleanImage"
                        style="max-width: none!important;"
                        @change="attachmentChange('regularCleanImage', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    図面(定期平面)2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="regularCleanImage2"
                        caption="図面(定期平面)2"
                        :value="requestPost.regularCleanImage2"
                        style="max-width: none!important;"
                        @change="attachmentChange('regularCleanImage2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    図面(定期平面)3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="regularCleanImage3"
                        caption="図面(定期平面)3"
                        :value="requestPost.regularCleanImage3"
                        style="max-width: none!important;"
                        @change="attachmentChange('regularCleanImage3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('定期清掃') && isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="regularCleanWorkWay"
                    caption="作業仕様"
                    v-model="requestPost.regularCleanWorkWay"
                    :disabled="referenceMode"
                  />
                </div>

                <InputGroupSubLabel
                  name="glassCleanLabel"
                  caption="ガラス清掃"
                  description="※水栓の使用は見積もり作成の必須条件となります。"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('ガラス清掃') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ガラス清掃') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="glassCleanMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.glassCleanMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ガラス清掃') && isShowCategoryItem('見積依頼')">
                  <NumericTextInput2
                    name="glassCleanCount"
                    caption="清掃希望回数"
                    :required="true"
                    v-model="requestPost.glassCleanCount"
                    :error="!validateGlassCleanCount.result"
                    :errorMessage="validateGlassCleanCount.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ガラス清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    図面(ガラス立面)
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="glassCleanImage"
                        caption="図面(ガラス立面)"
                        :value="requestPost.glassCleanImage"
                        style="max-width: none!important;"
                        @change="attachmentChange('glassCleanImage', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ガラス清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    図面(ガラス立面)2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="glassCleanImage2"
                        caption="図面(ガラス立面)2"
                        :value="requestPost.glassCleanImage2"
                        style="max-width: none!important;"
                        @change="attachmentChange('glassCleanImage2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ガラス清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    図面(ガラス立面)3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="glassCleanImage3"
                        caption="図面(ガラス立面)3"
                        :value="requestPost.glassCleanImage3"
                        style="max-width: none!important;"
                        @change="attachmentChange('glassCleanImage3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('ガラス清掃') && isShowCategoryItem('見積依頼')">
                  <GlassCleanWorkWaySelect
                    name="glassCleanWorkWay"
                    caption="作業仕様"
                    v-model="requestPost.glassCleanWorkWay"
                    :disabled="referenceMode"
                  />
                </div>

                <InputGroupSubLabel
                  name="estimationDorainPipeLabel"
                  caption="排水管清掃"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('排水管清掃') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('排水管清掃') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="estimationDorainPipeMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.estimationDorainPipeMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <InputGroupSubLabel
                  name="estimationWaterTankLabel"
                  caption="貯水槽清掃"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('貯水槽清掃') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('貯水槽清掃') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="estimationWaterTankMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.estimationWaterTankMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <InputGroupSubLabel
                  name="plantingLabel"
                  caption="植栽剪定"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="plantingMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.plantingMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <NumericTextInput2
                    name="plantingCount"
                    caption="希望回数"
                    :required="true"
                    v-model="requestPost.plantingCount"
                    :error="!validatePlantingCount.result"
                    :errorMessage="validatePlantingCount.message"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    対象箇所
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="plantingPlaceFile"
                        caption="対象箇所"
                        :value="requestPost.plantingPlaceFile"
                        style="max-width: none!important;"
                        @change="attachmentChange('plantingPlaceFile', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    対象箇所2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="plantingPlaceFile2"
                        caption="対象箇所2"
                        :value="requestPost.plantingPlaceFile2"
                        style="max-width: none!important;"
                        @change="attachmentChange('plantingPlaceFile2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    対象箇所3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="plantingPlaceFile3"
                        caption="対象箇所3"
                        :value="requestPost.plantingPlaceFile3"
                        style="max-width: none!important;"
                        @change="attachmentChange('plantingPlaceFile3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="plantingReportFile"
                        caption="過去の報告書"
                        :value="requestPost.plantingReportFile"
                        style="max-width: none!important;"
                        @change="attachmentChange('plantingReportFile', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="plantingReportFile2"
                        caption="過去の報告書2"
                        :value="requestPost.plantingReportFile2"
                        style="max-width: none!important;"
                        @change="attachmentChange('plantingReportFile2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('植栽剪定') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="plantingReportFile3"
                        caption="過去の報告書3"
                        :value="requestPost.plantingReportFile3"
                        style="max-width: none!important;"
                        @change="attachmentChange('plantingReportFile3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <InputGroupSubLabel
                  name="specialCleanLabel"
                  caption="特別清掃"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="specialCleanMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.specialCleanMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <div class="sm:col-span-full">
                  <div v-for="(specialClean, index) in requestPost.specialCleans" v-bind:key="specialClean.id">
                    <div class="mt-3" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                      <label
                        :name="'specialCleanLabel'+index"
                        class="text-sm font-bold"
                      >
                        特別清掃{{ outputIndex(index) }}
                      </label>
                    </div>

                    <div class="flex">
                      <div class="mw-60 mt-1" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                        <WmsSuggestInput
                          name="specialCleanContent"
                          caption="依頼内容 ※駐輪場清掃、照明器具清掃など"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="spItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateSpecialCleanContent(index).result"
                          :errorMessage="validateSpecialCleanContent(index).message"
                          v-model="specialClean.specialCleanContent"
                          @selected="selectedSp(index, $event)"
                          @change="changeSp(index)"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="mt-1" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                        <NumericTextInput2
                          name="specialCleanCount"
                          caption="希望回数"
                          :required="true"
                          v-model="specialClean.specialCleanCount"
                          :error="!validateSpecialCleanCount(index).result"
                          :errorMessage="validateSpecialCleanCount(index).message"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="mt-1" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                        <WmsSuggestInput
                          name="specialCleanUnitName"
                          caption="単位"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="unitNameItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateSpecialCleanUnitName(index).result"
                          :errorMessage="validateSpecialCleanUnitName(index).message"
                          v-model="specialClean.specialCleanUnitName"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="specialCleanDeleteButton" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                        <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeSpecialClean(index)">
                          <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full addButton-contents" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                  <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'特別清掃追加'" @click="addSpecialClean">
                    <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                  </PrimaryButton>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    添付資料 図面(平面図)・写真
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="specialCleanImage"
                        caption="添付資料 図面(平面図)・写真"
                        :value="requestPost.specialCleanImage"
                        style="max-width: none!important;"
                        @change="attachmentChange('specialCleanImage', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    添付資料 図面(平面図)・写真2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="specialCleanImage2"
                        caption="添付資料 図面(平面図)・写真2"
                        :value="requestPost.specialCleanImage2"
                        style="max-width: none!important;"
                        @change="attachmentChange('specialCleanImage2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('特別清掃') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    添付資料 図面(平面図)・写真3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="specialCleanImage3"
                        caption="添付資料 図面(平面図)・写真3"
                        :value="requestPost.specialCleanImage3"
                        style="max-width: none!important;"
                        @change="attachmentChange('specialCleanImage3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <InputGroupSubLabel
                  name="roundSubLabel"
                  caption="ラウンドサブメニュー"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('ラウンドサブメニュー') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-if="isShowEstimationCleanCategoryItem('ラウンドサブメニュー') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="roundSubMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.roundSubMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>

                  <div v-for="(rs, index) in requestPost.roundSubs" v-bind:key="rs.id">
                    <div class="mt-3">
                      <label
                        name="roundSubs"
                        class="text-sm font-bold"
                      >
                        ラウンドサブメニュー{{ outputIndex(index) }}
                      </label>
                    </div>

                    <div class="flex mt-1">
                      <div class="mw-60">
                        <WmsSuggestInput
                          name="roundSubContent"
                          caption="依頼内容"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="rsItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateRoundSub(index, 'roundSubContent').result"
                          :errorMessage="validateRoundSub(index, 'roundSubContent').message"
                          v-model="rs.roundSubContent"
                          :disabled="referenceMode"
                        />
                      </div>

                      <!-- ラウンドトラッシュの場合、ゴミ出し回数選択 -->
                      <div v-if="rs.roundSubContent=='ラウンドトラッシュ'" class="mx-1">
                        <label class="block text-xs font-bold text-gray-700 mb-1">
                          ゴミ出し回数
                        </label>
                        <select
                          v-model="rs.trash"
                          class="border-gray-300 rounded py-1"
                          :class="referenceMode?'bg-gray-200':''"
                          :disabled="referenceMode"
                        >
                          <option v-for="(rt, i) in rlsTrashList"
                            :key="'rt' + i"
                            :value="rt.key"
                          >
                            {{ rt.val }}
                          </option>
                        </select>
                      </div>

                      <div v-else class="flex">
                        <NumericTextInput2
                          name="roundSubCount"
                          caption="希望回数"
                          :required="true"
                          v-model="rs.roundSubCount"
                          :error="!validateRoundSub(index, 'roundSubCount').result"
                          :errorMessage="validateRoundSub(index, 'roundSubCount').message"
                          :disabled="referenceMode"
                        />
                        <WmsSuggestInput
                          name="roundSubUnitName"
                          caption="単位"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="unitNameItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateRoundSub(index, 'roundSubUnitName').result"
                          :errorMessage="validateRoundSub(index, 'roundSubUnitName').message"
                          v-model="rs.roundSubUnitName"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="regularCleanDeleteButton" v-if="!referenceMode">
                        <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeRoundSub(index)">
                          <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>

                  <div class="addButton-contents mt-2" v-if="!referenceMode">
                    <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'ラウンドサブメニュー追加'" @click="addRoundSub()">
                      <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                    </PrimaryButton>
                  </div>
                </div>

                <InputGroupSubLabel
                  name="estimationMRSabel"
                  caption="MRS"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationCleanCategoryItem('マンションローテーションサービス（MRS）') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationCleanCategoryItem('マンションローテーションサービス（MRS）') && isShowCategoryItem('見積依頼')">
                  <vsa-list>
                    <vsa-item>
                      <vsa-heading>
                        メモ
                      </vsa-heading>

                      <vsa-icon>
                        <span>∨</span>
                      </vsa-icon>

                      <vsa-content>
                        <WmsTextInput
                          name="estimationMRSMemo"
                          :multiline="true"
                          :rows="4"
                          v-model="requestPost.estimationMRSMemo"
                          :disabled="referenceMode"
                        />
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>

                <InputGroupSubLabel
                  name="fireInspectLabel"
                  caption="消防設備点検"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationInspectCategoryItem('消防設備点検') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('消防設備点検') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="fireInspectReport"
                        caption="過去の報告書"
                        :value="requestPost.fireInspectReport"
                        style="max-width: none!important;"
                        @change="attachmentChange('fireInspectReport', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('消防設備点検') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="fireInspectReport2"
                        caption="過去の報告書2"
                        :value="requestPost.fireInspectReport2"
                        style="max-width: none!important;"
                        @change="attachmentChange('fireInspectReport2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('消防設備点検') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="fireInspectReport3"
                        caption="過去の報告書3"
                        :value="requestPost.fireInspectReport3"
                        style="max-width: none!important;"
                        @change="attachmentChange('fireInspectReport3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <InputGroupSubLabel
                  name="constructionEquipmentInspectLabel"
                  caption="建築設備定期検査"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationInspectCategoryItem('建築設備定期検査') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('建築設備定期検査') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    各階の平面図及び面積表及び確認済証
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="constructionEquipmentInspectReport"
                        caption="各階の平面図及び面積表及び確認済証"
                        :value="requestPost.constructionEquipmentInspectReport"
                        style="max-width: none!important;"
                        @change="attachmentChange('constructionEquipmentInspectReport', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('建築設備定期検査') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    各階の平面図及び面積表及び確認済証2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="constructionEquipmentInspectReport2"
                        caption="各階の平面図及び面積表及び確認済証2"
                        :value="requestPost.constructionEquipmentInspectReport2"
                        style="max-width: none!important;"
                        @change="attachmentChange('constructionEquipmentInspectReport2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('建築設備定期検査') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    各階の平面図及び面積表及び確認済証3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="constructionEquipmentInspectReport3"
                        caption="各階の平面図及び面積表及び確認済証3"
                        :value="requestPost.constructionEquipmentInspectReport3"
                        style="max-width: none!important;"
                        @change="attachmentChange('constructionEquipmentInspectReport3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <InputGroupSubLabel
                  name="specificInspectLabel"
                  caption="特定建築物定期調査"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationInspectCategoryItem('特定建築物定期調査') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('特定建築物定期調査') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    各階の平面図及び面積表及び確認済証
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="specificInspectReport"
                        caption="各階の平面図及び面積表及び確認済証"
                        :value="requestPost.specificInspectReport"
                        style="max-width: none!important;"
                        @change="attachmentChange('specificInspectReport', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('特定建築物定期調査') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    各階の平面図及び面積表及び確認済証2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="specificInspectReport2"
                        caption="各階の平面図及び面積表及び確認済証2"
                        :value="requestPost.specificInspectReport2"
                        style="max-width: none!important;"
                        @change="attachmentChange('specificInspectReport2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('特定建築物定期調査') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    各階の平面図及び面積表及び確認済証3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="specificInspectReport3"
                        caption="各階の平面図及び面積表及び確認済証3"
                        :value="requestPost.specificInspectReport3"
                        style="max-width: none!important;"
                        @change="attachmentChange('specificInspectReport3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <InputGroupSubLabel
                  name="evInspectLabel"
                  caption="エレベーター保守点検"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <EvInspectContentSelect
                    name="evInspectContent"
                    caption="点検内容"
                    v-model="requestPost.evInspectContent"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-3" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <WmsSuggestInput
                    name="evQty"
                    caption="回数"
                    :dynamic="false"
                    :incrementalSearch="false"
                    :selectionItems="evQtyItems"
                    displayField="text"
                    :filter="{}"
                    :clearable="true"
                    v-model="requestPost.evQty"
                    :disabled="referenceMode"
                    />
                </div>

                <div class="sm:col-span-3" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <WmsSuggestInput
                    name="evUnitName"
                    caption="単位"
                    :dynamic="false"
                    :incrementalSearch="false"
                    :selectionItems="evUnitNameItems"
                    displayField="text"
                    :filter="{}"
                    :clearable="true"
                    v-model="requestPost.evUnitName"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="evInspectFile"
                        caption="過去の報告書"
                        :value="requestPost.evInspectFile"
                        style="max-width: none!important;"
                        @change="attachmentChange('evInspectFile', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書2
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="evInspectFile2"
                        caption="過去の報告書2"
                        :value="requestPost.evInspectFile2"
                        style="max-width: none!important;"
                        @change="attachmentChange('evInspectFile2', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <label class="block text-xs font-bold text-gray-700">
                    過去の報告書3
                  </label>
                  <div class="mt-1">
                    <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
                      <WmsAttachment
                        name="evInspectFile3"
                        caption="過去の報告書3"
                        :value="requestPost.evInspectFile3"
                        style="max-width: none!important;"
                        @change="attachmentChange('evInspectFile3', $event)"
                        :disabled="referenceMode"
                      />
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="evInspectMaker"
                    caption="メーカー"
                    v-model="requestPost.evInspectMaker"
                    :disabled="referenceMode"
                  />
                </div>

                <div class="sm:col-span-full" v-show="isShowEstimationInspectCategoryItem('エレベーター保守点検') && isShowCategoryItem('見積依頼')">
                  <WmsTextInput
                    name="evInspectMakeYear"
                    caption="製造年"
                    v-model="requestPost.evInspectMakeYear"
                    :disabled="referenceMode"
                  />
                </div>

                <InputGroupSubLabel
                  name="otherWorkLabel"
                  caption="その他作業"
                  class="mt-4 sm:col-span-full"
                  v-show="isShowEstimationOtherCategoryItem('その他作業') && isShowCategoryItem('見積依頼')"
                />

                <div class="sm:col-span-full">
                  <div v-for="(otherWork, index) in requestPost.otherWorks" v-bind:key="otherWork.id">
                    <div class="mt-3" v-show="isShowEstimationOtherCategoryItem('その他作業') && isShowCategoryItem('見積依頼')">
                      <label
                        name="otherWorkLabel"
                        class="text-sm font-bold"
                      >
                        その他作業{{ outputIndex(index) }}
                      </label>
                    </div>

                    <div class="flex">
                      <div class="mw-60 mt-1" v-show="isShowEstimationOtherCategoryItem('その他作業') && isShowCategoryItem('見積依頼')">
                        <WmsSuggestInput
                          name="otherWorkContent"
                          caption="依頼内容"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="otherWorkItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateOtherWorkContent(index).result"
                          :errorMessage="validateOtherWorkContent(index).message"
                          v-model="otherWork.otherWorkContent"
                          :disabled="referenceMode"
                          @selected="selectedOtherWork(index, $event)"
                        />
                      </div>

                      <div class="mt-1" v-show="isShowEstimationOtherCategoryItem('その他作業') && isShowCategoryItem('見積依頼')">
                        <NumericTextInput2
                          name="otherWorkCount"
                          caption="希望回数"
                          :required="true"
                          v-model="otherWork.otherWorkCount"
                          :error="!validateOtherWorkCount(index).result"
                          :errorMessage="validateOtherWorkCount(index).message"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="mt-1" v-show="isShowEstimationOtherCategoryItem('その他作業') && isShowCategoryItem('見積依頼')">
                        <WmsSuggestInput
                          name="otherWorkUnitName"
                          caption="単位"
                          :dynamic="false"
                          :incrementalSearch="false"
                          :required="true"
                          :selectionItems="unitNameItems"
                          displayField="text"
                          :filter="{}"
                          :clearable="true"
                          :error="!validateOtherWorkUnitName(index).result"
                          :errorMessage="validateOtherWorkUnitName(index).message"
                          v-model="otherWork.otherWorkUnitName"
                          :disabled="referenceMode"
                        />
                      </div>

                      <div class="specialCleanDeleteButton" v-show="isShowEstimationOtherCategoryItem('その他作業') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                        <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeOtherWork(index)">
                          <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="sm:col-span-full addButton-contents" v-show="isShowEstimationOtherCategoryItem('その他作業') && isShowCategoryItem('見積依頼')" v-if="!referenceMode">
                  <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'その他作業追加'" @click="addOtherWork">
                    <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                  </PrimaryButton>
                </div>
              </div>

              <!-- 雇い入れ -->
              <EmploymentComponents
                ref="EmploymentComponents"
                v-if="isShowCategoryItem('雇い入れ') || isShowCategoryItem('雇い入れ（社員）') || (isShowCategoryItem('雇い入れ（清掃員）') && !requestPost.dcNew && !requestPost.dcNew2)"
                :requestPost="requestPost"
                :referenceMode="referenceMode"
                :clientLists="clientLists"
                :departmentLists="toDepartmentList"
                @get-title2="getTitle2"
                @newEnterForCD="selectInterviewsForEmployment=true"
              />

              <!-- スマイル移行後の最新清掃員雇い入れ -->
              <EmploymentDCNewComponents
                ref="EmploymentDCNewComponents"
                v-else-if="isShowCategoryItem('雇い入れ（清掃員）') && requestPost.dcNew2"
                :requestPost="requestPost"
                :referenceMode="referenceMode"
                :referenceMode2="referenceMode||requestPost.akbsSaved"
                @get-title2="getTitle2"
                @loadingStart="isSaving=true"
                @loadingEnd="isSaving=false"
              />

              <!-- スマイル移行前の清掃員雇い入れ -->
              <EmploymentDCComponents
                ref="EmploymentDCComponents"
                v-else-if="isShowCategoryItem('雇い入れ（清掃員）')"
                :requestPost="requestPost"
                :referenceMode="referenceMode"
                :referenceMode2="referenceMode||requestPost.akbsSaved"
                :clientLists="clientLists"
                :departmentLists="toDepartmentList"
                @get-title2="getTitle2"
                @newEnterForCD="selectInterviewsForEmployment=true"
                @loadingStart="isSaving=true"
                @loadingEnd="isSaving=false"
              />

              <!-- 面接関連（中途社員、もしくは過去の清掃員コンポーネント） -->
              <InterviewsComponents
                ref="InterviewsComponents"
                v-if="isShowCategoryItem('面接関連')&&!requestPost.newGrad&&(requestPost.interviewsRegularStaff || (!requestPost.dcNew && !requestPost.dcNew2))"
                :requestPost="requestPost"
                :referenceMode="referenceMode"
                :departmentLists="toDepartmentList"
                :mainValidation="validation"
                @get-title="getTitle"
                @saveInterviewsSubTask="saveInterviewsSubTask"
                @storeOriginal="storeOriginal"
                @upDateInterviewsSubTaskInit=upDateInterviewsSubTaskInit
              />

              <!-- 面接関連（清掃員）スマイル移行後の最新コンポーネント -->
              <InterviewsDCNewComponents
                ref="InterviewsDCNewComponents"
                v-else-if="isShowCategoryItem('面接関連')&&!requestPost.newGrad&&!requestPost.interviewsRegularStaff&&requestPost.dcNew2"
                :requestPost="requestPost"
                :referenceMode="referenceMode"
                :departmentLists="toDepartmentList"
                @get-title="getTitle"
                @saveInterviewsSubTask="saveInterviewsSubTask"
                @storeOriginal="storeOriginal"
                @upDateInterviewsSubTaskInit=upDateInterviewsSubTaskInit
                @loadingStart="isSaving=true"
                @loadingEnd="isSaving=false"
              />

              <!-- 面接関連（清掃員）スマイル移行の前の新しいコンポーネント -->
              <InterviewsDCComponents
                ref="InterviewsDCComponents"
                v-else-if="isShowCategoryItem('面接関連')&&!requestPost.newGrad&&!requestPost.interviewsRegularStaff&&requestPost.dcNew"
                :requestPost="requestPost"
                :referenceMode="referenceMode"
                :departmentLists="toDepartmentList"
                @get-title="getTitle"
                @saveInterviewsSubTask="saveInterviewsSubTask"
                @storeOriginal="storeOriginal"
                @upDateInterviewsSubTaskInit=upDateInterviewsSubTaskInit
                @loadingStart="isSaving=true"
                @loadingEnd="isSaving=false"
              />

              <!-- 面接関連（新卒） -->
              <InterviewsNewGradComponents
                ref="InterviewsNewGradComponents"
                v-else-if="isShowCategoryItem('面接関連')&&requestPost.newGrad"
                :requestPost="requestPost"
                :referenceMode="referenceMode"
                from="main"
                :departmentLists="toDepartmentList"
                :mainValidation="validation"
                @get-title="getTitle"
                @saveInterviewsSubTask="saveInterviewsSubTask"
                @storeOriginal="storeOriginal"
                @upDateInterviewsSubTaskInit=upDateInterviewsSubTaskInit
              />

              <!-- 過去の受注データ -->
              <OrderComponents
                ref="OrderComponents"
                v-if="isOrder && editMode && !requestPost.orderNew"
                :estimateData="estimateData"
                :orderData="orderData"
                @toOrderData="additionOrderData"
                @changeValidateContractEndDate="changeValidateContractEndDate"
                @changeValidateSpecialCleanWorkItem="changeValidateSpecialCleanWorkItem"
                @changeValidateClassification="changeValidateClassification"
                @changeOrderSummary="changeOrderSummary"
                :referenceMode="referenceMode"
              />
              <!-- 新しい受注データ（全てのカテゴリーが配列）2023.11末 -->
              <OrderNewComponents
                ref="OrderNewComponents"
                v-else-if="isOrder"
                :estimateData="estimateData"
                :orderData="orderData"
                :mainData="requestPost"
                :position="position"
                :buildingListByClient="buildingListByClient"
                @toOrderData="additionOrderData"
                @changeValidateContractEndDate="changeValidateContractEndDate"
                @changeValidateSpecialCleanWorkItem="changeValidateSpecialCleanWorkItem"
                @changeValidateClassification="changeValidateClassification"
                @getBuildingList="getBuildingList"
                @toContractDetail="saveAndToContractDetail"
                :referenceMode="referenceMode"
              />

              <!-- スマイル移行後の新しい変更処理（解約・変更） -->
              <OrderChangeNewComponents
                ref="OrderChangeNewComponents"
                v-if="isShowCategoryItem('変更処理（解約・変更）') && requestPost.dcNew2"
                :rp="requestPost"
                :referenceMode="referenceMode"
                :referenceMode2="referenceMode||requestPost.akbsSaved"
                :clientLists="clientLists"
              />

              <!-- 変更処理（解約・変更） -->
              <OrderChangeComponents
                ref="OrderChangeComponents"
                v-else-if="isShowCategoryItem('変更処理（解約・変更）')"
                :rp="requestPost"
                :referenceMode="referenceMode"
                :referenceMode2="referenceMode||requestPost.akbsSaved"
                :buildingListByClient="buildingListByClient"
                :clientLists="clientLists"
              />

              <!-- 業務依頼 -->
              <WorkDetailComponents
                v-else-if="isShowCategoryItem('業務依頼')"
                :rp="requestPost"
                :referenceMode="referenceMode"
              />
            </div>
          </div>

          <div v-if="!initialized" class="w-full h-full flex justify-center items-center">
            <p class="text-gray-400 font-bold animate-pulse">Loading...</p>
          </div>

          <div class="text-transparent">{{reload}}</div>

        </div>
      </div>
    </main>

    <ClientSelectorModal
      v-model="dataSelectorShow"
      :open="dataSelectorShow"
      @modalClientSelected="modalClientSelected"
    />

    <!-- 受注する見積を選択モーダル -->
    <SelectEstimateForOrderModal
      v-model="selectEstimateForOrder"
      @modalEstimateSelected="modalEstimateSelected"
      :open="selectEstimateForOrder"
    />

    <!-- 雇い入れ選択モーダル -->
    <SelectInterviewsForEmploymentModal
      v-model="selectInterviewsForEmployment"
      :open="selectInterviewsForEmployment"
      :employmentRegularStaff="requestPost.employmentRegularStaff"
      @modalInterviewsSelected="modalInterviewsSelected"
    />

    <!-- 複写する見積もり選択モーダル -->
    <SelectEstimateForAllCopyModal
      v-model="allCopyEstimateShow"
      :open="allCopyEstimateShow"
      :estimates="allCopyEstimateParam.estimates"
      :selectCallback="allCopyEstimateParam.selectCallback"
    />

    <!-- 物件選択モーダル（見積依頼で使用） -->
    <SiteSelectorForEstimateModal
      v-model="siteModal"
      :open="siteModal"
      @modalSiteSelected="siteSelected"
    />

    <!-- 物件選択モーダル（デンタツで使用） -->
    <SiteSelectorForDentatsuModal
      v-model="siteDentatsuModal"
      :open="siteDentatsuModal"
      @modalSiteSelected="siteDentatsuSelected"
    />

    <!-- 発注書送信画面 -->
    <PurchaseMailModal
      v-model="purchaseMailOpen"
      :open="purchaseMailOpen"
      :order="orderData"
      :requestNo="requestPost.requestNo"
      :estimateData="estimateData"
      @closed="purchaseMailOpen=false"
    />

    <!-- 建物管理部、勤怠課の担当エリア -->
    <UserAreaModal
      v-model="openUserArea"
      :open="openUserArea"
      @closed="openUserArea=false"
    />

    <!-- 複数人登録の社員選択 -->
    <MultiStaffSelectModal
      v-model="openMultiStaff"
      :open="openMultiStaff"
      :selectedUsers="multiStaffList"
      :excludeUserId="requestPost.toStaffId"
      @decided="multiStaffDecided"
      @closed="openMultiStaff=false"
    />

  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import InputIcon from '@components/InputIcon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'

import Category2Select from '../components/Category2Select.vue'
import CategorySelect from '../components/CategorySelect.vue'
import NewNowFlagSelect from '../components/NewNowFlagSelect.vue'
import NewClassSelect from '../components/NewClassSelect.vue'
import EstimationCleanCategorySelect from '../components/EstimationCleanCategorySelect.vue'
import EstimationInspectCategorySelect from '../components/EstimationInspectCategorySelect.vue'
import EstimationOtherCategorySelect from '../components/EstimationOtherCategorySelect.vue'
import SiteSelectorForEstimateModal from '../components/SiteSelectorForEstimateModal.vue'

import AddFileBtnSelect from '../components/AddFileBtnSelect.vue'

import InputGroupLabel from '../components/InputGroupLabel.vue'
import AvailablePowerFlagSelect from '../components/AvailablePowerFlagSelect.vue'
import ParkingFlagSelect from '../components/ParkingFlagSelect.vue'
import AvailableToiletFlagSelect from '../components/AvailableToiletFlagSelect.vue'
import DustRemovalSelect from '../components/DustRemovalSelect.vue'
import CleanCountSelect from '../components/CleanCountSelect.vue'
import DustCountSelect from '../components/DustCountSelect.vue'
import PlusDustRemovalSelect from '../components/PlusDustRemovalSelect.vue'
import EverydayStartTimeFlagSelect from '../components/EverydayStartTimeFlagSelect.vue'
import ManagerWorkTimeFlagSelect from '../components/ManagerWorkTimeFlagSelect.vue'
import ManagerWorkHolidayFlagSelect from '../components/ManagerWorkHolidayFlagSelect.vue'

import EverydayHolidayFlagSelect from '../components/EverydayHolidayFlagSelect.vue'
import EverydayHolidaySelect from '../components/EverydayHolidaySelect.vue'
import InputGroupSubLabel from '../components/InputGroupSubLabel.vue'

import ManagerWorkHolidaySelect from '../components/ManagerWorkHolidaySelect.vue'
import GlassCleanWorkWaySelect from '../components/GlassCleanWorkWaySelect.vue'
import EvInspectContentSelect from '../components/EvInspectContentSelect.vue'
import ResidenceTypeSelect from '../components/ResidenceTypeSelect.vue'
import ApartmentTypeSelect from '../components/ApartmentTypeSelect.vue'
import ToiletCleaningSelect from '../components/ToiletCleaningSelect.vue'

import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
import WmsTimeInput2 from '@wmscomponents/WmsTimeInput2.vue'

import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import NumericTextInput2 from '@components/NumericTextInput2.vue'
import SelectionOneValue from '@components/SelectionOneValue.vue'
import DentatsuCategorySelect from '../components/DentatsuCategorySelect.vue'
import DentatsuMail from '../components/DentatsuMail.vue'
import ClientSelectorModal from '../components/ClientSelectorModal.vue'
import SelectEstimateForOrderModal from '../components/SelectEstimateForOrderModal.vue'
import SelectInterviewsForEmploymentModal from '../components/SelectInterviewsForEmploymentModal.vue'
import SelectEstimateForAllCopyModal from '../components/SelectEstimateForAllCopyModal.vue'
import UserAreaModal from '../../User/components/UserAreaModal.vue'
import MultiStaffSelectModal from '../components/MultiStaffSelectModal.vue'

import HelpBtnSelect from '../components/HelpBtnSelect.vue'
import WorkingCheckCard, { groupByKind } from '../../Akbs/components/WorkingCheckCard.vue'
// import PigeonFormModal from '@components/PigeonFormModal.vue'

import * as helper from '@libs/helper'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'

import * as requestPostManager from '@managers/requestPostManager'
import * as estimateManager from '@managers/estimateManager'
import * as taskRequestManager from '@managers/taskRequestManager'
import * as logManager from '@managers/logManager'
import * as orderManager from '@managers/orderManager'
import * as backend from '@libs/backend'

import LoadingIcon from '@assets/loading-circle.svg'
import { PIGEON_CONFIG } from '@/config'
import { REQUEST_POST_FEATURES } from '@/config'
import { REQUEST_POST_TRANSMISSION_FEATURES } from '@/config'
import * as chatwork from '@libs/chatwork'
import * as chatworkMessage from '@libs/chatworkMessage'
import OrderComponents from '@apps/Order/components/OrderComponents.vue'
import OrderNewComponents from '@apps/Order/components/OrderNewComponents.vue'
import EmploymentComponents from '../components/EmploymentComponents.vue'
import EmploymentDCComponents from '../components/EmploymentDCComponents.vue'
import EmploymentDCNewComponents from '../components/EmploymentDCNewComponents.vue'
import InterviewsComponents from '../components/InterviewsComponents.vue'
import InterviewsDCComponents from '../components/InterviewsDCComponents.vue'
import InterviewsDCNewComponents from '../components/InterviewsDCNewComponents.vue'
import InterviewsNewGradComponents from '../components/InterviewsNewGradComponents.vue'
import OrderChangeComponents from '../components/OrderChangeComponents.vue'
import OrderChangeNewComponents from '../components/OrderChangeNewComponents.vue'
import WorkDetailComponents from '../components/WorkDetailComponents.vue'
import SiteSelectorForDentatsuModal from '../components/SiteSelectorModal.vue'
import EstimateHistorySearchBtn from '../../Estimation/components/EstimateHistorySearchBtn.vue'
import PurchaseMailModal from '../components/PurchaseMailModal.vue'

import * as constants from '@libs/constants'
import { isDaysRemark, groupDaysByTime } from '@libs/orderRemark'
import * as purchaseManager from '@managers/purchaseManager'
import WmsSearchSelect from '@wmscomponents/WmsSearchSelect.vue'
import * as moment from 'moment'
import PageModel from '../../main/pages/PageModel.vue'

import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon
} from 'vue-simple-accordion'
import '@components/VueSimpleAccordion.scss'
import _ from 'lodash'
import { OHNO_USER_ID } from '@/config'

export default {
  extends: PageModel,
  components: {
    WorkingCheckCard,
    PageHeader,
    Icon,
    InputIcon,
    PrimaryButton,
    Category2Select,
    CategorySelect,
    NewNowFlagSelect,
    NewClassSelect,
    EstimationCleanCategorySelect,
    EstimationInspectCategorySelect,
    EstimationOtherCategorySelect,
    ManagerWorkHolidayFlagSelect,
    AddFileBtnSelect,
    InputGroupLabel,
    AvailablePowerFlagSelect,
    ParkingFlagSelect,
    AvailableToiletFlagSelect,
    DustRemovalSelect,
    CleanCountSelect,
    DustCountSelect,
    PlusDustRemovalSelect,
    EverydayStartTimeFlagSelect,
    EverydayHolidayFlagSelect,
    EverydayHolidaySelect,
    ManagerWorkTimeFlagSelect,
    InputGroupSubLabel,
    ManagerWorkHolidaySelect,
    GlassCleanWorkWaySelect,
    EvInspectContentSelect,
    ResidenceTypeSelect,
    ApartmentTypeSelect,
    ToiletCleaningSelect,
    WmsSuggestInput,
    WmsTextInput,
    WmsTimeInput2,
    NumericTextInput2,
    SelectionOneValue,
    DentatsuCategorySelect,
    DentatsuMail,
    WmsAttachment,
    WmsDateInput,
    HelpBtnSelect,
    // PigeonFormModal,
    ClientSelectorModal,
    SelectEstimateForOrderModal,
    SelectInterviewsForEmploymentModal,
    SelectEstimateForAllCopyModal,
    SiteSelectorForEstimateModal,
    LoadingIcon,
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    OrderComponents,
    OrderNewComponents,
    WmsSearchSelect,
    EmploymentComponents,
    EmploymentDCComponents,
    EmploymentDCNewComponents,
    InterviewsComponents,
    InterviewsDCComponents,
    InterviewsDCNewComponents,
    InterviewsNewGradComponents,
    SiteSelectorForDentatsuModal,
    EstimateHistorySearchBtn,
    PurchaseMailModal,
    OrderChangeComponents,
    OrderChangeNewComponents,
    UserAreaModal,
    MultiStaffSelectModal,
    WorkDetailComponents
  },

  data() {
    return {
      reload: 0,
      savingSubTask: false,
      requestPost: requestPostManager.create(),
      clientData: {},
      originalRequestPost: {},
      toDepartmentList: [],
      toStaffNameList: [],
      dataSelectorShow: false,
      isSaving: false,
      initialized: false,
      forCustomers: false,
      clientTaskId: null,
      clientRegistrationModalShow: false,
      displayHouseHolds: false,
      saved: false,
      estimateFlag: false,
      minLimitDate: '',
      isClientRequired: true,
      isDisabledNewClass: false,
      hourItems: [],
      minuteItems: [],
      // ゴミ出し搬出有無（ラウンド、ラウンドプラス）キャプション
      dustCaptionRls: 'ゴミ搬出有無',
      dustCaptionPlus: 'ゴミ搬出有無',
      evQtyItems: [],
      evUnitNameItems: [],
      spItems: [],
      unitNameItems: [],
      otherWorkItems: [],
      regItems: [],
      rsItems: [],
      isBuildingDetailsRequired: true,
      isBuildingEquipmentRequired: true,
      deci: 1,
      // 定期清掃
      copyFixed: [],
      // 特別清掃
      copySp: [],
      // ラウンドサブ
      copySubs: [],
      // ダブっているラウンドサービスの項目
      copySubsW: [],
      // その他作業
      copyOther: [],
      // ダブっているその他作業の項目
      copyOtherW: [],
      // 選択した部署のデータ
      departmentInfo: {},
      // 複写する見積もりを選択する画面表示
      allCopyEstimateShow: false,
      // 複写する見積もりを選択する画面に渡すパラム
      allCopyEstimateParam: {},
      isOrder: false,
      estimateData: {},
      isCategory: true,
      order: {},
      orderData: {},
      isCompleteButtunActive: true,
      contractEndDateResult: false,
      contractEndDateMessage: '',
      classificationResult: false,
      classificationMessage: '',
      specialCleanWorkItemResult: false,
      specialCleanWorkItemMessage: '',
      mode: 0,
      referenceMode: false,
      isOutsideRequired: true,
      isTransmission: false,
      // 得意先リスト
      clientLists: [],
      // 編集できるか
      canEdit: false,
      // 発注メールを一度でも送信したか
      isAlreadySent: false,
      // 受注する見積を選択するダイアログ表示
      selectEstimateForOrder: false,
      selectInterviewsForEmployment: false,
      // スタッフ  SuggestInput フラグ
      isStaffSuggest: true,
      selectedStaffValue: null,
      toStaffSelections: [],
      selectedByUserValue: null,
      byUserSelections: [],
      // サブ一覧から遷移した場合のスクロール位置
      position: '',
      // 雇い入れの元となる面接タスクのID
      interviewsId: null,
      // 全物件リスト（見積依頼で使用）
      allBuildingList: [],
      // 得意先に紐づく物件リスト（見積依頼で使用）
      buildingListByClient: [],
      // 物件検索モーダル（見積依頼で使用）
      siteModal: false,
      // 清掃員リスト
      allAkbsStaffList: [],
      akbsStaffList: [],
      // 物件リスト
      akbsBuildingList: [],
      // 物件リスト全取得
      allAkbsBuildingList: [],
      // 物件検索モーダル（デンタツで使用）
      siteModal2: false,
      // デンタツ用の物件検索モーダル
      siteDentatsuModal: false,
      // 面接関連（社員）に表示されるチャットワークマスタ編集権限
      chatMstAuth: false,
      // お問い合わせ内容 ハイパーリンク
      noteLinks: [],
      // デンタツメール送信中
      sending: false,
      // メール送信した
      isSendMail: false,
      // 得意先担当者のメールマスタ
      mailListAll: [],
      mailList: [],
      // 発注書送信モーダルOPEN
      purchaseMailOpen: false,
      // ラウンドトラッシュのゴミ出し選択値
      rlsTrashList: [
        { key: '週 1 回', val: '週 1 回' },
        { key: '週 2 回', val: '週 2 回' },
        { key: '週 3 回', val: '週 3 回' },
        { key: '週 4 回', val: '週 4 回' },
        { key: '週 3.5 回', val: '週 3.5 回' },
        { key: '週 4.5 回', val: '週 4.5 回' },
      ],
      // 担当エリアモーダル
      openUserArea: false,
      // 複数人登録の社員選択モーダル
      openMultiStaff: false,
      // 複数人登録で選択した社員
      // ＊「複数人選択モーダル」で選択した時のみ設定される（編集・複写では引き継がない）
      multiStaffList: []
    }
  },

  watch: {
    'estimateFlag': {
      handler: function() {
        this.estimateItemRefresh()
      },
      deep: true
    },

    /**
     * 複数人登録の対象カテゴリから外れた場合、選択済みの社員をクリアする
     * ＊対象外のカテゴリを混在させた時点で複数登録は行わない
     */
    isMultiRegistCategory(newVal) {
      if (!newVal && this.multiStaffList.length) {
        this.multiStaffList = []
      }
    },

    /**
     * 担当者が変更された場合、その社員を選択済みから外す
     * ＊担当者と選択者が重複して二重に登録されるのを防ぐ
     */
    'requestPost.toStaffId': function(newVal) {
      if (!newVal || !this.multiStaffList.length) {
        return
      }
      this.multiStaffList = this.multiStaffList.filter((staff) => {
        return String(staff.userId) != String(newVal)
      })
    }
  },

  props: {
    estimate: {
      type: Object
    }
  },

  computed: {
    /**
     * AKBS登録時に「確認メインタスクを作る」を選んだ休み・代勤・振替を種類ごとに分けたもの
     * （確認・質問のメインタスクに akbsCheckList として持っている。無ければ空）
     */
    akbsCheckGroups() {
      return groupByKind(this.requestPost.akbsCheckList)
    },

    /**
     * 確認する休み・代勤・振替を AKBS の稼働管理で開く URL（operations/true/一番早い日/一番遅い日/清掃員コード）
     * 日か清掃員コードが無い古いタスクは空
     */
    akbsOperationUrl() {
      const rp = this.requestPost || {}
      if (!rp.akbsCheckStart || !rp.akbsCheckEnd || !rp.akbsStaffCode) return ''
      return `${PIGEON_CONFIG.akbsUrl}operations/true/${rp.akbsCheckStart}/${rp.akbsCheckEnd}/${rp.akbsStaffCode}`
    },

    /**
     * 編集モード チェック
     */
    editMode() {
      return this.requestPost && this.requestPost._id
    },

    /**
     * 依頼日から1か月後
     */
    maxLimitDate() {
      return moment(this.requestPost.requestDate).add(1, 'months').format('YYYY-MM-DD')
    },

    /**
     * メールアドレス 入力チェック
     */
    emailInputCheck() {
      let result
      if(this.requestPost.clientMail) {
        const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
        result = !reg.test(this.requestPost.clientMail)
      }
      return result
    },

    validateCategory2() {
      if (this.isOutsideRequired && (!this.requestPost.category2 || this.requestPost.category2.length == 0)) {
        return {
          result: false,
          message: '社内/お客様は選択必須です。社内/お客様を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateCategory() {
      if (!this.requestPost.category || this.requestPost.category.length == 0) {
        return {
          result: false,
          message: 'お問い合わせカテゴリーは選択必須です。お問い合わせカテゴリーを選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateInquiry_title() {
      if (this.isOutsideRequired && !this.requestPost.inquiry_title) {
        return {
          result: false,
          message: 'タイトルは必須入力です。タイトルを入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    /**
     * お客様会社名入力チェック
     */
    validateClientName() {
      if (this.requestPost.temporarySaveFlag && !this.requestPost.clientName && this.isShowCategoryItem('見積依頼')) {
        return {
          result: false,
          message: '仮登録の際は、お客様会社名は必須入力です。\r\nお客様会社名を入力してください。'
        }
      }

      if (((this.isOutsideRequired && this.isClientRequired) && !this.requestPost.clientName)) {
        return {
          result: false,
          message: 'お客様会社名は必須入力です。お客様会社名を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateClientPersonName() {
      if (this.isOutsideRequired && this.isClientRequired && !this.requestPost.clientPersonName) {
        return {
          result: false,
          message: 'お客様担当者名は必須入力です。お客様担当者名を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateTelephoneNumber() {
      if (!this.requestPost.telephoneNumber) {
        return {
          result: false,
          message: '電話番号は必須入力です。電話番号を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateClientMail() {
      if (this.isOutsideRequired && this.isClientRequired && !this.requestPost.clientMail) {
        return {
          result: false,
          message: 'メールアドレスは必須入力です。メールアドレスを入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateToDepartment() {
      if (!this.requestPost.toDepartment) {
        return {
          result: false,
          message: 'アポロ管財依頼先部署は必須入力です。アポロ管財依頼先部署を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateToStaffName() {
      if (!this.requestPost.toStaffName) {
        return {
          result: false,
          message: '担当者は必須入力です。担当者を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateByUser() {
      if (!this.requestPost.byUser) {
        return {
          result: false,
          message: '依頼主は必須入力です。依頼主を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateLimitDate() {
      if (!this.requestPost.limitDate) {
        return {
          result: false,
          message: '期限は必須入力です。期限を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateNewNowFlag() {
      if (!this.requestPost.newNowFlag || this.requestPost.newNowFlag.length == 0) {
        return {
          result: false,
          message: '契約無/契約有は選択必須です。契約無/契約有を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateNewClass() {
      if (!this.requestPost.newClass || this.requestPost.newClass.length == 0) {
        return {
          result: false,
          message: '新規区分は選択必須です。新規区分を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateBuildingName() {
      if (!this.requestPost.buildingName) {
        return {
          result: false,
          message: '建物名は必須入力です。建物名を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateState() {
      if (this.isBuildingDetailsRequired && !this.requestPost.state) {
        return {
          result: false,
          message: '都道府県は必須入力です。都道府県を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateCity() {
      if (this.isBuildingDetailsRequired && !this.requestPost.city) {
        return {
          result: false,
          message: '市区郡は必須入力です。市区郡を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateStairs() {
      if (this.isBuildingDetailsRequired && !this.requestPost.stairs) {
        return {
          result: false,
          message: '階数は必須入力です。階数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateHouseholds() {
      if (this.isBuildingDetailsRequired && !this.requestPost.households) {
        return {
          result: false,
          message: '戸数は必須入力です。戸数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateAvailablePowerFlag() {
      if (this.isBuildingEquipmentRequired && (!this.requestPost.availablePowerFlag || this.requestPost.availablePowerFlag.length == 0)) {
        return {
          result: false,
          message: '使用できる電源の有無は選択必須です。使用できる電源の有無を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateParkingFlag() {
      if (this.isBuildingEquipmentRequired && (!this.requestPost.parkingFlag || this.requestPost.parkingFlag.length == 0)) {
        return {
          result: false,
          message: '駐車スペースの有無は選択必須です。駐車スペースの有無を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateDustRemoval() {
      if (!this.requestPost.dustRemoval || this.requestPost.dustRemoval.length == 0) {
        return {
          result: false,
          message: 'ラウンドサービスのゴミ搬出有無は選択必須です。ゴミ搬出有無を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateDustCount() {
      if (!this.requestPost.dustCount || this.requestPost.dustCount.length == 0) {
        return {
          result: false,
          message: 'ラウンドサービスのゴミ搬出回数は選択必須です。ゴミ搬出回数を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validatePlusDustRemoval() {
      if (!this.requestPost.plusDustRemoval || this.requestPost.plusDustRemoval.length == 0) {
        return {
          result: false,
          message: 'ラウンドプラスのゴミ搬出有無は選択必須です。ゴミ搬出有無を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateRlsToiletTimes() {
      if (this.isShowtToilet(this.requestPost.rlsToiletCleaning, '有料トイレ清掃あり') && this.requestPost.rlsToiletTimes == '') {
        return {
          result: false,
          message: 'ラウンドサービスの有料トイレ清掃回数は必須です。有料トイレ清掃回数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateRlsToiletPlace() {
      if (this.isShowtToilet(this.requestPost.rlsToiletCleaning, '有料トイレ清掃あり') && this.requestPost.rlsToiletPlace == '') {
        return {
          result: false,
          message: 'ラウンドサービスの有料トイレ清掃箇所は必須です。有料トイレ清掃箇所を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validatePlusToiletTimes() {
      if (this.isShowtToilet(this.requestPost.plusToiletCleaning, '有料トイレ清掃あり') && this.requestPost.plusToiletTimes == '') {
        return {
          result: false,
          message: 'ラウンドプラス（巡回清掃）の有料トイレ清掃回数は必須です。有料トイレ清掃回数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validatePlusToiletPlace() {
      if (this.isShowtToilet(this.requestPost.plusToiletCleaning, '有料トイレ清掃あり') && this.requestPost.plusToiletPlace == '') {
        return {
          result: false,
          message: 'ラウンドプラス（巡回清掃）の有料トイレ清掃箇所は必須です。有料トイレ清掃箇所を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validatePlusToiletTimesNormal() {
      if (this.isShowtToilet(this.requestPost.plusToiletCleaningNormal, '有料トイレ清掃あり') && this.requestPost.plusToiletTimesNormal == '') {
        return {
          result: false,
          message: 'ラウンドプラス（固定清掃）の有料トイレ清掃回数は必須です。有料トイレ清掃回数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validatePlusToiletPlaceNormal() {
      if (this.isShowtToilet(this.requestPost.plusToiletCleaningNormal, '有料トイレ清掃あり') && this.requestPost.plusToiletPlaceNormal == '') {
        return {
          result: false,
          message: 'ラウンドプラス（固定清掃）の有料トイレ清掃箇所は必須です。有料トイレ清掃箇所を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },


    validatePlusDustCount() {
      if (!this.requestPost.plusDustCount || this.requestPost.plusDustCount.length == 0) {
        return {
          result: false,
          message: 'ラウンドプラスのゴミ搬出回数は選択必須です。ゴミ搬出回数を選択してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateCleanCount() {
      if (!this.requestPost.cleanCount || this.requestPost.cleanCount.length == 0) {
        return {
          result: false,
          message: 'ラウンドサービスの清掃希望回数は必須入力です。清掃希望回数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validatePlusCleanCount() {
      if (!this.requestPost.plusCleanCount || this.requestPost.plusCleanCount.length == 0) {
        return {
          result: false,
          message: 'ラウンドプラスの清掃希望回数は必須入力です。清掃希望回数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateEverydayCleanCount: function() {
      return function(index) {
        if (!this.requestPost.everydayCleans.length) {
          return false
        } else if (!this.requestPost.everydayCleans[index].everydayCleanCount) {
          return {
            result: false,
            message: '日常清掃の清掃希望回数は必須入力です。清掃希望回数を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateEverydayCleanHours: function() {
      return function(index) {
        if (!this.requestPost.everydayCleans.length) {
          return false
        } else if (!this.requestPost.everydayCleans[index].everydayCleanHours) {
          return {
            result: false,
            message: '日常清掃の清掃希望時間は必須入力です。清掃希望時間を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateEverydayStartTimeFlag: function() {
      return function(index) {
        if (!this.requestPost.everydayCleans.length) {
          return false
        } else if (!this.requestPost.everydayCleans[index].everydayStartTimeFlag || this.requestPost.everydayCleans[index].everydayStartTimeFlag.length == 0) {
          return {
            result: false,
            message: '日常清掃の作業時間の指定の有無は選択必須です。作業時間の指定の有無を選択してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateEverydayStartTime: function() {
      return function(index) {
        if (!this.requestPost.everydayCleans.length) {
          return false
        } else if (!utils.isTime(this.requestPost.everydayCleans[index].everydayStartTime)) {
          return {
            result: false,
            message: '日常清掃の指定作業開始時間は必須入力です。指定作業開始時間を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateToiletTimes: function() {
      return function(index) {
        if (!this.requestPost.everydayCleans.length) {
          return false
        } else if (!this.requestPost.everydayCleans[index].toiletTimes) {
          return {
            result: false,
            message: '日常清掃の有料トイレ清掃回数は必須入力です。有料トイレ清掃回数を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateToiletPlace: function() {
      return function(index) {
        if (!this.requestPost.everydayCleans.length) {
          return false
        } else if (!this.requestPost.everydayCleans[index].toiletPlace) {
          return {
            result: false,
            message: '日常清掃の有料トイレ清掃箇所数は必須入力です。有料トイレ清掃箇所数を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateManagerWorkCount: function() {
      return function(index) {
        if (!this.requestPost.managerWorks.length) {
          return false
        } else if (!this.requestPost.managerWorks[index].managerWorkCount) {
          return {
            result: false,
            message: '管理員業務の清掃希望回数は必須入力です。清掃希望回数を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateManagerWorkHours: function() {
      return function(index) {
        if (!this.requestPost.managerWorks.length) {
          return false
        } else if (!this.requestPost.managerWorks[index].managerWorkHours) {
          return {
            result: false,
            message: '管理員業務の清掃希望時間は必須入力です。清掃希望時間を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateManagerWorkTimeFlag: function() {
      return function(index) {
        if (!this.requestPost.managerWorks.length) {
          return false
        } else if (!this.requestPost.managerWorks[index].managerWorkTimeFlag || this.requestPost.managerWorks[index].managerWorkTimeFlag.length == 0) {
          return {
            result: false,
            message: '管理員業務の作業時間の指定の有無は選択必須です。作業時間の指定の有無を選択してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateManagerWorkTime: function() {
      return function(index) {
        if (!this.requestPost.managerWorks.length) {
          return false
        } else if (!utils.isTime(this.requestPost.managerWorks[index].managerWorkTime)) {
          return {
            result: false,
            message: '管理員業務の指定作業開始時間は必須入力です。指定作業開始時間を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateRegularClean: function() {
      return function(index, item) {
        if (!this.requestPost.regularCleans.length) {
          return false
        } else if (!this.requestPost.regularCleans[index][item]) {
          if (item.indexOf('Content') != -1) {
            return {
              result: false,
              message: '定期清掃の依頼内容は必須入力です。依頼内容を入力してください。'
            }
          } else if (item.indexOf('Count') != -1) {
            return {
              result: false,
              message: '定期清掃の回数は必須入力です。回数を入力してください。'
            }
          } else {
            return {
              result: false,
              message: '定期清掃の単位は必須入力です。単位を入力してください。'
            }
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateGlassCleanCount() {
      if (!this.requestPost.glassCleanCount) {
        return {
          result: false,
          message: 'ガラス清掃の清掃希望回数は必須入力です。清掃希望回数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validatePlantingCount() {
      if (!this.requestPost.plantingCount) {
        return {
          result: false,
          message: '植栽剪定の希望回数は必須入力です。希望回数を入力してください。'
        }
      } else {
        return {
          result: true,
          message: ''
        }
      }
    },

    validateSpecialCleanCount: function() {
      return function(index) {
        if (!this.requestPost.specialCleans.length) {
          return false
        } else if (!this.requestPost.specialCleans[index].specialCleanCount) {
          return {
            result: false,
            message: '特別清掃の希望回数は必須入力です。希望回数を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateSpecialCleanContent: function() {
      return function(index) {
        if (!this.requestPost.specialCleans.length) {
          return false
        } else if (!this.requestPost.specialCleans[index].specialCleanContent) {
          return {
            result: false,
            message: '特別清掃の依頼内容は必須入力です。依頼内容を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateSpecialCleanUnitName: function() {
      return function(index) {
        if (!this.requestPost.specialCleans.length) {
          return false
        } else if (!this.requestPost.specialCleans[index].specialCleanUnitName) {
          return {
            result: false,
            message: '特別清掃の単位は必須入力です。単位を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateRoundSub: function() {
      return function(index, item) {
        if (!this.requestPost.roundSubs.length) {
          return false
        } else if (!this.requestPost.roundSubs[index][item]) {
          if (item.indexOf('Content') != -1) {
            return {
              result: false,
              message: 'ラウンドサブメニューの依頼内容は必須入力です。依頼内容を入力してください。'
            }
          } else if (item.indexOf('Count') != -1 && this.requestPost.roundSubs[index].roundSubContent != 'ラウンドトラッシュ') {
            return {
              result: false,
              message: 'ラウンドサブメニューの回数は必須入力です。回数を入力してください。'
            }
          } else if (item.indexOf('UnitName') != -1 && this.requestPost.roundSubs[index].roundSubContent != 'ラウンドトラッシュ') {
            return {
              result: false,
              message: 'ラウンドサブメニューの単位は必須入力です。単位を入力してください。'
            }
          }
        }

        return {
          result: true,
          message: ''
        }
      }
    },

    validateOtherWorkContent: function() {
      return function(index) {
        if (!this.requestPost.otherWorks.length) {
          return false
        } else if (!this.requestPost.otherWorks[index].otherWorkContent) {
          return {
            result: false,
            message: 'その他作業の依頼内容は必須入力です。依頼内容を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateOtherWorkCount: function() {
      return function(index) {
        if (!this.requestPost.otherWorks.length) {
          return false
        } else if (!this.requestPost.otherWorks[index].otherWorkCount) {
          return {
            result: false,
            message: 'その他作業の希望回数は必須入力です。希望回数を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    validateOtherWorkUnitName: function() {
      return function(index) {
        if (!this.requestPost.otherWorks.length) {
          return false
        } else if (!this.requestPost.otherWorks[index].otherWorkUnitName) {
          return {
            result: false,
            message: 'その他作業の単位は必須入力です。単位を入力してください。'
          }
        } else {
          return {
            result: true,
            message: ''
          }
        }
      }
    },

    dustDisabledRls() {
      if (this.requestPost.category2[0] && this.requestPost.category2[0] == 'お客様直' && ['月 1 回', '週 1 回', '週 2 回'].includes(this.requestPost.cleanCount[0])) {
        return true
      } else {
        return false
      }
    },

    dustDisabledPlus() {
      if (this.requestPost.category2[0] && this.requestPost.category2[0] == 'お客様直' && ['月 1 回', '週 1 回', '週 2 回'].includes(this.requestPost.plusCleanCount[0])) {
        return true
      } else {
        return false
      }
    },

    /**
     * メインタスク権限
     */
    mainAuth() {
      return this.$store.getters.mainAuth
    },

    /**
     * 発注書PDF 活性or非活性判定
     */
    activePurchaseBtn() {
      // 受注が決まったもの
      if (this.$route.query.mode == 6) {
        return true
      } else {
        // 保存されたもの
        if (this.requestPost && this.requestPost._id && this.requestPost._id != '') {
          return true
        } else {
          return false
        }
      }
    },

    /**
     * 発注ボタンツールチップ
     */
    purchaseTooltip() {
      // 編集権限なし
      if (!this.canEdit) {
        return ''
      }
      if (!this.requestPost || !this.requestPost._id || this.requestPost._id == '') {
        return '発注処理に進むには、一度登録し、受注を確定してください。'
      }
      return ''
    },

    /**
     * 複数人登録の対象カテゴリのみが選択されているか
     * ＊対象カテゴリ（MULTI_REGIST_CATEGORIES）のみで構成されている場合に true
     * ＊対象外のカテゴリが1つでも混在している場合は false
     */
    isMultiRegistCategory() {
      const category = this.requestPost.category
      if (!category || !category.length) {
        return false
      }
      return category.every((c) => {
        return constants.MULTI_REGIST_CATEGORIES.includes(c)
      })
    },

    /**
     * 複数人登録が可能か
     * ＊対象カテゴリのみで構成されている場合に可
     * ＊新規登録時のみ可（編集・参照では不可）
     */
    canMultiRegist() {
      if (this.forCustomers || this.referenceMode || this.isOrder) {
        return false
      }
      // 編集（既に登録済み）の場合は不可
      if (this.requestPost.requestNo && this.requestPost._id) {
        return false
      }
      return this.isMultiRegistCategory
    },

    /**
     * 非公開の始末書OR反省文
     */
    isApology() {
      if (this.isShowCategoryItem('非公開依頼') && (this.requestPost.apology || this.requestPost.reflect)) {
        return true
      } else {
        return false
      }
    },

    /**
     * ログインユーザーID
     */
    userId() {
      return this.$store.getters.user.id
    },

    /**
     * ログインユーザー名（カナなし）
     */
    userName() {
      // ログインユーザー名
      const name = this.$store.getters.user.user_name
      return utils.deleteKana(name)
    },

    /**
     * メインの所属部署名
     */
    mainDepartment() {
      const res = this.$store.getters.loginUserData
      return res.departmentName
    },

    /**
     * 担当者 Multiselect 表示値
     * toStaffId（なければtoStaffName）から選択肢オブジェクトを特定
     */
    selectedToStaff() {
      const id = this.requestPost.toStaffId
      const name = this.requestPost.toStaffName
      if (!id && !name) {
        return null
      }
      const list = this.toStaffNameList || []
      let hit = null
      if (id) {
        // 兼務者は同一userIdが複数行あるため、依頼先部署と一致する行を優先
        hit = list.find(s => String(s.userId) == String(id) && String(s.departmentId) == String(this.requestPost.toDepartmentId))
          || list.find(s => String(s.userId) == String(id))
      } else {
        hit = list.find(s => s.userName == name)
      }
      // 選択肢にない（旧データ・退職者など）場合も、保存済みの名前を表示する
      return hit || { userId: id, userName: name, dispName: name }
    },

    /**
     * アポロ管財依頼先部署 Multiselect 表示値
     */
    selectedToDepartment() {
      const id = this.requestPost.toDepartmentId
      const name = this.requestPost.toDepartment
      if (!id && !name) {
        return null
      }
      const list = this.toDepartmentList || []
      const hit = id ? list.find(d => String(d.departmentId) == String(id)) : list.find(d => d.name == name)
      return hit || { departmentId: id, name }
    },

    /**
     * 依頼主 Multiselect 表示値
     * byUserId（なければbyUser）から選択肢オブジェクトを特定
     */
    selectedByUser() {
      const id = this.requestPost.byUserId
      const name = this.requestPost.byUser
      if (!id && !name) {
        return null
      }
      const list = this.$store.getters.userList || []
      const hit = id ? list.find(u => String(u.id) == String(id)) : list.find(u => u.user_name == name)
      return hit || { id, user_name: name }
    },
  },

  async created() {
    this.initialized = false
    try {
      await this.initialize()
    } finally {
      this.initialized = true
    }
  },

  mounted() {
  },

  methods: {
    async initialize() {
      // this.$route.query.modeの区分一覧
      //   1：編集（メイン）
      //   2：コピー
      //   3：複写
      //   4：受注仮登録
      //   5：受注処理（見積参照画面から）
      //   6：編集（受注）

      this.requestPost = this.createNewrequestPost()

      // 複数人登録の選択はクリアする
      // ＊編集・コピー・複写では引き継がず、「複数人選択モーダル」で選択し直した場合のみ複数登録する
      this.multiStaffList = []

      // パラメータにIDがある場合は、編集モード
      // リクエストポストのデータを取得
      const requestPostId = this.$route.query.requestPostId
      if (requestPostId) {
        const requestPost = await requestPostManager.getRequestPost(this, requestPostId)
        if (!requestPost) {
          await dialogs.showErrorDialog('エラー', 'メインタスクを開くことができません。')

        } else {
          // お問い合わせカテゴリーを過去の文言を新しくする
          if (requestPost.category) {
            requestPost.category = this.setNewCategory(requestPost)
          }
          // 見積りカテゴリーを過去の文言を新しくする
          if (requestPost.estimationCleanCategory) {
            requestPost.estimationCleanCategory = this.setNewEstimateCategory(requestPost.estimationCleanCategory)
          }
          // 雇い入れ 種別を過去の文言を新しくする
          if (requestPost.employmentClass) {
            requestPost.employmentClass = this.setNewEmploymentClass(requestPost.employmentClass)
          }
          // modeパラメータを取得
          const mode = this.$route.query.mode
          // modeが1の場合は編集
          if(mode == 1) {
            this.requestPost = requestPost
            // メール受信タスク自動登録の場合、足りないプロパティ追加
            if (requestPost.mailAutoTask && (!this.requestPost.specialCleans || !this.requestPost.specialCleans[0] || this.requestPost.specialCleans[0].specialCleanCount == undefined)) {
              this.requestPost = { ...this.createNewrequestPost(), ...requestPost }
            }

            // リクエストポストIDを条件にサブタスクを全件取得
            let mainSubTasks = await taskRequestManager.getByRequestPostId(this, this.requestPost._id, null)

            // 「非公開依頼」関係者以外はメニューへリダイレクト（担当者でも依頼主でも、未定かつ同じ部署でも、管理者でもない、始末書・反省文の場合は賞与権限なし）
            if (requestPost.category.includes('非公開依頼') && !this.isPrivateAuthorized(requestPost, mainSubTasks) && !utils.admin(this.$store.getters.auth) && !((this.requestPost.apology || this.requestPost.reflect) && this.$store.getters.auth && this.$store.getters.auth.bonusAuth)) {
              dialogs.showInfoDialog('非公開依頼', '非公開依頼のため表示出来ません。メニューへ戻ります。', 'OK')
              this.$router.push('/')
            // 雇い入れ社員用の場合、人事もしくは大野様、管理者ユーザーのみ表示
            } else if ((this.requestPost.category.includes('雇い入れ') || this.requestPost.category.includes('雇い入れ（社員）')) && this.requestPost.employmentRegularStaff) {
              let empAuth = await this.isRegularStaffAuthorized()
              if (!empAuth) {
                await dialogs.showInfoDialog('雇い入れ（社員）', '管理者権限、人事総務経理部、もしくはG4以上で同じ部署の人しか閲覧できません。\r\nメニューへ戻ります。', 'OK')
                this.$router.push('/')
              }
            // 社員用面接の場合、大野様、管理者ユーザー、人事部、社員面接権限のあるユーザーのみ
            } else if (this.requestPost.category.includes('面接関連') && this.requestPost.interviewsRegularStaff) {
              let intAuth = await this.isRegularStaffInterviewAuthorized()
              if (!intAuth) {
                await dialogs.showInfoDialog('面接関連（社員）', '限られた人しか閲覧できません。\r\nメニューへ戻ります。', 'OK')
                this.$router.push('/')
              }
            }

            // サブタスクに未完了タスクがある場合、完了ボタンは非アクティブ
            let result = mainSubTasks.every(function(val){
              return val.status == 'done'
            })
            if (!result) {
              this.isCompleteButtunActive = false
            }

            // ステータスが完了の場合、参照モード
            if (this.requestPost.status == 'done') {
              this.referenceMode = true
            }
          // modeが2の場合はコピー、3の場合はRP、サブ依頼タスク、見積を全てコピー
          } else if (mode == 2 || mode == 3) {

            this.requestPost = requestPost
            this.requestPost._id = null
            this.requestPost.requestNo = null
            this.requestPost.mailResult = []
            this.requestPost.createDate = null
            this.requestPost.upDate = null
            this.requestPost.status = 'open'
            this.requestPost.kubunLimitDisabled = false
            this.requestPost.limitDateHistory = []

            if (mode == 3) {
              this.requestPost.requestDate = utils.getToday()
              this.requestPost.limitDate = utils.getToday()
              this.requestPost.toStaffName = this.$store.getters.user.user_name
              this.requestPost.toStaffId = this.$store.getters.user.id
              this.requestPost.byUser = this.$store.getters.user.user_name
              this.requestPost.byUserId = this.$store.getters.user.id

              // 定期清掃
              if (this.requestPost.regularCleans) {
                this.copyFixed = utils.clone(this.requestPost.regularCleans)
              }
              // 特別清掃
              if (this.requestPost.specialCleans) {
                this.copySp = utils.clone(this.requestPost.specialCleans)
              }
              // ラウンドサブ
              if (this.requestPost.roundSubs) {
                this.copySubs = utils.clone(this.requestPost.roundSubs)

                let subName = []
                this.copySubsW = []
                for (let i = 0; i < this.copySubs.length; i++) {
                  const cs = this.copySubs[i];
                  if (subName.includes(cs.roundSubContent)) {
                    this.copySubsW.push(cs.roundSubContent)
                  } else {
                    subName.push(cs.roundSubContent)
                  }
                }
              }
              // その他作業
              if (this.requestPost.otherWorks) {
                this.copyOther = utils.clone(this.requestPost.otherWorks)

                let oName = []
                this.copyOtherW = []
                for (let i = 0; i < this.copyOther.length; i++) {
                  const cs = this.copyOther[i];
                  if (oName.includes(cs.otherWorkContent)) {
                    this.copyOtherW.push(cs.otherWorkContent)
                  } else {
                    oName.push(cs.otherWorkContent)
                  }
                }
              }

            }
          }

          // フラグ 設定
          this.category2Changed()
          this.newNowFlagChanged()
          this.categoryChanged(this.requestPost.category, false)
        }
      } else {
        // 新規登録
        this.requestPost = this.createNewrequestPost()
        this.requestPost.dcNew2 = true
      }

      // 面接関連メニューから入った場合
      if (this.$route.query.interviews) {
        this.requestPost.category = ['面接関連']
        await this.InterviewsDialog()
      }

      // modeが5の場合は見積参照画面から遷移
      else if (this.$route.query.mode == 5) {
        // すでに受注タスク作成済み
        if (this.$route.query.orderId) {
          this.mode = 6

        // 新規
        } else {
          this.requestPost.category = ['受注処理（新規・金額変更）']
          await this.modalEstimateSelected(this.estimate)
        }
      }

      // 受注編集
      else if (this.$route.query.mode == 6 || this.mode == 6) {
        this.mode = 6
        const orderId = this.$route.query.orderId
        if (orderId) {
          let order = await orderManager.getOrderData(this, orderId)
          if (!order) {
            await dialogs.showErrorDialog('エラー', '受注タスクを開くことができません。')
          } else {
            // 過去のデータにないプロパティを入れる（昔の仕様の受注のみ）
            if (!order.orderNew) {
              order = this.setNewProperty(order)
            }

            // お問い合わせカテゴリーを過去の文言を新しくする
            if (order.category) {
              order.category = this.setNewCategory(order)
            }
            this.requestPost = order
            this.orderData = order
            this.estimateData = await estimateManager.getEstimate(this, order.estimateNo)
            this.isOrder = true
            this.isCategory = false
            this.isClientRequired = false
            // ステータスが完了の場合、参照モード
            if (this.requestPost.status == 'done') {
              this.referenceMode = true
            }
          }
        }
        // サブ一覧の「配信作業」から遷移した場合
        if (this.$route.query.position) {
          this.position = this.$route.query.position
        }
      }

      // pathがお客様用フォームであるか確認
      let path = location.pathname
      if (path.indexOf('/customersRequestPost') > -1 ) {
        // お客様用フォームフラグ
        this.forCustomers = true
        this.requestPost.category2 = ['お客様直']

        // お客様コード有無 確認
        let clientCode = this.$route.query.clientCode
        if (clientCode) {
          const client = await estimateManager.getClientByCode(clientCode)
          if (!client) {
            await dialogs.showErrorDialog('エラー', 'メインタスクを開くことができません。')
          } else {
            this.clientData = client

            // お客様コードよりお客様会社名、お客様部署名 取得
            this.requestPost.clientName = this.clientData.clientName + ' ' + this.clientData.clientDepartmentName
          }
        } else {
          await dialogs.showErrorDialog('エラー', 'メインタスクを開くことができません。')
        }

        // リクエストポストのデータにお客様コードを追加
        this.requestPost.clientCode = clientCode
      }

      // デンタツ以外の場合、部署のリスト取得
      if (!this.requestPost.category.includes('デンタツ') && !this.requestPost.category.includes('AKBS休み登録')) {
        let departmentList = this.$store.getters.departmentList
        this.toDepartmentList = departmentList
      }

      this.minLimitDate = utils.getToday()

      if (path.indexOf('/customersRequestPost') == -1 && !requestPostId && !this.requestPost.orderNo) {
        // 担当者・依頼主にログインユーザーをセット
        this.setDefaultStaff()
      }

      // 得意先リスト
      this.clientLists = await estimateManager.getClient(null)
      // 担当者リスト 生成
      if (this.requestPost.toDepartmentId) {
        this.getStaffNameList(this.requestPost.toDepartmentId, false)
      } else {
        this.getStaffNameList()
      }

      // お問い合わせ内容 リンク生成
      this.noteLinks = this.getNoteLinks()

      this.hourItems = [
        { text: '7' },
        { text: '8' },
        { text: '9' },
        { text: '10' },
        { text: '11' },
        { text: '12' },
        { text: '13' },
        { text: '14' },
        { text: '15' },
        { text: '16' },
        { text: '17' },
        { text: '18' },
        { text: '19' },
        { text: '20' },
        { text: '21' },
        { text: '22' },
        { text: '23' }
      ]
      this.minuteItems = [
        { text: '00' },
        { text: '15' },
        { text: '30' },
        { text: '45' }
      ]

      this.evQtyItems = [
        { text: '1' },
        { text: '4' },
        { text: '6' },
        { text: '12' },
        { text: '24' }
      ]
      this.evUnitNameItems = [
        { text: 'ヶ月' },
        { text: '回' },
        { text: '回/年' },
        { text: '式' },
        { text: '回/2年' },
        { text: '回/3年' }
      ]

      // idは見積りで単価取得に必要！
      this.spItems = [
        { id:'wall',text:'腰壁清掃' },
        { id:'lighting',text:'照明器具清掃' },
        { id:'acid',text:'エントランス等石材酸洗浄' },
        { id:'coating',text:'エントランスコーティング' },
        { id:'garari',text:'ガラリ清掃' },
        { id:'gutter',text:'側溝清掃' },
        { id:'masu',text:'枡清掃' },
        { id:'parking',text:'駐車場ピット内清掃' },
        { id:'safety',text:'安全対策要員' },
        { id:'shovel',text:'釜場清掃（スコップ）' },
        { id:'sludge',text:'汚泥処理' },
        { id:'inter',text:'インターロッキング洗浄' },
        { id:'drain',text:'屋上ドレン清掃' },
        { id:'bicycle',text:'駐輪場清掃' },
        { id:'roof',text:'駐輪場屋根' },
        { id:'wipe',text:'壁面拭き上げ' },
        { id:'filter',text:'エアコンフィルター清掃' },
        { id:'louver',text:'ルーバー' },
        { id:'pallet',text:'機械式駐車場パレット清掃（掃き）' },
        { id:'fence',text:'クーラーフェンス' },
        { id:'ceiling',text:'天井清掃(ステンレス）' },
        { id:'pond',text:'水景(池)清掃' },
        { id:'lattice',text:'外廊下面格子・網戸清掃' }
      ]

      // 単位
      this.unitNameItems = [
        { text: '回' },
        { text: '回/年' },
        { text: '式' },
        { text: 'ヶ月' },
        { text: '回/2年' },
        { text: '回/3年' }
      ]

      // その他作業
      this.otherWorkItems = [
        { text: '管球対応' },
        { text: '消火器交換' },
        { text: '粗大ごみ対応' },
        { text: '物品販売' },
        { text: '緊急対応' },
        { text: '防火対象物点検' },
        { text: 'スポット清掃' }
      ]

      // 定期清掃内容
      this.regItems = [
        { text:'エントランス' },
        { text:'廊下' },
        { text:'階段' },
        { text:'管理室' }
      ]

      // ラウンドサブメニュー内容
      this.rsItems = [
        { text:'フロントサポート' },
        { text:'フロントサポートプラス' },
        { text:'ラウンドトラッシュ' },
        { text:'クオリティレポート' }
      ]

      if (!this.requestPost.specialCleans || !this.requestPost.specialCleans[0] || this.requestPost.specialCleans[0].specialCleanCount == undefined) {
        this.addSpecialClean()
        this.addRegularClean()
        this.addRoundSub()
        this.addOtherWork()
        this.addEverydayClean()
        this.addManagerWork()
      }

      // 担当者から担当者（非公開依頼）へ反映
      this.staffNameToToStaff()
      // 依頼者から依頼者（非公開依頼）へ反映
      this.byUserToSByUser()

      // 依頼主（非公開依頼）選択肢生成
      this.byUserSelections = this.$store.getters.userList.map(function(item){
        return {
          value: item.id,
          text: item.user_name
        };
      });

      // console.log(this.byUserSelections)
      // console.log(this.$store.getters.userList)

      const self = this
      self.$nextTick(() => {
        self.storeOriginal()
        this.canEdit = this.checkCanEdit()
        this.checkAlreadySent()
      })

      // 期限区分がなく、期限が設定している場合（過去データ）
      if (!this.requestPost.kubunLimit && this.requestPost.limitDate) {
        // 依頼日と期限日から区分を算出
        // 期限日が1か月後なら長期タスク
        const isLongTerm = moment(this.requestPost.limitDate, 'YYYY-MM-DD').isAfter(
          moment(this.requestPost.requestDate).add(1, 'month'),
          'day'
        )
        if (isLongTerm) {
          this.requestPost.kubunLimit = 2
        } else {
          this.requestPost.kubunLimit = 1
        }
      }
    },

    /**
     * 編集の有無 取得
     */
    isDirty() {
      // 参照モードでない場合、変更の有無を確認
      if (!this.referenceMode) {
        let before = utils.clone(this.originalRequestPost)
        // <p>タグ後ろの半角スペースを無視して比較
        if (this.requestPost.type == 'order' && before.template) {
          before.template = before.template.replace(/<p> /g, '<p>').replace(/ <\/p>/g, '</p>')
        }
        return !utils.isEquals(utils.toPlainObject(before), utils.toPlainObject(this.requestPost))
      } else {
        return false
      }
    },

    /**
     * 過去のデータで追加になったプロパティが無ければ追加
     * @param order オーダーデータ
     */
    setNewProperty(order) {
      // カテゴリコードがないもの
      if (!order.orderOthers) {
        order.orderOthers = []
      }
      // EV点検の作業開始年、月
      if (!order.evInspectFirstWorkYear) {
        order.evInspectFirstWorkYear = ''
      }
      if (!order.evInspectFirstWorkMonth) {
        order.evInspectFirstWorkMonth = []
      }
      return order
    },

    /**
     * 一覧へ遷移
     */
    async toList(val) {
      // 変更箇所があり、編集権限がある場合は警告
      if (this.isDirty() && this.canEdit) {
        const dialogResult = await dialogs.showWarningConfirmDialog('保存の確認', '変更が保存されませんがよろしいですか？')
        if (dialogResult != 'YES') {
          return
        }
      }

      if (val == 1) {
        this.$router.push({ name: 'RequestPostList', query: { main: true } })
      } else {
        this.$router.push({ name: 'TaskCalendar' })
      }

    },

    storeOriginal() {
      const tempRequestPost = utils.clone(this.requestPost)
      this.originalRequestPost = tempRequestPost
    },

    /**
     * 新規リクエストポスト生成
     */
    createNewrequestPost() {
      return requestPostManager.create()
    },

    /**
     * 保存
     * @param isTemporarySave 途中保存
     * @param isMail デンタツ協力会社メール送信成功
     * @param {*} mail デンタツメールの内容
     */
    async save(isTemporarySave, isMail, mail) {
      console.log('Save.')

      this.requestPost.temporarySaveFlag = isTemporarySave

      const validationResult = await this.validation(isTemporarySave)
      if (!validationResult) {
        return
      }

      try {
        this.isSaving = true

        let result
        let newFlag = false
        // 複数人登録で追加登録したメインタスク
        let multiRegistered = []

        const changeLimit = this.beforeSave()

        // 受注の場合
        if (this.isOrder) {
          // 過去の受注データ
          if (!this.requestPost.orderNew && this.editMode) {
            this.$refs.OrderComponents.orderDataEmit()
            this.requestPost.orderSummary = this.getOrderSummary()
          // 新受注データ（全て配列）
          } else {
            if (!await this.emitOrderNew()) {
              return
            }
          }

          this.requestPost.isConfirmationCommissionFlag = true

          // 更新
          if (this.requestPost.orderNo) {
            result = await orderManager.updateOrderData(this, this.requestPost)

          // 新規登録
          } else {
            this.requestPost.orderNew = true
            result = await orderManager.registerOrder(this, this.requestPost)
            newFlag = true

            if (result) {
              // 見積りステータスを受注にして保存
              this.estimateData.estimateStatus = '受注'

              // ログインユーザー名
              let name = this.$store.getters.user.user_name
              name = utils.deleteKana(name)

              // 受注の状態、登録者を保存
              this.estimateData.orderStatus = {
                status: '受注登録中',
                create: name,
                createDate: moment().format('YYYY-MM-DD HH:mm:ss')
              }
              // 更新
              let esResult = await estimateManager.updateEstimate(this, this.estimateData)
              if (!esResult) {
                await dialogs.showErrorDialog('更新エラー', 'ステータスを受注に切替できませんでした。')
                return false
              } else {
                logManager.recording(this, logManager.Loglevel.INFO, '見積', '受注', '見積（見積番号：' + this.requestPost.estimateNo + '）を受注しました。')
              }
            }
          }

          if (result) {
            if (this.requestPost.requestNo) {
              logManager.recordingByRegist(this, newFlag, '受注タスク', '受注タスク（お問い合わせ番号：' + this.requestPost.requestNo + '）')
            } else {
              logManager.recordingByRegist(this, newFlag, '受注タスク', '受注タスク')
            }

            await dialogs.showSuccessDialog('受注タスクの保存', '受注タスクを保存しました。')

            const dialogResult = await dialogs.showConfirmDialog('タスク依頼', '続けてタスク依頼を行いますか？', 'はい', 'いいえ')
            if (dialogResult === 'YES') {
              this.$router.push({ name: 'TaskRequest', query: { orderId: result, mode: '1' }})
            } else {
              this.$router.push({ name: 'RequestPostList' })
            }
          } else {
            await dialogs.showErrorDialog('受注タスクの保存', '受注タスクを保存できませんでした。')
          }

        // メインタスク
        } else {
          // 社員面接で採否が決まっていれば、採否編集不可フラグを立てる
          this.interviewsCannotEdit()
          // 雇い入れのフラグを確認
          this.checkEmploymentRegularStaff()

          // 更新
          if (this.requestPost.requestNo && this.requestPost._id) {
            // 録音確認タスクは、開いている間に AKBS の休み登録で履歴が足されることがある。古い内容で上書きしないよう、変わっていたら保存せずに開き直す
            if (await this.akbsRecordsChanged()) {
              this.isSaving = false
              return
            }
            result = await requestPostManager.update(this, this.requestPost)
          // 新規
          } else {
            result = await requestPostManager.register(this, this.requestPost)
            newFlag = true
          }

          if (result.id) {
            this.requestPost._id = result.id
            this.requestPost.requestNo = result.requestNo
            logManager.recordingByRegist(this, newFlag, 'メインタスク', 'メインタスク（お問い合わせ番号：' + result.requestNo + '）')

            // 複数人登録
            // ＊「複数人選択モーダル」で選択した場合のみ実行（新規登録時のみ）
            // ＊対象外カテゴリが混在している場合は実行しない
            //   （watchでクリアされるが、保存時にも念のため判定する）
            if (newFlag && this.isMultiRegistCategory && this.multiStaffList.length) {
              multiRegistered = await this.registMultiStaff()
              // 登録済みの選択は解除する（再保存で二重に登録しないため）
              this.multiStaffList = []
            }

            if (!this.forCustomers) {
              // 途中保存
              if (isTemporarySave) {
                // 社員面接タスク初期サブ
                await this.saveInterviewsSubTaskInit(result.id, result.requestNo)
                const log = await dialogs.showConfirmDialog('仮登録完了', '一覧に遷移しますか？', '一覧へ', 'このまま')
                // 見積りの場合
                if (log == 'YES') {
                  // 仮登録の場合はリクエストポスト一覧へ遷移
                  this.$router.push({ name: 'RequestPostList' })
                }

              // 保存
              } else {
                if (isMail && this.requestPost.category.includes('デンタツ') && this.requestPost.dentatsuCategory && this.requestPost.dentatsuCategory.includes('協力会社')) {
                  // デンタツ「協力会社」メール送信成功の場合
                  await dialogs.showSuccessDialog('メール送信成功・メインタスク保存', 'メール送信成功したので、メインタスクを保存しました。\nまた、メール内容をチャットに載せます。')
                } else if (multiRegistered.length) {
                  // 複数人登録
                  await dialogs.showSuccessDialog('メインタスクの保存', `メインタスクを ${multiRegistered.length + 1} 件（複数人登録）保存しました。`)
                } else {
                  await dialogs.showSuccessDialog('メインタスクの保存', 'メインタスクを保存しました。')
                }

                await this.setUserRetire()

                try {
                  await this.employmentSendChat(result.id, newFlag)
                  // 複数人登録の場合は、同じルームIDへの通知を連名で1通にまとめて送信する
                  if (multiRegistered.length) {
                    await this.sendChatWorkMessageForMultiStaff(result, multiRegistered, changeLimit, mail)
                  } else {
                    await this.sendChatWorkMessage(this.requestPost, result.id, changeLimit, mail)
                  }
                  // 社員面接タスク初期サブ
                  await this.saveInterviewsSubTaskInit(result.id, result.requestNo)

                  if (!await this.interviewsSendChat()) return
                } catch (e) {
                  console.log(e)
                }

                // 複写の場合は強制的にタスク依頼に遷移
                if (this.$route.query.mode == 3) {
                  await this.allCopy(result)

                // 複写でなければ選択させる
                } else {
                  // 雇い入れは、面接データを更新＆強制的にサブタスクへ
                  if (this.isShowCategoryItem('雇い入れ') || this.isShowCategoryItem('雇い入れ（社員）') || this.isShowCategoryItem('雇い入れ（清掃員）')) {
                    // 新規登録の場合、面接データを更新
                    if (newFlag) {
                      await requestPostManager.upDateInterviews(this, this.requestPost.interviewsId || this.interviewsId)

                      if (this.isShowCategoryItem('雇い入れ（清掃員）') && this.requestPost.dcNew2) {
                        await this.requireSaveSubTask(newFlag)
                        this.$refs.EmploymentDCNewComponents.toAkbsEmployment()
                        return
                      }

                    } else if (this.isShowCategoryItem('雇い入れ（清掃員）') && this.requestPost.dcNew2) {
                      await this.requireSaveSubTask(newFlag)

                      const dialogResult = await dialogs.showConfirmDialog('遷移先を選択', 'どちらに遷移しますか？', '雇用指示へ登録', '一覧')
                      if (dialogResult === 'YES') {
                        this.$refs.EmploymentDCNewComponents.toAkbsEmployment()
                      } else {
                        this.$router.push({ name: 'RequestPostList' })
                      }

                      return
                    }

                  // 面接関連+清掃員+最新コンポーネント
                  } else if (this.isShowCategoryItem('面接関連') && !this.requestPost.newGrad && !this.requestPost.interviewsRegularStaff && this.requestPost.dcNew2) {
                    if (newFlag) {
                      // 勤務情報入力画面へ
                      this.$refs.InterviewsDCNewComponents.toAkbsEmployment()
                    } else {
                      const dialogResult = await dialogs.showConfirmDialog('遷移先を選択', 'どちらに遷移しますか？', '雇用指示へ登録', '一覧')
                      if (dialogResult === 'YES') {
                        this.$refs.InterviewsDCNewComponents.toAkbsEmployment()
                      } else {
                        this.$router.push({ name: 'RequestPostList' })
                      }
                    }
                    return
                  }

                  // サブタスクが強制保存される場合
                  if (await this.requireSaveSubTask(newFlag)) {
                    await dialogs.showSuccessDialog('関連するサブタスクも保存', 'サブタスクも保存しました。ご確認ください。')
                    this.$router.push({ name: 'TaskRequest', query: { requestPostId: result.id }})
                  }

                  // // 非公開（始末書）は強制的にサブタスク
                  // if (this.isShowCategoryItem('非公開依頼') && (this.requestPost.apology || this.requestPost.reflect)) {
                  //   this.$router.push({ name: 'TaskRequest', query: { requestPostId: result.id }})

                  // // 新規＆デンタツの「清掃員（退職）」は強制的にサブタスク
                  // } else if (newFlag && this.isShowCategoryItem('デンタツ') && this.requestPost.dentatsuCategory.includes('清掃員（退職）')) {
                  //   this.$router.push({ name: 'TaskRequest', query: { requestPostId: result.id }})

                  // デンタツ、もしくは社員の面接
                  else if (this.requestPost.category.includes('デンタツ') || this.requestPost.category.includes('面接関連')) {
                    //サブタスク不要
                    this.$router.push({ name: 'RequestPostList' })
                  } else {
                    const dialogResult = await dialogs.showConfirmDialog('サブタスク登録', '続けてサブタスクを登録しますか？', 'はい', 'いいえ')
                    if (dialogResult === 'YES') {
                      this.$router.push({ name: 'TaskRequest', query: { requestPostId: result.id }})
                    } else {
                      this.$router.push({ name: 'RequestPostList' })
                    }
                  }
                }
              }
            } else {
              await dialogs.showSuccessDialog('メインタスクの保存', 'メインタスクを保存しました。フォームを終了いたします。')
              // お客様RPフォーム の場合は閉じる
              this.$pigeon.signout()
              window.close()
              this.saved = true
              await dialogs.showSuccessDialog('メインタスクの保存', 'タブを閉じてください。')
            }
          } else {
            // alert('保存できませんでした。')
            if (isTemporarySave) {
              await dialogs.showErrorDialog('メインタスクの仮登録', 'メインタスクを仮登録できませんでした。')
            } else {
              await dialogs.showErrorDialog('メインタスクの保存', 'メインタスクを保存できませんでした。')
            }
          }
        }

        this.storeOriginal()

        return result
      } finally {
        this.isSaving = false
      }
    },

    /**
     * 保存の前の共通処理（期限日の変更の履歴・短期の期限区分の固定）
     * @returns 期限日の変更の文（変更が無ければ空）
     */
    beforeSave() {
      // 期限日の変更があれば、履歴として残す
      let changeLimit = ''
      if (this.editMode && this.originalRequestPost && this.originalRequestPost.limitDate) {
        if (this.originalRequestPost.limitDate != this.requestPost.limitDate) {
          if (!this.requestPost.limitDateHistory) {
            this.requestPost.limitDateHistory = []
          }
          let short = ''
          if (this.originalRequestPost.limitDate > this.requestPost.limitDate) {
            short = '（短縮）'
          }
          const now = moment().format('M/D HH:mm')
          changeLimit = `${this.originalRequestPost.limitDate} ➡ ${this.requestPost.limitDate}${short}`

          const msg = `${changeLimit}（${this.userName} ${now}）`
          this.requestPost.limitDateHistory.push(msg)
        }
      }

      // 期限区分が短期の場合は、変更不可
      if (this.requestPost.kubunLimit == 1) {
        this.requestPost.kubunLimitDisabled = true
      }
      return changeLimit
    },

    /**
     * 新受注データ（OrderNewComponents）の入力を requestPost に取り込み、受注の入力チェックと要約を作る
     * @returns 入力チェックに引っかかれば false
     */
    async emitOrderNew() {
      this.$refs.OrderNewComponents.orderDataEmit()
      if (!await this.orderNewValidate()) {
        return false
      }
      this.requestPost.orderSummary = this.getOrderSummaryNew()
      return true
    },

    /**
     * 受注タスクの「契約詳細を登録」：受注タスクを保存してから契約詳細入力画面へ
     * 「更新」と同じ入力チェック・保存を通す（更新 → サブタスク画面 → 契約詳細、と回らなくても開始日などが保存されるように）
     * 入力チェックに引っかかれば保存せず、画面も移らない（直してもう一度押してもらう）
     * 参照モード・更新できない状態のときは保存せずに移る
     * @param route 契約詳細入力画面のルート
     */
    async saveAndToContractDetail(route) {
      const canSave = !this.referenceMode && this.canEdit && !this.saved && !this.isSaving && this.requestPost.orderNo
        && (this.mainAuth || (this.requestPost.category2[0] && this.requestPost.category2[0] == 'お客様直'))
      if (canSave && !await this.saveOrderQuietly()) {
        return
      }
      this.$router.push(route)
    },

    /**
     * 受注タスクを、ダイアログや遷移なしで保存する（「更新」と同じ入力チェック・保存）
     * @returns 保存できれば true
     */
    async saveOrderQuietly() {
      this.requestPost.temporarySaveFlag = false
      if (!await this.validation(false)) {
        return false
      }
      try {
        this.isSaving = true
        this.beforeSave()
        if (!await this.emitOrderNew()) {
          return false
        }
        this.requestPost.isConfirmationCommissionFlag = true
        const result = await orderManager.updateOrderData(this, this.requestPost)
        if (!result) {
          await dialogs.showErrorDialog('受注タスクの保存', '受注タスクを保存できませんでした。')
          return false
        }
        logManager.recordingByRegist(this, false, '受注タスク', '受注タスク（お問い合わせ番号：' + (this.requestPost.requestNo || '') + '）')
        this.storeOriginal()
        return true
      } finally {
        this.isSaving = false
      }
    },

    /**
     * サブタスク強制登録
     */
    async requireSaveSubTask(newFlag) {
      // 新規登録の場合のみ
      if (newFlag) {
        // メインのカテゴリー
        let cat = this.requestPost.category[0]
        // 雇い入れの場合
        if (cat.indexOf('雇い入れ') > -1) {
          cat = '雇い入れ'
        }
        const tar = taskRequestManager.getRequireSubTaskKeyWord(this.requestPost)
        if (tar) {
          this.savingSubTask = true

          const subTask = await taskRequestManager.initSubTask(this, this.requestPost, cat, tar)
          if (subTask.length) {
            for (let i = 0; i < subTask.length; i++) {
              const s = subTask[i]
              await taskRequestManager.register(this, s)
            }

            // すべて保存し終わってからチャット送信
            for (let i = 0; i < subTask.length; i++) {
              const s = subTask[i]
              await taskRequestManager.isSendChatWorkSubTaskAndSend(this, this.requestPost, s)
            }
            this.savingSubTask = false

            return true
          }
          this.savingSubTask = false
        }
      }
      return false
    },

    /**
     * 入力チェック
     * @param isTemporarySave 途中保存
     * @param beforeSendMail デンタツ協力会社メールの送信前のチェック（「メール送信していない」は見ない）
     */
    async validation(isTemporarySave, beforeSendMail) {
      // 社内/お客様
      if (!isTemporarySave && !this.validateCategory2.result) {
        await dialogs.showInfoDialog('入力確認', this.validateCategory2.message, 'OK')
        return false
      }

      // お問い合わせカテゴリー
      if (!isTemporarySave && !this.validateCategory.result) {
        await dialogs.showInfoDialog('入力確認', this.validateCategory.message, 'OK')
        return false
      }

      // 電話番号
      if(this.requestPost.category.indexOf('デンタツ') != -1) {
        if (!isTemporarySave && !this.validateTelephoneNumber.result) {
          await dialogs.showInfoDialog('入力確認', this.validateTelephoneNumber.message, 'OK')
          return false
        }
      }

      // タイトル
      if (this.forCustomers == false) {
        if (!this.validateInquiry_title.result) {
          await dialogs.showInfoDialog('入力確認', this.validateInquiry_title.message, 'OK')
          return false
        }
      }

      // お客様会社名
      if (!this.validateClientName.result) {
        await dialogs.showInfoDialog('入力確認', this.validateClientName.message, 'OK')
        return false
      }

      // お客様担当者名
      if (!isTemporarySave && !this.validateClientPersonName.result) {
        await dialogs.showInfoDialog('入力確認', this.validateClientPersonName.message, 'OK')
        return false
      }

      // メールアドレス
      if (!isTemporarySave && !this.validateClientMail.result) {
        await dialogs.showInfoDialog('入力確認', this.validateClientMail.message, 'OK')
        return false
      }

      if (this.emailInputCheck) {
        await dialogs.showInfoDialog('入力確認', '入力されたメールアドレスが正しくありません。', 'OK')
        return false
      }

      // アポロ管財依頼先部署
      if (!isTemporarySave && !this.validateToDepartment.result) {
        await dialogs.showInfoDialog('入力確認', this.validateToDepartment.message, 'OK')
        return false
      }

      // 担当者
      if (this.forCustomers == false) {
        if (!isTemporarySave && !this.validateToStaffName.result) {
          await dialogs.showInfoDialog('入力確認', this.validateToStaffName.message, 'OK')
          return false
        }
      }

      // 依頼主
      if (this.forCustomers == false) {
        if (!isTemporarySave && !this.validateByUser.result) {
          await dialogs.showInfoDialog('入力確認', this.validateByUser.message, 'OK')
          return false
        }
      }

      // 期限区分
      if (this.forCustomers == false && !this.requestPost.kubunLimit) {
        await dialogs.showInfoDialog('入力確認', '期限区分を選択してください', 'OK')
        return false
      }

      // 期限
      if (!this.validateLimitDate.result) {
        await dialogs.showInfoDialog('入力確認', this.validateLimitDate.message, 'OK')
        return false
      }

      // 契約無/契約有
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateNewNowFlag.result) {
          await dialogs.showInfoDialog('入力確認', this.validateNewNowFlag.message, 'OK')
          return false
        }
      }

      // 新規区分
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateNewClass.result) {
          await dialogs.showInfoDialog('入力確認', this.validateNewClass.message, 'OK')
          return false
        }
      }

      // 建物名
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateBuildingName.result) {
          await dialogs.showInfoDialog('入力確認', this.validateBuildingName.message, 'OK')
          return false
        }
      }

      // 都道府県
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateState.result) {
          await dialogs.showInfoDialog('入力確認', this.validateState.message, 'OK')
          return false
        }
      }

      // 市区郡
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateCity.result) {
          await dialogs.showInfoDialog('入力確認', this.validateCity.message, 'OK')
          return false
        }
      }

      // 階数
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateStairs.result) {
          await dialogs.showInfoDialog('入力確認', this.validateStairs.message, 'OK')
          return false
        }
      }

      // 戸数
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateHouseholds.result) {
          await dialogs.showInfoDialog('入力確認', this.validateHouseholds.message, 'OK')
          return false
        }
      }

      // 使用できる電源の有無
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateAvailablePowerFlag.result) {
          await dialogs.showInfoDialog('入力確認', this.validateAvailablePowerFlag.message, 'OK')
          return false
        }
      }

      // 駐車スペースの有無
      if(this.requestPost.category.indexOf('見積依頼') != -1) {
        if (!isTemporarySave && !this.validateParkingFlag.result) {
          await dialogs.showInfoDialog('入力確認', this.validateParkingFlag.message, 'OK')
          return false
        }
      }

      // 清掃希望回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドサービス') != -1) {
        if (!isTemporarySave && !this.validateCleanCount.result) {
          await dialogs.showInfoDialog('入力確認', this.validateCleanCount.message, 'OK')
          return false
        }
      }

      // ゴミ搬出有無
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドサービス') != -1) {
        if (!isTemporarySave && !this.validateDustRemoval.result) {
          await dialogs.showInfoDialog('入力確認', this.validateDustRemoval.message, 'OK')
          return false
        }
      }

      // ゴミ搬出回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドサービス') != -1 && this.requestPost.dustRemoval && this.requestPost.dustRemoval.length && this.requestPost.dustRemoval[0]=='有') {
        if (!isTemporarySave && !this.validateDustCount.result) {
          await dialogs.showInfoDialog('入力確認', this.validateDustCount.message, 'OK')
          return false
        }
      }

      // RLSトイレ回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドサービス') != -1 && this.isShowtToilet(this.requestPost.rlsToiletCleaning, '有料トイレ清掃あり')) {
        if (!isTemporarySave && !this.validateRlsToiletTimes.result) {
          await dialogs.showInfoDialog('入力確認', this.validateRlsToiletTimes.message, 'OK')
          return false
        }
      }

      // RLSトイレ回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドサービス') != -1 && this.isShowtToilet(this.requestPost.rlsToiletCleaning, '有料トイレ清掃あり')) {
        if (!isTemporarySave && !this.validateRlsToiletPlace.result) {
          await dialogs.showInfoDialog('入力確認', this.validateRlsToiletPlace.message, 'OK')
          return false
        }
      }

      // 清掃希望回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドプラス') != -1) {
        if (!isTemporarySave && !this.validatePlusCleanCount.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlusCleanCount.message, 'OK')
          return false
        }
      }

      // ゴミ搬出有無
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドプラス') != -1) {
        if (!isTemporarySave && !this.validatePlusDustRemoval.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlusDustRemoval.message, 'OK')
          return false
        }
      }

      // ゴミ搬出回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドプラス') != -1  && this.requestPost.plusDustRemoval && this.requestPost.plusDustRemoval.length && this.requestPost.plusDustRemoval[0]=='有') {
        if (!isTemporarySave && !this.validatePlusDustCount.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlusDustCount.message, 'OK')
          return false
        }
      }

      // RLSプラストイレ回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドプラス') != -1 && this.isShowtToilet(this.requestPost.plusToiletCleaning, '有料トイレ清掃あり')) {
        if (!isTemporarySave && !this.validatePlusToiletTimes.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlusToiletTimes.message, 'OK')
          return false
        }
      }

      // RLSプラストイレ回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドプラス') != -1 && this.isShowtToilet(this.requestPost.plusToiletCleaning, '有料トイレ清掃あり')) {
        if (!isTemporarySave && !this.validatePlusToiletPlace.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlusToiletPlace.message, 'OK')
          return false
        }
      }

      // RLSプラストイレ回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドプラス') != -1 && this.isShowtToilet(this.requestPost.plusToiletCleaningNormal, '有料トイレ清掃あり')) {
        if (!isTemporarySave && !this.validatePlusToiletTimesNormal.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlusToiletTimesNormal.message, 'OK')
          return false
        }
      }

      // RLSプラストイレ回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドプラス') != -1 && this.isShowtToilet(this.requestPost.plusToiletCleaningNormal, '有料トイレ清掃あり')) {
        if (!isTemporarySave && !this.validatePlusToiletPlaceNormal.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlusToiletPlaceNormal.message, 'OK')
          return false
        }
      }

      // 日常清掃
      if (this.requestPost.category.indexOf('見積依頼') != -1) {
        for (let index = 0; index < this.requestPost.everydayCleans.length; index++) {
          // 清掃希望回数
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('日常清掃') != -1) {
            if (!isTemporarySave && !this.validateEverydayCleanCount(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateEverydayCleanCount(index).message, 'OK')
              return false
            }
          }

          // 清掃希望時間
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('日常清掃') != -1) {
            if (!isTemporarySave && !this.validateEverydayCleanHours(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateEverydayCleanHours(index).message, 'OK')
              return false
            }
          }

          // 作業時間の指定の有無
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('日常清掃') != -1) {
            if (!isTemporarySave && !this.validateEverydayStartTimeFlag(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateEverydayStartTimeFlag(index).message, 'OK')
              return false
            }
          }

          // 指定作業開始時間
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.everydayCleans[index].everydayStartTimeFlag.indexOf('有') != -1) {
            if (!isTemporarySave && !this.validateEverydayStartTime(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateEverydayStartTime(index).message, 'OK')
              return false
            }
          }

          // 有料トイレ清掃回数
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.everydayCleans[index].toiletCleaning.indexOf('有料トイレ清掃あり') != -1 && this.requestPost.estimationCleanCategory.indexOf('日常清掃') != -1) {
            if (!isTemporarySave && !this.validateToiletTimes(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateToiletTimes(index).message, 'OK')
              return false
            }
          }

          // 有料トイレ清掃箇所数
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.everydayCleans[index].toiletCleaning.indexOf('有料トイレ清掃あり') != -1 && this.requestPost.estimationCleanCategory.indexOf('日常清掃') != -1) {
            if (!isTemporarySave && !this.validateToiletPlace(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateToiletPlace(index).message, 'OK')
              return false
            }
          }
        }
      }

      // 管理員業務
      if (this.requestPost.category.indexOf('見積依頼') != -1) {
        for (let index = 0; index < this.requestPost.managerWorks.length; index++) {
          // 清掃希望回数
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('管理員業務') != -1) {
            if (!isTemporarySave && !this.validateManagerWorkCount(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateManagerWorkCount(index).message, 'OK')
              return false
            }
          }

          // 清掃希望時間
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('管理員業務') != -1) {
            if (!isTemporarySave && !this.validateManagerWorkHours(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateManagerWorkHours(index).message, 'OK')
              return false
            }
          }

          // 作業時間の指定の有無
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('管理員業務') != -1) {
            if (!isTemporarySave && !this.validateManagerWorkTimeFlag(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateManagerWorkTimeFlag(index).message, 'OK')
              return false
            }
          }

          // 指定作業開始時間
          if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.managerWorks[index].managerWorkTimeFlag.indexOf('有') != -1) {
            if (!isTemporarySave && !this.validateManagerWorkTime(index).result) {
              await dialogs.showInfoDialog('入力確認', this.validateManagerWorkTime(index).message, 'OK')
              return false
            }
          }
        }
      }

      // 定期清掃
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('定期清掃') != -1) {
        for (let index = 0; index < this.requestPost.regularCleans.length; index++) {
          if (!isTemporarySave && !this.validateRegularClean(index, 'regularCleanContent').result) {
            await dialogs.showInfoDialog('入力確認', this.validateRegularClean(index, 'regularCleanContent').message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateRegularClean(index, 'regularCleanCount').result) {
            await dialogs.showInfoDialog('入力確認', this.validateRegularClean(index, 'regularCleanCount').message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateRegularClean(index, 'regularCleanUnitName').result) {
            await dialogs.showInfoDialog('入力確認', this.validateRegularClean(index, 'regularCleanUnitName').message, 'OK')
            return false
          }
        }
      }

      // 清掃希望回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ガラス清掃') != -1) {
        if (!isTemporarySave && !this.validateGlassCleanCount.result) {
          await dialogs.showInfoDialog('入力確認', this.validateGlassCleanCount.message, 'OK')
          return false
        }
      }

      // 希望回数
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('植栽剪定') != -1) {
        if (!isTemporarySave && !this.validatePlantingCount.result) {
          await dialogs.showInfoDialog('入力確認', this.validatePlantingCount.message, 'OK')
          return false
        }
      }

      // 特別清掃
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('特別清掃') != -1) {
        for (let index = 0; index < this.requestPost.specialCleans.length; index++) {
          if (!isTemporarySave && !this.validateSpecialCleanCount(index).result) {
            await dialogs.showInfoDialog('入力確認', this.validateSpecialCleanCount(index).message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateSpecialCleanContent(index).result) {
            await dialogs.showInfoDialog('入力確認', this.validateSpecialCleanContent(index).message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateSpecialCleanUnitName(index).result) {
            await dialogs.showInfoDialog('入力確認', this.validateSpecialCleanUnitName(index).message, 'OK')
            return false
          }
        }
      }

      // ラウンドサブメニュー
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationCleanCategory.indexOf('ラウンドサブメニュー') != -1) {
        for (let index = 0; index < this.requestPost.roundSubs.length; index++) {
          if (!isTemporarySave && !this.validateRoundSub(index, 'roundSubContent').result) {
            await dialogs.showInfoDialog('入力確認', this.validateRoundSub(index, 'roundSubContent').message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateRoundSub(index, 'roundSubCount').result) {
            await dialogs.showInfoDialog('入力確認', this.validateRoundSub(index, 'roundSubCount').message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateRoundSub(index, 'roundSubUnitName').result) {
            await dialogs.showInfoDialog('入力確認', this.validateRoundSub(index, 'roundSubUnitName').message, 'OK')
            return false
          }
        }
      }

      // その他作業
      if(this.requestPost.category.indexOf('見積依頼') != -1 && this.requestPost.estimationOtherCategory.indexOf('その他作業') != -1) {
        for (let index = 0; index < this.requestPost.otherWorks.length; index++) {
          if (!isTemporarySave && !this.validateOtherWorkContent(index).result) {
            await dialogs.showInfoDialog('入力確認', this.validateOtherWorkContent(index).message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateOtherWorkCount(index).result) {
            await dialogs.showInfoDialog('入力確認', this.validateOtherWorkCount(index).message, 'OK')
            return false
          }
          if (!isTemporarySave && !this.validateOtherWorkUnitName(index).result) {
            await dialogs.showInfoDialog('入力確認', this.validateOtherWorkUnitName(index).message, 'OK')
            return false
          }
        }
      }

      // 受注画面の入力チェック（過去の受注データの場合）
      if (this.isOrder && !this.requestPost.orderNew && this.editMode) {

        // 契約終了日
        if (!this.contractEndDateResult) {
          await dialogs.showInfoDialog('入力確認', this.contractEndDateMessage, 'OK')
          return false
        }

        // 区分
        if (!this.classificationResult) {
          await dialogs.showInfoDialog('入力確認', this.classificationMessage, 'OK')
          return false
        }

        // 特別清掃 作業項目
        if(this.requestPost.estimationDetailsCategoryCode.indexOf('14') != -1 && this.requestPost.orderSpecialCleans && this.requestPost.orderSpecialCleans.length > 0) {
          if (!this.specialCleanWorkItemResult) {
            await dialogs.showInfoDialog('入力確認', this.specialCleanWorkItemMessage, 'OK')
            return false
          }
        }
      }

      if (this.requestPost.category.includes('受注処理（新規・金額変更）')) {
        // 新規登録で見積が選択されていない
        if (this.mode != 6 && !Object.keys(this.estimateData).length) {
          await dialogs.showErrorDialog('見積を選択してください', 'どの見積を受注するか選択されていません。')
          return
        }
      }

      // 変更処理（解約・変更）チェック
      if (this.isShowCategoryItem('変更処理（解約・変更）')) {
        // スマイル移行後の新しい変更処理
        if (this.requestPost.dcNew2) {
          if (!await this.$refs.OrderChangeNewComponents.validation()) {
            return false
          }
        } else {
          if (!await this.$refs.OrderChangeComponents.validation()) {
            return false
          }
        }
      }

      if (this.requestPost.category[0].includes('雇い入れ')) {
        // 新しい清掃員雇入れ
        if (this.isShowCategoryItem('雇い入れ（清掃員）') && this.requestPost.dcNew2) {
          if (!await this.$refs.EmploymentDCNewComponents.validation()) return
        } else if (this.isShowCategoryItem('雇い入れ（清掃員）') && this.requestPost.dcNew) {
          if (!await this.$refs.EmploymentDCComponents.validation()) return
        } else {
          if (!await this.$refs.EmploymentComponents.validation()) return
        }
      }

      // 面接関連入力チェック（仮登録以外）
      if(!isTemporarySave && this.requestPost.category.indexOf('面接関連') != -1) {
        // 必須項目入力チェック

        // 新卒
        if (this.requestPost.newGrad) {
          if (!await this.$refs.InterviewsNewGradComponents.validation()) {
            return false
          }

        // 清掃員・中途
        } else {
          // 新しい清掃員面接
          if (!this.requestPost.interviewsRegularStaff && this.requestPost.dcNew2) {
            if (!await this.$refs.InterviewsDCNewComponents.validation()) return false

          // スマイル移行前の新しい清掃員面接
          } else if (!this.requestPost.interviewsRegularStaff && this.requestPost.dcNew) {
            if (!await this.$refs.InterviewsDCComponents.validation()) return false

          // 中途もしくは過去のDC
          } else {
            if (!await this.$refs.InterviewsComponents.validation()) return false
          }
        }
      }

      // デンタツ「協力会社」でメール送信していない場合（これから送信するときは見ない）
      if (!beforeSendMail && this.requestPost.category.includes('デンタツ') && this.requestPost.dentatsuCategory && this.requestPost.dentatsuCategory.includes('協力会社') && !this.isSendMail) {
        // 更新
        if (this.requestPost.requestNo && this.requestPost._id) {
          // メール本文の一つである依頼内容が変更されている場合
          if (this.originalRequestPost.inquiry_title != this.requestPost.inquiry_title) {
            await dialogs.showErrorDialog('依頼内容変更あり', '「依頼内容」 が変更されています。メールを送信しなければ保存できません。')
            return false
          }
        // 新規
        } else {
          await dialogs.showErrorDialog('メール送信していません', 'メール送信をしなければ保存できません。')
          return false
        }
      }

      return true
    },

    /**
     * 新受注データの登録チェック処理
     */
    async orderNewValidate() {
      if (!this.requestPost.contractDate) {
        await dialogs.showInfoDialog('入力確認', '契約開始日を選択してください。', 'OK')
        return false
      }

      if (!this.requestPost.contractEndDate) {
        await dialogs.showInfoDialog('入力確認', '契約終了日を選択してください。', 'OK')
        return false
      }

      if (Number(this.requestPost.contractDate.replace(/-/g, '')) > Number(this.requestPost.contractEndDate.replace(/-/g, ''))) {
        await dialogs.showInfoDialog('入力確認', '契約日が不正です。', 'OK')
        return false
      }

      if (!this.requestPost.classification || this.requestPost.classification.length == 0 || this.requestPost.classification[0] == '2') {
        await dialogs.showInfoDialog('入力確認', '区分を選択してください。', 'OK')
        return false
      }

      // 特別清掃がある場合
      if (this.requestPost.orderSpecialCleans && this.requestPost.orderSpecialCleans.length) {
        for (let i = 0; i < this.requestPost.orderSpecialCleans.length; i++) {
          let sp = this.requestPost.orderSpecialCleans[i]
          for (let j = 0; j < sp.details.length; j++) {
            const det = sp.details[j]
            // 調整費以外で作業項目を選択していない場合は、アラートを出す
            if (det.content.indexOf('調整費') == -1 && det.workItem == null) {
              await dialogs.showInfoDialog('入力確認', '特別清掃 【' + det.content +'】の作業項目は必須入力です。業務項目を入力してください。', 'OK')
              return false
            }
          }
        }
      }

      // テンプレート未反映の場合
      if (!this.requestPost.template) {
        const log = await dialogs.showConfirmDialog('配信テンプレート', '配信テンプレートが未反映です。よろしいでしょうか？')
        if (log != 'YES') {
          return false
        }
      }
      return true
    },

    /**
     * 担当者選択イベント
     */
    selectedStaffName(e) {
      this.requestPost.toStaffName = e.userName
      this.requestPost.toStaffId = e.userId || ''

      // 担当者を選択した場合、担当者の部署名をアポロ管財依頼先部署にセット
      if (this.requestPost.category.includes('デンタツ') || this.requestPost.category.includes('AKBS休み登録')) {
        // デンタツの場合
        if (e.transDepId) {
          let transDepartmentList = this.$store.getters.transDepartmentList
          let dep = transDepartmentList.find((t) => {
            return t.departmentId == e.transDepId
          })
          this.requestPost.toDepartment = dep.name
          this.requestPost.toDepartmentId = e.transDepId
          this.getStaffNameList(e.transDepId, false)
        }
      } else {
        // デンタツ以外の場合
        if (e.departmentId) {
          let departmentList = this.$store.getters.departmentList
          let dep = departmentList.find((d) => {
            return d.departmentId == e.departmentId
          })
          this.requestPost.toDepartment = dep.name
          this.requestPost.toDepartmentId = e.departmentId
          this.getStaffNameList(e.departmentId, false)
        }
      }
    },

    /**
     * 担当者変更イベント
     */
    changeStaffName() {
      if (this.requestPost.toStaffName == '') {
        this.requestPost.toStaffId = ''
      }
    },

    /**
     * 担当者 候補ラベル（検索対象）
     * 受注モードは氏名のみ、それ以外は「部署名＋氏名」（dispName）
     */
    staffOptionLabel(option) {
      if (!option) {
        return ''
      }
      if (this.isOrder) {
        return option.userName || ''
      }
      return option.dispName || option.userName || ''
    },

    /**
     * 担当者 選択後の表示ラベル（氏名のみ）
     */
    staffSelectedLabel(option) {
      return option ? (option.userName || '') : ''
    },

    /**
     * 担当者 Multiselect 選択／クリア
     */
    onSelectToStaff(staff) {
      if (!staff) {
        this.requestPost.toStaffId = ''
        this.requestPost.toStaffName = ''
        return
      }
      // 名前とIDを同じオブジェクトから同時に代入（部署の自動セットは既存処理に任せる）
      this.selectedStaffName(staff)
    },

    /**
     * アポロ管財依頼先部署 Multiselect 選択／クリア
     */
    onSelectToDepartment(dep) {
      if (!dep) {
        this.requestPost.toDepartment = ''
        this.toDepartmentChanged() // toDepartmentIdクリア＋担当者リストを全員へ
        return
      }
      // 今まではv-modelがtoDepartmentに名前を入れていたので、ここで明示的に代入する
      this.requestPost.toDepartment = dep.name
      this.toDepartmentSelected(dep)
    },

    /**
     * 依頼主 Multiselect 選択／クリア
     */
    onSelectByUser(user) {
      if (!user) {
        this.requestPost.byUser = ''
        this.requestPost.byUserId = ''
        return
      }
      this.requestPost.byUser = user.user_name
      this.requestPost.byUserId = user.id
    },

    /**
     * 担当者（非公開依頼）変更イベント
     */
    changeToStaff(e) {
      if (e) {
        this.requestPost.toStaffId = e.value
        this.requestPost.toStaffName = e.text
      }

      // 担当者選択 → 部署指定
      const staff = this.toStaffNameList.find(user => user.userId == this.requestPost.toStaffId);
      if (staff && staff.departmentId) {
        let departmentList = this.$store.getters.departmentList
        let dep = departmentList.find((d) => {
          return d.departmentId == staff.departmentId
        })
        if (dep) {
          this.requestPost.toDepartment = dep.name
          this.requestPost.toDepartmentId = staff.departmentId
          this.getStaffNameList(this.requestPost.toDepartmentId, false)
        }
      }
    },

    /**
     * 依頼主（非公開依頼）変更イベント
     */
    changeByStaff(e) {
      if (e) {
        this.requestPost.byUserId = e.value
        this.requestPost.byUser = e.text
      }
    },

    /**
     * 担当者から担当者（非公開依頼）へ反映
     */
    staffNameToToStaff() {
      if (this.requestPost && this.requestPost.toStaffId) {
        let val = this.toStaffNameList.find(st => st.userId == this.requestPost.toStaffId)
        if (val) {
          this.selectedStaffValue = {
            value: val.userId,
            text: val.userName
          }
        }
      } else {
        this.selectedStaffValue = null
      }
    },

    /**
     * 担当者（非公開依頼）から担当者へ反映
     */
    toStaffToStaffName() {
      if (this.selectedStaffValue && this.selectedStaffValue.value) {
        let val = this.toStaffNameList.find(st => st.userId == this.selectedStaffValue.value)
        if (val) {
          this.requestPost.toStaffId = val.userId
          this.requestPost.toStaffName = val.userName
        }
      } else {
        this.requestPost.toStaffId = ''
        this.requestPost.toStaffName = ''
      }
    },

    /**
     * 依頼者から依頼者（非公開依頼）へ反映
     */
    byUserToSByUser() {
      if (this.requestPost && this.requestPost.byUserId) {
        let val = this.$store.getters.userList.find(st => st.id == this.requestPost.byUserId)
        if (val) {
          this.selectedByUserValue = {
            value: val.id,
            text: val.user_name
          }
        }
      } else {
        this.selectedByUserValue = null
      }
    },

    /**
     * 依頼者（非公開依頼）から依頼者へ反映
     */
    sByUserToByUser() {
      if (this.selectedByUserValue && this.selectedByUserValue.value) {
        let val = this.$store.getters.userList.find(st => st.id == this.selectedByUserValue.value)
        if (val) {
          this.requestPost.byUser = val.user_name
          this.requestPost.byUserId = val.id
        }
      } else {
        this.requestPost.byUser = ''
        this.requestPost.byUserId = ''
      }
    },

    /**
     * 依頼主プルダウン 表示
     */
    async byUserSelected(selectedUser) {
      this.requestPost.byUserId = selectedUser.id
    },

    byUserNameChanged(byUserName) {
      if (byUserName === '') {
        this.requestPost.byUserId = ''
      }
    },

    /**
     * アポロ管財依頼先部署選択イベント
     */
    async toDepartmentSelected(value) {
      if(value.departmentId){
        // 所属部署データ取得
        this.getStaffNameList(value.departmentId, true)
        this.requestPost.toDepartmentId = value.departmentId
        this.departmentInfo = value

        // 担当者が所属部署の人ではない場合は空にする
        let result = this.toStaffNameList.find((u) => {
          return u.userId == this.requestPost.toStaffId
        })
        if (!result || !result.userId) {
          this.requestPost.toStaffId = ''
          this.requestPost.toStaffName = ''
          this.selectedStaffValue = null
        }

        // デンタツの場合
        if (this.isShowCategoryItem('デンタツ')) {
          // 物件住所があり+建物管理部の場合
          if (this.requestPost.siteAddress && (value.name.includes('建物管理部東京') || value.name.includes('東京西'))) {
            // エリアが登録されているスタッフを取得
            const res = await backend.searchData('user/getUserArea')
            if (res.data.data && res.data.data.length) {
              const users = res.data.data

              for (let i = 0; i < users.length; i++) {
                const u = users[i]
                if (u.areas && u.areas.length) {

                  for (let j = 0; j < u.areas.length; j++) {
                    const a = u.areas[j]
                    // 該当住所が担当の場合
                    if (this.requestPost.siteAddress.includes(a)) {

                      // 担当者リストに該当者いる場合
                      const user = this.toStaffNameList.find((s) => {
                        return s.userId == u.id
                      })

                      if (user && user.userId) {
                        this.selectedStaffName(user)
                        await dialogs.showInfoDialog('担当者セット', '物件住所エリア担当の' + user.userName + 'さんをセットしました。\r\nエリアの確認は「担当エリア編集（勤怠・建物）」をクリックしてください。\r\n\r\n＊依頼先部署が建物管理部に変更時のみ、自動でセット＊')
                        return
                      } else {
                        break
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        this.toStaffNameList = []
        this.toStaffSelections = []
      }
    },

    /**
     * アポロ管財依頼先部署 変更イベント
     */
    toDepartmentChanged() {
      if (this.requestPost.toDepartment == '') {
        this.requestPost.toDepartmentId = ''
        this.getStaffNameList()
      }
    },

    /**
     * 添付ファイル
     */
    attachmentChange(targetAttachmentName, attachmentInfo) {
      if (!this.requestPost[targetAttachmentName]) {
        this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
      }
      if (attachmentInfo) {
        this.requestPost[targetAttachmentName].originalName = attachmentInfo.filename
        this.requestPost[targetAttachmentName].content = attachmentInfo.content
      } else {
        this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
      }
    },

    /**
     * お問い合わせカテゴリー 表示フラグ
     */
    isShowCategoryItem(category) {
      if (this.requestPost.category && this.requestPost.category.length > 0) {
        if (category == '見積依頼') {
          this.estimateFlag = this.requestPost.category.indexOf(category) > -1
        }
        return this.requestPost.category.indexOf(category) > -1
      } else {
        this.estimateFlag = false
        return false
      }
    },

    /**
     * 添付資料追加 表示フラグ
     */
    isShowAddFileBtnItem(category) {
      if (this.requestPost.addFileBtn) {
        return this.requestPost.addFileBtn.indexOf(category) > -1
      } else {
        return false
      }
    },

    /**
     * 御見積_清掃カテゴリー 表示フラグ
     */
    isShowEstimationCleanCategoryItem(category) {
      if (this.requestPost.estimationCleanCategory && this.requestPost.estimationCleanCategory.length > 0) {
        return this.requestPost.estimationCleanCategory.indexOf(category) > -1
      } else {
        return false
      }
    },

    /**
     * 日常清掃 祝日対応の有無
     */
    isEverydayHolidayFlag(index) {
      if (this.requestPost.everydayCleans[index].everydayHolidayFlag && this.requestPost.everydayCleans[index].everydayHolidayFlag.length > 0) {
        return (this.requestPost.everydayCleans[index].everydayHolidayFlag.indexOf('有') > -1 || this.requestPost.everydayCleans[index].everydayHolidayFlag.indexOf('不明') > -1)
      } else {
        return false
      }
    },

    /**
     * 管理業務 祝日対応の有無
     */
    isManagerWorkHolidayFlag(index) {
      if (this.requestPost.managerWorks[index].managerWorkHolidayFlag && this.requestPost.managerWorks[index].managerWorkHolidayFlag.length > 0) {
        return (this.requestPost.managerWorks[index].managerWorkHolidayFlag.indexOf('有') > -1 || this.requestPost.managerWorks[index].managerWorkHolidayFlag.indexOf('不明') > -1)
      } else {
        return false
      }
    },

    /**
     * 作業時間の指定の有無 表示フラグ
     */
    isShowEverydayStartTimeFlagItem(category, index) {
      if (this.requestPost.everydayCleans[index].everydayStartTimeFlag && this.requestPost.everydayCleans[index].everydayStartTimeFlag.length > 0) {
        return this.requestPost.everydayCleans[index].everydayStartTimeFlag.indexOf(category) > -1
      } else {
        return false
      }
    },

    isShowManagerWorkTimeFlagItem(category, index) {
      if (this.requestPost.managerWorks[index].managerWorkTimeFlag && this.requestPost.managerWorks[index].managerWorkTimeFlag.length > 0) {
        return this.requestPost.managerWorks[index].managerWorkTimeFlag.indexOf(category) > -1
      } else {
        return false
      }
    },

    /**
     * 御見積_点検カテゴリー 表示フラグ
     */
    isShowEstimationInspectCategoryItem(category) {
      if (this.requestPost.estimationInspectCategory && this.requestPost.estimationInspectCategory.length > 0) {
        return this.requestPost.estimationInspectCategory.indexOf(category) > -1
      } else {
        return false
      }
    },

    /**
     * 有料トイレ清掃あり/有料トイレ清掃無し 表示フラグ_RLS,RLSプラス
     */
    isShowtToilet(rp, category) {
      if (rp && rp.length > 0) {
        return rp[0].indexOf(category) > -1
      } else {
        return false
      }
    },

    /**
     * 有料トイレ清掃あり/有料トイレ清掃無し 表示フラグ
     */
    isShowtToiletCleaningItem(category, index) {
      if (this.requestPost.everydayCleans[index].toiletCleaning && this.requestPost.everydayCleans[index].toiletCleaning.length > 0) {
        return this.requestPost.everydayCleans[index].toiletCleaning.indexOf(category) > -1
      } else {
        return false
      }
    },

    /**
     * 御見積_その他カテゴリー 表示されているかのチェック
     */
    isShowEstimationOtherCategoryItem(category) {
      if (this.requestPost.estimationOtherCategory && this.requestPost.estimationOtherCategory.length > 0) {
        return this.requestPost.estimationOtherCategory.indexOf(category) > -1
      } else {
        return false
      }
    },

    /**
     * 戸数 変更イベント
     */
    houseHoldsChange() {
      if (this.requestPost.category2[0] && this.requestPost.category2[0] == 'お客様直') {
        // 清掃希望回数をクリア
        this.requestPost.cleanCount = []
        this.requestPost.plusCleanCount = []
        // ゴミ搬出をクリア
        this.requestPost.dustRemoval = []
        this.requestPost.plusDustRemoval = []
        this.requestPost.dustCount = []
        this.requestPost.plusDustCount = []
      }
    },

    /**
     * 得意先モーダル検索イベント
     */
    openClientModal() {
      this.dataSelectorShow = true
    },

    /**
     * 「得意先の選択」モーダルでの得意先選択イベント
     */
    modalClientSelected(target) {
      this.dataSelectorShow = false
      this.clientSelected(target)
    },

    /**
     * 得意先選択イベント
     */
    async clientSelected(selectedClient) {
      // 選択したお客様情報を表示
      this.requestPost.clientName = selectedClient.clientName + ' ' + selectedClient.clientDepartmentName

      // 得意先名
      this.requestPost.clientName1 = selectedClient.clientName
      // 支店名
      this.requestPost.clientName2 = selectedClient.clientDepartmentName

      // リクエストポストのデータにお客様コードを追加
      this.requestPost.clientCode = selectedClient.clientCode

      // 住所
      this.requestPost.clientAddress1 = selectedClient.address1
      this.requestPost.clientAddress2 = selectedClient.address2

      // 得意先に紐づく物件を取得
      this.getBuildingListByClient()

      // 受注の場合
      if (this.isShowCategoryItem('受注処理（新規・金額変更）')) {
        this.$refs.OrderNewComponents.clientSelected(selectedClient.clientCode)
      }
      this.reload++
    },

    /**
     * 得意先変更イベント
     * @param clientName 入力値
     */
    clientNameChanged(clientName) {
      if (!clientName) {
        this.requestPost.clientName = ''
        this.requestPost.clientName1 = ''
        this.requestPost.clientName2 = ''
        this.requestPost.clientCode = ''
        this.requestPost.clientAddress1 = ''
        this.requestPost.clientAddress2 = ''
      }
      this.reload++
    },

    /**
     * お問い合わせ内容 変更イベント
     */
    noteChange(){
      this.noteLinks = this.getNoteLinks()
    },

    /**
     * お問い合わせ内容 リンク取得
     */
    getNoteLinks(){
      var ret = []
      var note = this.requestPost.note
      var rows = note.split('\n')

      for (let ridx = 0; ridx < rows.length; ridx++) {
        var row = rows[ridx]
        row = row.trim()
        var add = ''
        if (row.indexOf('http://') >= 0) {
          add = row.substring(row.indexOf('http://'))
          ret.push(add)
        } else if (row.indexOf('https://') >= 0) {
          add = row.substring(row.indexOf('https://'))
          ret.push(add)
        }
      }
      return ret
    },

    /**
     * 郵便番号より住所検索
     */
    addressSearch(){
      var geocoder = new window.google.maps.Geocoder()
      var pattern = /^[0-9]{3}-?[0-9]{4}$/

      if(this.requestPost.postalCode) {
        var postalCode = this.requestPost.postalCode
        if (postalCode) {
          //入力値が正しいか
          if (pattern.test(postalCode)) {
            //住所を取得
            geocoder.geocode ({
              address:postalCode,
              language:"ja",
              region:"jp"
            }, this.addressSearchCb)
          } else {
            alert("入力が3桁-4桁の形式であるか確認してください。")
          }
        } else {
          alert("郵便番号を入力をしてください。")
        }
      }
      this.reload++
    },

    /**
     * 郵便番号より住所検索 CallBack
     */
    addressSearchCb(results, status) {
      if (status == window.google.maps.GeocoderStatus.OK) {
        if (results.length > 0){
          if (results[0].geometry) {
            if(results[0].address_components[4].long_name == '日本') {
              this.requestPost.state = results[0].address_components[3].long_name
              this.requestPost.city = results[0].address_components[2].long_name
              this.requestPost.street = results[0].address_components[1].long_name
            } else {
              this.requestPost.state = results[0].address_components[4].long_name
              this.requestPost.city = results[0].address_components[3].long_name + results[0].address_components[2].long_name
              this.requestPost.street = results[0].address_components[1].long_name
            }
          }
        }
      } else {
        if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
          alert("郵便番号 " + this.requestPost.postalCode + "は見つかりませんでした。")
        } else {
          alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
        }
      }
      this.reload++
    },

    /**
     * 住所より郵便番号検索
     */
    postalCodeSearch(){
      var geocoder = new window.google.maps.Geocoder()

      var state = this.requestPost.state
      var city = this.requestPost.city
      var street = this.requestPost.street

      if (state && city && street) {
        var unionAddress = state + city + street
        geocoder.geocode({
          address:unionAddress,
          language:"ja",
          region:"jp"
        }, this.postalCodeSearchCb)
      } else {
        if (state && city){
          alert("町名・番地を入力してください")
        } else if (state) {
          alert("市区郡,町名・番地を入力してください")
        } else if (street && city){
          alert("都道府県を入力してください")
        } else if (street) {
          alert("都道府県,市区郡を入力してください")
        } else if (city) {
          alert("都道府県,町名・番地を入力してください")
        } else {
          alert("都道府県,市区郡,町名・番地を入力してください")
        }
      }
      this.reload++
    },

    /**
     * 住所より郵便番号検索 CallBack
     */
    postalCodeSearchCb(results, status) {
      //アラート用フラグ
      var flag = false
      var ret = this.requestPost

      if (status == window.google.maps.GeocoderStatus.OK) {
        if (results.length > 0) {
          if (results[0].geometry) {
            var result = results[0].address_components;
            result.forEach(function(returnData) {
              returnData.types.forEach(function(getType) {
                if (getType == 'postal_code') {
                  ret.postalCode = returnData.long_name
                  flag = true
                }
              })
            })
          }
        }
        if (flag == false) {
          alert("郵便番号が見つかりませんでした。")
        }
      } else {
        if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
          alert(this.requestPost.state + this.requestPost.city + this.requestPost.street + "の郵便番号は見つかりませんでした。")
        } else {
          alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
        }
      }
      this.reload++
    },

    /**
     * 見積依頼の選択を外した際に、非表示なる項目の中を初期値に戻す
     */
    estimateItemRefresh() {

      if (!this.estimateFlag) {
        this.requestPost.newNowFlag = []
        this.requestPost.newClass = []
        this.requestPost.estimationCleanCategory = []
        this.requestPost.estimationInspectCategory = []
        this.requestPost.estimationOtherCategory = []
        this.requestPost.buildingName = ''
        this.requestPost.stairs = ''
        this.requestPost.households = ''
        this.requestPost.estimationReason = ''
        this.requestPost.availablePowerFlag = []
        this.requestPost.apartmentType = []
        this.requestPost.parkingFlag = []
        this.requestPost.availableToiletFlag = []
        this.requestPost.cleanCount = []
        this.requestPost.dustRemoval = []
        this.requestPost.dustCount = []
        this.requestPost.rlsToiletCleaning = []
        this.requestPost.rlsToiletTimes = ''
        this.requestPost.rlsToiletPlace = ''
        this.requestPost.plusCleanCount = []
        this.requestPost.plusToiletCleaning = []
        this.requestPost.plusToiletTimes = ''
        this.requestPost.plusToiletPlace = ''
        this.requestPost.plusCleanCount = []
        this.requestPost.plusDustRemoval = []
        this.requestPost.plusDustCount = []
        this.requestPost.residenceType = []
        this.requestPost.everydayCleans = []
        this.requestPost.managerWorks = []
        this.requestPost.regularCleans = []
        this.requestPost.regularCleanImage = {}
        this.requestPost.regularCleanImage2 = {}
        this.requestPost.regularCleanImage3 = {}
        this.requestPost.regularCleanWorkWay = ''
        this.requestPost.glassCleanCount = ''
        this.requestPost.glassCleanImage = {}
        this.requestPost.glassCleanImage2 = {}
        this.requestPost.glassCleanImage3 = {}
        this.requestPost.glassCleanWorkWay = []
        this.requestPost.plantingCount = ''
        this.requestPost.plantingPlaceFile = {}
        this.requestPost.plantingPlaceFile2 = {}
        this.requestPost.plantingPlaceFile3 = {}
        this.requestPost.plantingReportFile = {}
        this.requestPost.plantingReportFile2 = {}
        this.requestPost.plantingReportFile3 = {}
        this.requestPost.specialCleans = []
        this.requestPost.specialCleanImage = {}
        this.requestPost.specialCleanImage2 = {}
        this.requestPost.specialCleanImage3 = {}
        this.requestPost.roundSubs = []
        this.requestPost.fireInspectReport = {}
        this.requestPost.fireInspectReport2 = {}
        this.requestPost.fireInspectReport3 = {}
        this.requestPost.constructionEquipmentInspectReport = {}
        this.requestPost.constructionEquipmentInspectReport2 = {}
        this.requestPost.constructionEquipmentInspectReport3 = {}
        this.requestPost.specificInspectReport = {}
        this.requestPost.specificInspectReport2 = {}
        this.requestPost.specificInspectReport3 = {}
        this.requestPost.evInspectContent = []
        this.requestPost.evInspectFile = {}
        this.requestPost.evInspectFile2 = {}
        this.requestPost.evInspectFile3 = {}
        this.requestPost.evInspectMaker = ''
        this.requestPost.evInspectMakeYear = ''
        this.requestPost.postalCode = ''
        this.requestPost.state = ''
        this.requestPost.city = ''
        this.requestPost.street = ''
        this.requestPost.building = ''
        this.requestPost.otherWorks = []
        this.requestPost.roundServiceMemo = ''
        this.requestPost.roundPlusMemo = ''
        this.requestPost.everydayCleanMemo = ''
        this.requestPost.managerWorkMemo = ''
        this.requestPost.regularCleanMemo = ''
        this.requestPost.glassCleanMemo = ''
        this.requestPost.estimationDorainPipeMemo = ''
        this.requestPost.estimationWaterTankMemo = ''
        this.requestPost.plantingMemo = ''
        this.requestPost.specialCleanMemo = ''
        this.requestPost.roundSubMemo = ''
      }
    },

    /**
     * カテゴリ２ change イベント
     */
    category2Changed() {
      // 社内の場合は、お客様項目必須解除
      this.isClientRequired = (this.requestPost.category2 != '社内')
    },

    /**
     * カテゴリ change イベント
     * @param category 選択値
     * @param isOperation 変更あり
     */
    async categoryChanged(category, isOperation) {
      if (category.includes('受注処理（新規・金額変更）')) {
        // 受注以外に他のカテゴリーを選択した場合、他のカテゴリーを消す
        if (category.length > 1) {
          await dialogs.showErrorDialog('受注処理を選択しています。', '受注処理を選択した場合は、他のカテゴリーは選択できません。')
          this.requestPost.category = ['受注処理（新規・金額変更）']
        }
        // 受注処理
        this.setOrderData()

      // 受注にしていたが、他のカテゴリに変更した場合
      } else if (this.isOrder) {
        this.requestPost = requestPostManager.create()
        this.estimateData = {}
        // 担当者・依頼主にログインユーザーをセット
        this.setDefaultStaff()
        this.isOrder = false
        this.isCategory = true
        this.isClientRequired = true
        // スタッフリスト生成
        this.getStaffNameList(this.requestPost.toDepartmentId, false)
      }

      if (category.includes('雇い入れ（清掃員）') || category.includes('雇い入れ（社員）')) {
        // 雇い入れ以外に他のカテゴリーを選択した場合、他のカテゴリーを消す
        if (category.length > 1) {
          await dialogs.showErrorDialog('雇い入れを選択しています。', '雇い入れを選択した場合は、他のカテゴリーは選択できません。')
          if (category.includes('雇い入れ（清掃員）')) {
            this.requestPost.category = ['雇い入れ（清掃員）']
          }
          if (category.includes('雇い入れ（社員）')) {
            this.requestPost.category = ['雇い入れ（社員）']
          }
        }
        if (category.includes('雇い入れ（清掃員）')) {
          this.requestPost.employmentRegularStaff = false
        }
        if (category.includes('雇い入れ（社員）')) {
          this.requestPost.employmentRegularStaff = true

          // 雇い入れ選択ダイアログ表示
          if (isOperation) this.selectInterviewsForEmployment = true
        }

      } else if (category.includes('デンタツ')) {
        // 清掃員リスト取得
        this.getAkbsStaffList()
        // 物件リスト取得
        await this.getAllEmploymentBuildingList()
        this.getEmploymentBuildingList()
      } else if (isOperation && category.includes('面接関連')) {
        await this.InterviewsDialog()
      }

      if (isOperation) {
        this.setTitle()
      }

      if (!this.isOrder) {
        if (category.includes('デンタツ') || category.includes('AKBS休み登録')) {
          if (category.includes('デンタツ')) {
            this.isTransmission = true
          } else {
            this.isTransmission = false
          }

          // 担当者、アポロ管財依頼先部署をクリア
          if (isOperation) {
            this.requestPost.toStaffName = ''
            this.requestPost.toStaffId = ''
            this.requestPost.toDepartment = ''
            this.requestPost.toDepartmentId = ''
          }
        } else {
          // デンタツを選択していたが、他のカテゴリに変更した場合、担当者・アポロ管財依頼先部署をクリア
          if (this.isTransmission) {
            this.requestPost.toStaffName = ''
            this.requestPost.toStaffId = ''
            this.requestPost.toDepartment = ''
            this.requestPost.toDepartmentId = ''
          }
          this.isTransmission = false

          // if (category.includes('雇い入れ')) {
          //   this.isCategory = false
          // }
        }
        // 社内/お客様、タイトル、お客様項目の必須設定
        this.isOutsideRequired = (this.requestPost.category != 'デンタツ')

        // デンタツの場合、アポロ管財依頼先部署はデンタツ用部署のみ表示
        // デンタツ以外、アポロ管財依頼先部署はデンタツ用部署は非表示
        let filterDepartmentList
        if (this.requestPost.category.includes('デンタツ') || this.requestPost.category.includes('AKBS休み登録')) {
          // デンタツ部署のリスト取得
          filterDepartmentList = this.$store.getters.transDepartmentList
        } else {
          // デンタツ以外の部署のリスト取得
          filterDepartmentList = this.$store.getters.departmentList
        }
        this.toDepartmentList = filterDepartmentList
        // 担当者リスト 生成
        this.getStaffNameList()
      }

      // 見積依頼の場合、社内/お客様は「お客様」を選択
      if (isOperation) {
        if (category.includes('見積依頼') && !this.forCustomers) {
          this.requestPost.category2 = ['お客様']
          this.category2Changed()
        }
      }

      if (category.includes('見積依頼') && !this.forCustomers) {
        // 得意先メールアドレスマスタ取得
        this.getClientMailMst(1)
      }

      // 「非公開依頼」の場合は、Suggest OFF
      this.isStaffSuggest = !this.requestPost.category.includes('非公開依頼')

      // 選択担当者連携
      if (isOperation) {
        if (this.requestPost.category.includes('非公開依頼')) {
          this.staffNameToToStaff()
          this.byUserToSByUser()
        } else if (category.includes('雇い入れ（清掃員）')) {
          this.requestPost = requestPostManager.setEmployFromInterview(this.$store.getters.user, null, this.requestPost)
          this.category2Changed()
        } else {
          this.toStaffToStaffName()
          this.sByUserToByUser()
        }
      }

      if (category.includes('面接関連')){
        if(!this.requestPost.interviewsBirthDay || this.requestPost.interviewsBirthDay == ''){
          this.requestPost.interviewsBirthDay = this.getInitBirthDate()
        }
      } else {
        this.requestPost.interviewsBirthDay = ''
        this.requestPost.interviewsAge = ''
      }

      // 見積り依頼、変更処理の場合、物件リストを取得（新しい変更処理は得意先を選んでから物件を取るので不要。完了済みも不要）
      if (this.requestPost.status != 'done' && (category.includes('見積依頼') || (category.includes('変更処理（解約・変更）') && !this.requestPost.dcNew2))) {
        await this.getBuildingList()
      }
      this.reload++
    },

    /**
     * メアドマスタ取得
     */
    async getClientMailMst(type) {
      const res = await backend.searchData('mail/getData', { type })
      if (res.data.data && res.data.data.length) {
        this.mailListAll = res.data.data
        this.mailList = res.data.data
      }
    },

    /**
     * 始末書、反省文チェックボックス
     */
    changeApologyOrReflect(val) {
      if (this.requestPost.apology || this.requestPost.reflect) {
        let type = '始末書'
        if (val == 2) {
          type = '反省文'
          this.requestPost.apology = false
        } else {
          this.requestPost.reflect = false
        }

        // 社内
        this.requestPost.category2 = ['社内']
        this.category2Changed()

        // タイトル
        this.requestPost.inquiry_title = type + '提出依頼'

        // お問い合わせ内容
        this.requestPost.note = '期限までに総務に' + type + '提出をお願いいたします。'

        // 期限は1ヶ月先
        this.requestPost.kubunLimit = 1
        this.requestPost.limitDate = moment().add(1, 'M').format('YYYY-MM-DD')
      }
    },

    /**
     * 物件リストを取得
     */
    async getBuildingList() {
      this.buildingListByClient = []
      this.allBuildingList = []
      let res = await backend.searchData('akbsTable/getSiteListForEstimate')
      if (res.data && res.data.data && res.data.data.length) {
        this.allBuildingList = res.data.data
      }
      // 得意先に紐づく物件を取得
      this.getBuildingListByClient()
    },

    /**
     * 得意先に紐づく物件を取得
     */
    getBuildingListByClient() {
      this.buildingListByClient = []
      if (this.allBuildingList && this.allBuildingList.length) {
        if (this.requestPost.clientCode) {
          this.buildingListByClient = this.allBuildingList.filter((all) => {
            return all.clientCode == this.requestPost.clientCode
          })
        } else {
          this.buildingListByClient = utils.clone(this.allBuildingList)
        }
      }
    },

    /**
     * 物件選択モーダルopen
     */
    openSiteModal() {
      this.siteModal = true
    },

    /**
     * 物件選択
     * @param e 選択したデータ
     */
    async siteSelected(e) {
      this.requestPost.siteCode = e.siteCode
      this.requestPost.buildingName = e.site1 + ' ' + e.site2
      this.siteNameChanged()
      this.requestPost.postalCode = e.zip

      let state = ''
      if (e.address1.indexOf('東京都') > -1) {
        state = '東京都'
      } else if (e.address1.indexOf('県') > -1) {
        state = e.address1.substr(0, e.address1.indexOf('県') + 1)
      }
      this.requestPost.state = state
      this.requestPost.city = e.address1.replace(state, '')
      this.requestPost.street = e.address2

      this.siteModal = false

      // 物件概要書データ取得
      await this.getOutline(e.siteCode)
      this.reload++
    },

    /**
     * 物件概要書取得
     */
    async getOutline(siteCode) {
      // 世帯数
      this.requestPost.households = ''
      this.requestPost.householdsNote = ''
      // 階数
      this.requestPost.stairs = ''

      const res = await backend.searchData('siteOutline/getOutlineForTask', { siteCode })
      if (res.data.data) {
        const val = res.data.data
        // 世帯数
        this.requestPost.households = String(val.household || '')
        this.requestPost.householdsNote = val.householdNote
        // 階数
        this.requestPost.stairs = String(val.stairs || '')
      }
      this.reload++
    },

    /**
     * 建物名 change イベント
     */
    siteNameChanged() {
      this.requestPost.building = this.requestPost.buildingName
      this.setTitle()

      if (!this.requestPost.buildingName) {
        this.requestPost.siteCode = ''
        // 世帯数
        this.requestPost.households = ''
        this.requestPost.householdsNote = ''
        // 階数
        this.requestPost.stairs = ''
      }
      this.reload++
    },

    /**
     * 住所の建物名 change イベント
     */
    buildingChanged() {
      this.requestPost.buildingName = this.requestPost.building
      this.setTitle()
      this.reload++
    },

    /**
     * タイトル設定
     */
    setTitle() {
      if (!this.isOrder) {
        var categoryStr = ''
        if(this.requestPost.category.indexOf('見積依頼') > -1) {
          var newCategory = this.requestPost.category.filter(function(value) {
            return (value == '見積依頼')
          })
          categoryStr = newCategory.join()
        }

        var cepa = ''
        if (this.requestPost.buildingName && this.requestPost.buildingName.length > 0
          && categoryStr && categoryStr.length > 0) cepa = ' '

        this.requestPost.inquiry_title = this.requestPost.buildingName + cepa + categoryStr
      }
      this.reload++
    },

    /**
     * 契約無/契約有 Changed イベント
     */
    newNowFlagChanged() {
      // 契約有の場合、既存固定
      if (this.requestPost.newNowFlag && this.requestPost.newNowFlag.indexOf('契約有') > -1) {
        // 「既存」を選択して、
        this.requestPost.newClass = ['既存']
        this.isDisabledNewClass = true
      } else {
        this.isDisabledNewClass = false
      }
      this.setBuildingDetailsRequired()
      this.setBuildingEquipmentRequired()
      this.reload++
    },

    /**
     * 清掃回数（RLS）変更イベント
     */
    changeCleanCountRls(rp) {
      this.dustCaptionRls = 'ゴミ搬出有無'
      if (this.requestPost.category2[0] && this.requestPost.category2[0] == 'お客様直' && rp.length && rp[0]) {
        if (['月 1 回', '週 1 回', '週 2 回'].includes(rp[0])) {
          if (this.isShowEstimationCleanCategoryItem('ラウンドサービス')) {
            this.requestPost.dustRemoval = []
            this.requestPost.dustCount = []
            this.requestPost.dustRemoval[0] = '無'
            this.dustCaptionRls = 'ゴミ搬出有無（清掃回数が「' + rp[0] + '」の場合はゴミ搬出はありません。）'
          }
        }
      }
      this.reload++
    },

    /**
     * 清掃回数（RLSプラス）変更イベント
     */
    changeCleanCountPlus(rp) {
      this.dustCaptionPlus = 'ゴミ搬出有無'
      if (this.requestPost.category2[0] && this.requestPost.category2[0] == 'お客様直' && rp.length && rp[0]) {
        if (['月 1 回', '週 1 回', '週 2 回'].includes(rp[0])) {
          if (this.isShowEstimationCleanCategoryItem('ラウンドプラス')) {
            this.requestPost.plusDustRemoval = []
            this.requestPost.plusDustCount = []
            this.requestPost.plusDustRemoval[0] = '無'
            this.dustCaptionPlus = 'ゴミ搬出有無（清掃回数が「' + rp[0] + '」の場合はゴミ搬出はありません。）'
          }
        }
      }
      this.reload++
    },

    /**
     * 特別清掃追加ボタン
     */
    addSpecialClean() {
      let specialClean = {
        specialCleanCount: '',
        specialCleanContentId: '',
        specialCleanContent: '',
        specialCleanUnitName: ''
      }
      if (!this.requestPost.specialCleans) {
        this.requestPost.specialCleans = []
      }
      this.requestPost.specialCleans.push(specialClean)
      this.reload++
    },

    /**
     * 特別清掃削除ボタン
     */
    removeSpecialClean(idx) {
      if (this.requestPost.specialCleans.length == 1) {
        this.requestPost.specialCleans[0].specialCleanCount = ''
        this.requestPost.specialCleans[0].specialCleanContentId = ''
        this.requestPost.specialCleans[0].specialCleanContent = ''
        this.requestPost.specialCleans[0].specialCleanUnitName = ''
        return
      }
      this.requestPost.specialCleans.splice(idx, 1)
    },

    /**
     * ラベル表示用index変換
     */
    outputIndex(index) {
      let idxNumber = String(index + 1)
      const zenkaku = utils.zenkaku(idxNumber)
      return zenkaku
    },

    /**
     * 特別清掃 選択イベント
     * @index 番号
     * @e 選択内容
     */
    selectedSp(index, e) {
      let target = this.requestPost.specialCleans[index]
      target.specialCleanContentId = e.id
      this.reload++
    },

    /**
     * 特別清掃 変更イベント
     * @index 番号
     */
    changeSp(index) {
      let target = this.requestPost.specialCleans[index]
      if (target.specialCleanContent == '') {
        target.specialCleanContentId = ''
      }
      this.reload++
    },

    /**
     * ラウンドサブ追加ボタン
     */
    addRoundSub() {
      let r = {
        roundSubCount: '12',
        roundSubContent: '',
        roundSubUnitName: 'ヶ月'
      }
      if (!this.requestPost.roundSubs) {
        this.requestPost.roundSubs = []
      }
      this.requestPost.roundSubs.push(r)
      this.reload++
    },

    /**
     * 定期清掃追加ボタン
     */
    addRegularClean() {
      let regularClean = {
        regularCleanCount: '',
        regularCleanContent: '',
        regularCleanUnitName: ''
      }
      if (!this.requestPost.regularCleans) {
        this.requestPost.regularCleans = []
      }
      this.requestPost.regularCleans.push(regularClean)

      for (let index = 0; index < this.requestPost.regularCleans.length; index++) {
        // 定期清掃１のみの場合、依頼内容の初期値は「定期清掃」
        if (!this.requestPost.regularCleans[index].regularCleanContent && this.requestPost.regularCleans.length == 1) {
          this.requestPost.regularCleans[index].regularCleanContent = '定期清掃'
        // プラスボタンで定期清掃を増やした場合、依頼内容の初期値は「定期清掃 + 数字」
        } else if (!this.requestPost.regularCleans[index].regularCleanContent && this.requestPost.regularCleans.length > 1) {
          if (this.requestPost.regularCleans[0] && this.requestPost.regularCleans[0].regularCleanContent == '定期清掃') {
            let number = this.outputIndex(0)
            this.requestPost.regularCleans[0].regularCleanContent = '定期清掃' + number
          }
          let indexNumber = this.outputIndex(index)
          this.requestPost.regularCleans[index].regularCleanContent = '定期清掃' + indexNumber
        }
      }
    },

    /**
     * ラウンドサブメニュー削除ボタン
     */
    removeRoundSub(idx) {
      // 複写の場合
      if (this.$route.query.mode == 3) {
        if (this.copySubs && this.copySubs[idx]) {
          this.copySubs.splice(idx, 1)
        }
      }

      if (this.requestPost.roundSubs.length == 1) {
        this.requestPost.roundSubs[0].roundSubCount = ''
        this.requestPost.roundSubs[0].roundSubContent = ''
        this.requestPost.roundSubs[0].roundSubUnitName = ''
        return
      }
      this.requestPost.roundSubs.splice(idx, 1)
    },

    /**
     * 定期清掃削除ボタン
     */
    removeRegularClean(idx) {
      if (this.requestPost.regularCleans.length == 1) {
        this.requestPost.regularCleans[0].regularCleanCount = ''
        this.requestPost.regularCleans[0].regularCleanContent = '定期清掃'
        this.requestPost.regularCleans[0].regularCleanUnitName = ''
        return
      }
      this.requestPost.regularCleans.splice(idx, 1)
    },

    /**
     * その他作業追加ボタン
     */
    addOtherWork() {
      let otherWork = {
        otherWorkContent: '',
        otherWorkCount: '',
        otherWorkUnitName: '',
      }
      if (!this.requestPost.otherWorks) {
        this.requestPost.otherWorks = []
      }
      this.requestPost.otherWorks.push(otherWork)
    },

    /**
     * その他作業削除ボタン
     */
    removeOtherWork(idx) {
      // 複写の場合
      if (this.$route.query.mode == 3) {
        if (this.copyOther && this.copyOther[idx]) {
          this.copyOther.splice(idx, 1)
        }
      }

      if (this.requestPost.otherWorks.length == 1) {
        this.requestPost.otherWorks[0].otherWorkContent = ''
        this.requestPost.otherWorks[0].otherWorkCount = ''
        this.requestPost.otherWorks[0].otherWorkUnitName = ''
        return
      }
      this.requestPost.otherWorks.splice(idx, 1)
    },

    /**
     * 御見積_その他カテゴリー change イベント
     */
    estimationOtherCategoryChanged() {
      this.setBuildingDetailsRequired()
      this.setBuildingEquipmentRequired()
    },

    /**
     * 新規区分 change イベント
     */
    newClassChanged() {
      this.setBuildingDetailsRequired()
      this.setBuildingEquipmentRequired()
    },

    /**
     * 建物詳細 必須設定
     */
    setBuildingDetailsRequired() {
      if ((this.requestPost.estimationOtherCategory == 'その他作業' && this.requestPost.newNowFlag == '契約有' && this.requestPost.newClass == '既存')
        || (this.requestPost.newNowFlag == '契約有' && this.requestPost.newClass == '既存' && !this.forCustomers)) {
        this.isBuildingDetailsRequired = false
      } else {
        this.isBuildingDetailsRequired = true
      }
    },

    /**
     * 建物設備 必須設定
     */
     setBuildingEquipmentRequired() {
      if (this.requestPost.estimationOtherCategory == 'その他作業' && this.requestPost.newNowFlag == '契約有' && this.requestPost.newClass == '既存') {
        this.isBuildingEquipmentRequired = false
      } else {
        this.isBuildingEquipmentRequired = true
      }
    },

    /**
     * 日常清掃追加ボタン
     */
    addEverydayClean() {
      let everydayClean = {
        everydayCleanCount: '',
        everydayCleanHours: '',
        everydayStartTimeFlag: [],
        everydayStartTime: '',
        everydayEndTime: '',
        everydayHolidayFlag: [],
        everydayHoliday: [],
        toiletCleaning: [],
        toiletTimes: '',
        toiletPlace: ''
      }
      if (!this.requestPost.everydayCleans) {
        this.requestPost.everydayCleans = []
      }
      this.requestPost.everydayCleans.push(everydayClean)
    },

    /**
     * 日常清掃削除ボタン
     */
     removeEverydayClean(idx) {
      if (this.requestPost.everydayCleans.length == 1) {
        this.requestPost.everydayCleans[0].everydayCleanCount = ''
        this.requestPost.everydayCleans[0].everydayCleanHours = ''
        this.requestPost.everydayCleans[0].everydayStartTimeFlag = []
        this.requestPost.everydayCleans[0].everydayStartTime = ''
        this.requestPost.everydayCleans[0].everydayEndTime = ''
        this.requestPost.everydayCleans[0].everydayHolidayFlag = []
        this.requestPost.everydayCleans[0].everydayHoliday = []
        this.requestPost.everydayCleans[0].toiletCleaning = []
        this.requestPost.everydayCleans[0].toiletTimes = ''
        this.requestPost.everydayCleans[0].toiletPlace = ''
        return
      }
      this.requestPost.everydayCleans.splice(idx, 1)
    },

    /**
     * 管理員業務追加ボタン
     */
     addManagerWork() {
      let ManagerWork = {
        managerWorkCount: '',
        managerWorkHours: '',
        managerWorkTimeFlag: [],
        managerWorkTime: '',
        managerWorkEndTime: '',
        managerWorkHolidayFlag: [],
        managerWorkHoliday: []
      }
      if (!this.requestPost.managerWorks) {
        this.requestPost.managerWorks = []
      }
      this.requestPost.managerWorks.push(ManagerWork)
    },

    /**
     * 管理員業務削除ボタン
     */
    removeManagerWork(idx) {
      if (this.requestPost.managerWorks.length == 1) {
        this.requestPost.managerWorks[0].managerWorkCount = ''
        this.requestPost.managerWorks[0].managerWorkHours = ''
        this.requestPost.managerWorks[0].managerWorkTimeFlag = []
        this.requestPost.managerWorks[0].managerWorkTime = ''
        this.requestPost.managerWorks[0].managerWorkEndTime = ''
        this.requestPost.managerWorks[0].managerWorkHolidayFlag = []
        this.requestPost.managerWorks[0].managerWorkHoliday = []
        return
      }
      this.requestPost.managerWorks.splice(idx, 1)
    },

    /**
     * 複数人登録 社員選択モーダルの決定イベント
     * @param staffList 選択された社員一覧
     */
    multiStaffDecided(staffList) {
      this.multiStaffList = staffList || []
    },

    /**
     * 複数人登録 選択解除
     */
    clearMultiStaff() {
      this.multiStaffList = []
    },

  /**
   * 担当者リスト生成
   * @param id 部署ID
   * @param clearSelected 選択済み担当者をクリアするか否か
   */
    getStaffNameList(id, clearSelected) {
      // 部署IDがあれば部署に所属する担当者のリストを生成
      if (id) {
        // 所属部署データ取得
        const ud = this.$store.getters.userDepartment
        // console.log(ud)

        // デンタツの場合
        if (this.requestPost.category.includes('デンタツ') || this.requestPost.category.includes('AKBS休み登録')) {
          // アポロ管財依頼先部署で部署を選択した場合は担当者を空にする
          // 編集、コピー、複写の場合は担当者を空にしない
          if (clearSelected) {
            this.requestPost.toStaffName = ''
            this.requestPost.toStaffId = ''
          }

          let trId = ''
          let list2 = []
          let trd = this.$store.getters.transDepartmentList
          let trans = trd.find((t) => {
            return t.departmentId == id
          })
          if (trans.transDepartment) {
            trId = trans.transDepartment
          }
          for (let j = 0; j < ud.length; j++) {
            const u2 =  ud[j]
            if (u2.departmentId == trId && u2.transmission) {
              list2.push(u2)
            }
          }
          list2 = this.createTransStaffNameList(list2)
          this.toStaffNameList = list2
          this.toStaffSelections = list2.map(function(item){
            return {
              value: item.userId,
              text: item.userName
            };
          });

        // デンタツ以外
        } else {
          let list = []
          for (let i = 0; i < ud.length; i++) {
            const u = ud[i]
            if (u.departmentId == id) {
              // 兼務者は部署の数だけ同一userIdで重複するため、Multiselectの選択判定（track-by）用に
              // 「ユーザーID＋部署ID」の行専用キーを付与する（保存データには影響しない）
              u.rowKey = u.userId + '_' + u.departmentId
              list.push(u)
            }
          }

          // 受注モードの場合は、担当者「未定」は非表示
          if (this.isOrder) {
            list = list.filter((u) => {
              return u.userName != '未定'
            })
          }
          this.toStaffNameList = list
          this.toStaffSelections = list.map(function(item){
            return {
              value: item.userId,
              text: item.userName
            };
          });
        }
      } else {
        // 部署IDが無ければ、全担当者のリストを生成
        if (!this.isOrder) {
          let staffNameList
          // デンタツの場合
          if (this.requestPost.category.includes('デンタツ') || this.requestPost.category.includes('AKBS休み登録')) {
            staffNameList = this.$store.getters.transUserList
            staffNameList = this.createTransStaffNameList(staffNameList)
          } else {
            // デンタツ以外の場合
            staffNameList = this.$store.getters.userDepartment
            for (let index = 0; index < staffNameList.length; index++) {
              // 兼務者は部署の数だけ同一userIdで重複するため、Multiselectの選択判定（track-by）用に
              // 「ユーザーID＋部署ID」の行専用キーを付与する（保存データには影響しない）
              staffNameList[index].rowKey = staffNameList[index].userId + '_' + staffNameList[index].departmentId
              let dep = this.getDepartment(staffNameList[index].departmentId, false)
              staffNameList[index].dispName = dep.name + '　' + staffNameList[index].userName
            }
          }
          this.toStaffNameList = staffNameList
          this.toStaffSelections = staffNameList.map(function(item){
            return {
              value: item.userId,
              text: item.userName
            };
          });
        }
      }
    },

    /**
     * 部署IDを元に担当者が所属する部署を特定
     */
    getDepartment(id, isTrans) {
      let dep
      if (isTrans) {
        let transDepartmentList = this.$store.getters.transDepartmentList
        dep = transDepartmentList.find((d) => {
          return d.transDepartment == id
        })
      } else {
        let departmentList = this.$store.getters.departmentList
        dep = departmentList.find((d) => {
          return d.departmentId == id
        })
      }
      return dep
    },

    /**
     * デンタツ用の担当者リスト 生成
     * @param {*} list
     */
    createTransStaffNameList (list) {
      for (let index = 0; index < list.length; index++) {
        // 兼務者は部署の数だけ同一userIdで重複するため、Multiselectの選択判定（track-by）用に
        // 「ユーザーID＋部署ID」の行専用キーを付与する（保存データには影響しない）
        list[index].rowKey = list[index].userId + '_' + list[index].departmentId
        let dep = this.getDepartment(list[index].departmentId, true)
        if (dep) {
          list[index].dispName = dep.name + '　' + list[index].userName
          list[index].transDepName = dep.name
          list[index].transDepId = dep.departmentId
        } else {
          list[index].dispName = list[index].userName
        }
      }
      return list
    },

    /**
     * 編集・完了できるか確認
     */
    checkCanEdit() {
      // 編集の場合に限る
      if (this.editMode) {
        // デンタツの再通知、協力会社はOK
        if (this.requestPost.category.includes('デンタツ') && this.requestPost.dentatsuCategory && (this.requestPost.dentatsuCategory.includes('再通知') || this.requestPost.dentatsuCategory.includes('協力会社'))) {
          return true
        }
        let name = this.$store.getters.user.user_name
        // ログインユーザー名
        name = utils.deleteSpace(utils.deleteKana(name))

        // 管理者権限はOK
        const auth = this.$store.getters.auth
        if (auth.adminAuth) {
          return true
        }

        // 編集できる段階で他の人を割り当てたりする場合に備えて、originalRequestPostのデータで判定

        // ログインユーザーが担当者の場合、OK
        let tanto = utils.deleteSpace(utils.deleteKana(this.originalRequestPost.toStaffName))
        if (name == tanto) {
          return true
        }

        // ログインユーザーが依頼主の場合、OK
        let irai = utils.deleteSpace(utils.deleteKana(this.originalRequestPost.byUser))
        if (name == irai) {
          return true
        }

        // 担当者に関係なく、同じ部署の人はOK
        // 兼任を含めたログインユーザーの前所属部署
        let d = this.$store.getters.dualPosition
        for (let i = 0; i < d.length; i++) {
          const tar = d[i]
          if (tar.departmentName == this.originalRequestPost.toDepartment || tar.departmentId == this.originalRequestPost.toDepartmentId) {
            return true
          }
        }
        // デンタツの場合
        // デンタツの全データ取得
        let resDT = this.$store.getters.transDepartmentList
        // 該当のデンタツ部署のデータを取得
        let dentatsu = resDT.find((r) => {
          return (r.name == this.originalRequestPost.toDepartment || r.departmentId == this.originalRequestPost.toDepartmentId)
        })
        // 該当のデンタツに紐づく部署の人はOK（RLS_デンタツならRLS全員OK）
        if (dentatsu && dentatsu.transDepartment) {
          for (let i = 0; i < d.length; i++) {
            const tar = d[i]
            if (tar.departmentId == dentatsu.transDepartment) {
              return true
            }
          }
        }
        return false
      } else {
        return true
      }
    },

    /**
     * その他作業選択イベント
     */
    selectedOtherWork(i, e) {
      // 防火対象物点検・スポット清掃の場合は、デフォルトで回数、単位を入れる
      if (e.text == '防火対象物点検' || e.text == 'スポット清掃') {
        this.requestPost.otherWorks[i].otherWorkCount = '1'
        this.requestPost.otherWorks[i].otherWorkUnitName = '回/年'
      // 消火器変更の場合
      } else if (e.text == '消火器交換') {
        this.requestPost.otherWorks[i].otherWorkCount = '1'
        this.requestPost.otherWorks[i].otherWorkUnitName = '式'
      }
    },

    /**
     * RP、サブ依頼タスク、見積を全てコピー
     * @param key キーとなる項目
     */
    async allCopy(key) {
      // 定期清掃で変更があった場合
      let changeFixed = false
      for (let i = 0; i < this.copyFixed.length; i++) {
        const cf = this.copyFixed[i];
        if (this.requestPost.regularCleans && this.requestPost.regularCleans[i]) {
          if (!_.isEqual(this.requestPost.regularCleans[i], cf)) {
            changeFixed = true
            break
          }
        } else {
          changeFixed = true
        }
      }

      // 特別清掃で変更があった場合
      let changeSp = false
      for (let i = 0; i < this.copySp.length; i++) {
        const cs = this.copySp[i];
        if (this.requestPost.specialCleans) {
          if (!_.isEqual(this.requestPost.specialCleans[i], cs)) {
            changeSp = true
            break
          }
        } else {
          changeSp = true
        }
      }

      // ラウンドサブで変更があった項目
      let subCode = []
      if (this.requestPost.roundSubs) {
        for (let i = 0; i < this.copySubs.length; i++) {
          const sub = this.copySubs[i];
          let code = sub.roundSubContent

          if (this.requestPost.roundSubs[i]) {
            // 項目名が違う場合は、削除
            if (this.requestPost.roundSubs[i].roundSubContent != sub.roundSubContent) {
              subCode.push({code: code, delete: true})

            // 単位が違う
            } else if (this.requestPost.roundSubs[i].roundSubUnitName != sub.roundSubUnitName) {
              // 同じ項目が複数ある場合は、削除
              if (this.copySubsW.includes(sub.roundSubContent)) {
                subCode.push({code: code, delete: true})

              // 対象項目が1つしかない場合は、単位の書き換え
              } else {
                subCode.push({code: code, delete: false, qty: this.requestPost.roundSubs[i].roundSubCount, uName: this.requestPost.roundSubs[i].roundSubUnitName})
              }

            // 数量が違う
            } else if (this.requestPost.roundSubs[i].roundSubCount != sub.roundSubCount) {
              // 同じ項目が複数ある場合は、削除
              if (this.copySubsW.includes(sub.roundSubContent)) {
                subCode.push({code: code, delete: true})

              // 対象項目が1つしかない場合は、数量の書き換え
              } else {
                subCode.push({code: code, delete: false, qty: this.requestPost.roundSubs[i].roundSubCount, uName: this.requestPost.roundSubs[i].roundSubUnitName})
              }
            }
          } else {
            subCode.push({code: code, delete: true})
          }
        }

        // 項目が追加されている場合、もし、同じ項目が既にあったらその項目は作り直しするため、削除
        if (this.copySubs.length < this.requestPost.roundSubs.length) {
            for (let j = this.copySubs.length; j < this.requestPost.roundSubs.length; j++) {
            subCode.push({code: this.requestPost.roundSubs[j].roundSubContent, delete: true})
          }
        }

        for (let k = 0; k < subCode.length; k++) {
          let sCode = subCode[k].code;
          if (sCode == 'フロントサポート') {
            subCode[k].code = '6'
          } else if (sCode == 'フロントサポートプラス') {
            subCode[k].code = '7'
          } else if (sCode == 'ラウンドトラッシュ') {
            subCode[k].code = '8'
          } else if (sCode == 'クオリティレポート') {
            subCode[k].code = '9'
          }
        }

      } else if (this.copySubs.length) {
        subCode = [{code: '6', delete: true}, {code: '7', delete: true}, {code: '8', delete: true}, {code: '9', delete: true}]
      }

      // その他作業で変更があった項目
      let otherCode = []
      if (this.requestPost.otherWorks) {
        for (let i = 0; i < this.copyOther.length; i++) {
          const ot = this.copyOther[i];
          let code = ot.otherWorkContent

          if (this.requestPost.otherWorks[i]) {
            // 項目名が違う場合は、削除
            if (this.requestPost.otherWorks[i].otherWorkContent != ot.otherWorkContent) {
              otherCode.push({code: code, delete: true})

            // 単位が違う
            } else if (this.requestPost.otherWorks[i].otherWorkUnitName != ot.otherWorkUnitName) {
              // 同じ項目が複数ある場合は、削除
              if (this.copyOtherW.includes(ot.otherWorkContent)) {
                otherCode.push({code: code, delete: true})

              // 対象項目が1つしかない場合は、単位の書き換え
              } else {
                otherCode.push({code: code, delete: false, qty: this.requestPost.otherWorks[i].otherWorkCount, uName: this.requestPost.otherWorks[i].otherWorkUnitName})
              }

            // 数量が違う
            } else if (this.requestPost.otherWorks[i].otherWorkCount != ot.otherWorkCount) {
              // 同じ項目が複数ある場合は、削除
              if (this.copyOtherW.includes(ot.otherWorkContent)) {
                otherCode.push({code: code, delete: true})

              // 対象項目が1つしかない場合は、数量の書き換え
              } else {
                otherCode.push({code: code, delete: false, qty: this.requestPost.otherWorks[i].otherWorkCount, uName: this.requestPost.otherWorks[i].otherWorkUnitName})
              }
            }
          } else {
            otherCode.push({code: code, delete: true})
          }
        }

        // 項目が追加されている場合、もし、同じ項目が既にあったらその項目は作り直しするため、削除
        if (this.copyOther.length < this.requestPost.otherWorks.length) {
            for (let j = this.copyOther.length; j < this.requestPost.otherWorks.length; j++) {
            otherCode.push({code: this.requestPost.otherWorks[j].otherWorkContent, delete: true})
          }
        }

        for (let k = 0; k < otherCode.length; k++) {
          let sCode = otherCode[k].code;
          if (sCode == '管球対応') {
            otherCode[k].code = '23'
          } else if (sCode == '粗大ごみ対応') {
            otherCode[k].code = '24'
          } else if (sCode == '物品販売') {
            otherCode[k].code = '25'
          } else if (sCode == '緊急対応') {
            otherCode[k].code = '26'
          } else {
            otherCode[k].code = ''
          }
        }

      } else if (this.copyOther.length) {
        otherCode = [{code: '23', delete: true}, {code: '24', delete: true}, {code: '25', delete: true}, {code: '26', delete: true}]
      }

      // タスク
      if (key.id && key.requestNo && this.$route.query.requestPostId) {
        // コピー元に紐づくサブタスク取得
        const tr = await taskRequestManager.getByRequestPostId(this, this.$route.query.requestPostId, null)
        let estimates = []
        if (tr.length) {
          for (let i = 0; i < tr.length; i++) {
            let oldTaskId = tr[i]._id

            delete tr[i]._id
            tr[i].requestPostId = key.id
            tr[i].taskRequestRequestNo = key.requestNo
            // 空のままで通す人がいるので、とにかく日付を入れる
            tr[i].limitDate = this.requestPost.limitDate

            // タスクのステータスをクリア
            tr[i].status = 'open'
            tr[i].doneDate = null
            tr[i].doneStaffName = null

            if (tr[i].details && tr[i].details.length) {
              for (const detail of tr[i].details) {
                detail.isDone = false
                detail.doneDate = null
                detail.doneStaffName = null
              }
            }

            tr[i].allCopy = true

            let taskNewId = await taskRequestManager.register(this, tr[i])
            if (!taskNewId) {
              await dialogs.showErrorDialog('タスク依頼の複写', 'タスク依頼の複写中にエラーが発生しました。')
              return false
            }

            // 「見積依頼」でなければ見積りの複写はしない
            if (!this.requestPost.category.includes('見積依頼')) {
              continue
            }

            // コピー元に紐づく見積り取得
            let es = await estimateManager.getEstimateByTaskRequestId(this, oldTaskId)
            es.forEach((e) => {
              e.taskRequestId = taskNewId
            })
            estimates = estimates.concat(es)
          }

          // 複写もとに見積もりがあれば、どれを複写するか選択
          if (estimates && estimates.length) {
            this.allCopyEstimateShow = true
            const estimateNos = []
            this.allCopyEstimateParam = {
              estimates,

              // 選択後
              selectCallback: async (selectedEstimates) => {
                this.allCopyEstimateShow = false
                estimates = selectedEstimates

                if (estimates && estimates.length) {
                  for (let j = 0; j < estimates.length; j++) {
                    let e = estimates[j]
                    e = estimateManager.formatCopy(e)
                    e.requestPostId = key.id
                    e.requestPostName = this.requestPost.inquiry_title
                    // e.taskRequestId = taskNewId
                    e.clientPersonName = this.requestPost.clientPersonName
                    e.subject = this.requestPost.note

                    // 得意先
                    e.clientName = this.requestPost.clientName
                    e.clientPostalCode = this.requestPost.postalCode
                    e.clientAddress1 = this.requestPost.clientAddress1
                    e.clientAddress2 = this.requestPost.clientAddress2
                    // メインにない得意先のデータをマスタから取得
                    if (this.requestPost.clientCode) {
                      const client = await estimateManager.getClientByCode(this.requestPost.clientCode)
                      if (client) {
                        e.clientHonorific = client.honorific
                        e.clientPhoneNumber = client.clientPhoneNumber
                        e.clientFax = client.clientFax
                      }
                    }
                    // 複写フラグ
                    e.allCopy = true
                    // 変更フラグ
                    e.isChangeRegular = changeFixed
                    e.isChangeSp = changeSp
                    // ラウンドサブの変更された内容
                    e.isChangeSubs = subCode
                    // ラウンドサブの変更された内容
                    e.isChangeOther = otherCode

                    let eResult = await estimateManager.registerEstimate(this, e)
                    if (!eResult) {
                      await dialogs.showErrorDialog('見積りの複写', '見積りの複写中にエラーが発生しました。')
                      return
                    } else {
                      estimateNos.push(eResult)
                    }
                  }
                }

                if (estimateNos && estimateNos.length) {
                  await dialogs.showInfoDialog('見積り複写完了', `見積Noは以下の通りです。\r\n${estimateNos.join('\r\n')}`)
                }
                // サブタスクに強制遷移
                this.$router.push({ name: 'TaskRequest', query: { requestPostId: key.id }})
              }
            }
          } else {
            // サブタスクに強制遷移
            this.$router.push({ name: 'TaskRequest', query: { requestPostId: key.id }})
          }
          // 複写もとにサブタスクがない
        } else if (this.requestPost.category.includes('デンタツ')) {
          //サブタスク不要
          this.$router.push({ name: 'RequestPostList' })
        } else {
          const dialogResult = await dialogs.showConfirmDialog('サブタスク登録', '複写元にサブタスクがありませんでした。\r\n続けてサブタスクを登録しますか？', 'はい', 'いいえ')
          if (dialogResult === 'YES') {
            this.$router.push({ name: 'TaskRequest', query: { requestPostId: key.id }})
          } else {
            this.$router.push({ name: 'RequestPostList' })
          }
        }
      }
    },

    /**
     * 複写時にどの見積もりをコピーするか選択する
     * @param estimates 見積り
     */
    // async allCopyEstimate (estimates, key, taskNewId, changeFixed, changeSp, subCode, otherCode) {
    //   if (estimates && estimates.length) {
    //     this.allCopyEstimateShow = true
    //     this.allCopyEstimateParam = {
    //       estimates,

    //       selectCallback: async (selectedEstimates) => {
    //         this.allCopyEstimateShow = false
    //         estimates = selectedEstimates


    //         for (let j = 0; j < estimates.length; j++) {
    //           let e = estimates[j]
    //           e._id = null
    //           e.estimateNo = ''
    //           e.estimateDate = utils.getToday()
    //           e.expireDate = utils.addMonths(utils.getToday(), 3)
    //           e.requestPostId = key.id
    //           e.requestPostName = this.requestPost.inquiry_title
    //           e.taskRequestId = taskNewId
    //           e.clientPersonName = this.requestPost.clientPersonName
    //           e.subject = this.requestPost.note

    //           // 得意先
    //           e.clientName = this.requestPost.clientName
    //           e.clientPostalCode = this.requestPost.postalCode
    //           e.clientAddress1 = this.requestPost.clientAddress1
    //           e.clientAddress2 = this.requestPost.clientAddress2
    //           // メインにない得意先のデータをマスタから取得
    //           if (this.requestPost.clientCode) {
    //             const client = await estimateManager.getClientByCode(this.requestPost.clientCode)
    //             if (client) {
    //               e.clientHonorific = client.honorific
    //               e.clientPhoneNumber = client.clientPhoneNumber
    //               e.clientFax = client.clientFax
    //             }
    //           }
    //           e.estimateStatus = '作成中'
    //           // 1番目の承認ルート
    //           e.approvalFlow1 = [{
    //             sequentialOrder: '1',
    //             userId: '',
    //             userName: '',
    //             chatworkAccountId: '',
    //             chatworkRoomId: '',
    //             chatworkApiToken: '',
    //             status: '未承認',
    //             stamp: ''
    //           }]
    //           // 2番目の承認ルート
    //           e.approvalFlow2 = [{
    //             sequentialOrder: '2',
    //             userId: '',
    //             userName: '',
    //             chatworkAccountId: '',
    //             chatworkRoomId: '',
    //             chatworkApiToken: '',
    //             status: '未承認',
    //             stamp: ''
    //           }]
    //           // 承認1ステータス
    //           e.approval1 = '---'
    //           // 承認2ステータス
    //           e.approval2 = '---'
    //           // 複写フラグ
    //           e.allCopy = true
    //           // 変更フラグ
    //           e.isChangeRegular = changeFixed
    //           e.isChangeSp = changeSp
    //           // ラウンドサブの変更された内容
    //           e.isChangeSubs = subCode
    //           // ラウンドサブの変更された内容
    //           e.isChangeOther = otherCode

    //           let eResult = await estimateManager.registerEstimate(this, e)
    //           if (!eResult) {
    //             await dialogs.showErrorDialog('見積りの複写', '見積りの複写中にエラーが発生しました。')
    //             return false
    //           }
    //         }
    //       }
    //     }
    //   }
    // },

    /**
     * 複数人登録
     * 「複数人選択モーダル」で選択した社員に、同じ内容のメインタスクを登録する
     * ＊担当者として1件目に登録済みの社員は除外する
     * ＊requestPostManager.register() は引数の requestNo を書き換えるため、
     *   1人ごとにクローンし、お問い合わせ番号とIDをクリアしてから登録する
     * ＊お問い合わせ番号の採番が競合しないよう、必ず逐次で登録する
     */
    async registMultiStaff() {
      const registered = []
      const isTransmission = this.requestPost.category.includes('デンタツ')

      // 社員リスト（メイン部署と兼任含むリストからメイン部署のみ取得）
      const list = this.$store.getters.userDepartment.filter(e => e.main)

      for (let i = 0; i < this.multiStaffList.length; i++) {
        const staff = this.multiStaffList[i]
        // 担当者として既に登録済みの社員は除外（IDが無い場合は氏名で判定）
        if (this.requestPost.toStaffId) {
          if (String(staff.userId) == String(this.requestPost.toStaffId)) {
            continue
          }
        } else if (staff.userName == this.requestPost.toStaffName) {
          continue
        }

        const rp = utils.clone(this.requestPost)
        delete rp._id
        rp.requestNo = ''
        rp.toStaffId = staff.userId
        rp.toStaffName = staff.userName

        // 担当者のIDがある場合のみ
        if (rp.toStaffId) {
          // 主な部署を取得
          let depId = ''
          const userData = list.find(e => e.userId == rp.toStaffId)
          if (userData.departmentId) {
            depId = userData.departmentId
          }
          // デンタツの場合はそのデンタツ部署
          if (isTransmission && userData.departmentId) {
            const dep = this.$store.getters.transDepartmentList.find((t) => {
              return t.transDepartment == depId
            })
            if (dep && dep.departmentId) {
              rp.toDepartmentId = dep.departmentId
              rp.toDepartment = dep.name
            }

          // デンタツではない場合
          } else if (!isTransmission && depId) {
            const dep = this.$store.getters.departmentList.find((t) => {
              return t.departmentId == depId
            })
            if (dep && dep.name) {
              rp.toDepartmentId = dep.departmentId
              rp.toDepartment = dep.name
            }
          }
        }

        const res = await requestPostManager.register(this, rp)
        if (res && res.id) {
          logManager.recordingByRegist(this, true, 'メインタスク', 'メインタスク（お問い合わせ番号：' + res.requestNo + '）')
          registered.push({
            userId: staff.userId,
            userName: staff.userName,
            id: res.id,
            requestNo: res.requestNo
          })
        } else {
          await dialogs.showErrorDialog('複数人登録', `${staff.userName}さんのメインタスクを登録できませんでした。`)
        }
      }

      return registered
    },

    /**
     * 複数人登録 chatworkへ通知 送信
     * 同じルームIDの宛先は【To】を連名にして1通にまとめて送信する
     * ＊Chatworkは10秒以内に11件以上送ると送信制限がかかるため、通数を抑える必要がある
     * @param result 担当者（1件目）の登録結果
     * @param multiRegistered 複数人登録で追加登録した結果
     * @param changeLimit 期限変更の内容
     * @param mail デンタツ協力会社へのメール内容
     */
    async sendChatWorkMessageForMultiStaff(result, multiRegistered, changeLimit, mail) {
      const requestPost = this.requestPost
      const isTransmission = requestPost.category.includes('デンタツ')

      // 社員リスト（メイン部署と兼任含むリストからメイン部署のみ取得）
      const list = this.$store.getters.userDepartment.filter(e => e.main)
      // 社員リスト
      const userList = this.$store.getters.userList

      // 機能が無効の場合は送信しない
      if (isTransmission) {
        const feature = REQUEST_POST_TRANSMISSION_FEATURES.REQUEST_POST_TRANSMISSION.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST_TRANSMISSION
        if (!feature || !feature.enable) {
          return
        }
      } else {
        const feature = REQUEST_POST_FEATURES.REQUEST_POST.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST
        if (!feature || !feature.enable) {
          return
        }
      }

      // 通知対象（担当者＋複数人登録で追加登録した社員）
      const staffList = [{
        userId: requestPost.toStaffId,
        userName: requestPost.toStaffName,
        id: result.id
      }]
      for (let i = 0; i < multiRegistered.length; i++) {
        staffList.push(multiRegistered[i])
      }

      // ログインユーザー情報
      const loginUser = this.$store.getters.user
      // ルームIDごとに宛先をまとめる
      const groups = {}

      for (let i = 0; i < staffList.length; i++) {
        const staff = staffList[i]

        // ログインユーザー自身への通知は行わない
        if (staff.userId && loginUser.id == staff.userId) {
          continue
        }
        if (utils.deleteKana(loginUser.user_name).replace(/\s+/g, '') == utils.deleteKana(staff.userName || '').replace(/\s+/g, '')) {
          continue
        }

        // 社員情報
        let staffId = staff.userId
        if (!staffId && staff.userName) {
          staffId = utils.getUserIdByName(staff.userName, userList)
        }
        if (staffId) {
          // 主な部署を取得
          const userData = list.find(e => e.userId == staffId)
          if (userData.departmentId) {
            staff.departmentId = userData.departmentId
          }

          // チャットワークアカウントID取得
          const chatData = userList.find(e => e.id == staffId)
          if (chatData && chatData.chatwork_account_id) {
            staff.chatworkAccountId = chatData.chatwork_account_id
          }
        }

        // 宛先（未定はTO ALL）
        let mension = ''
        if (staff.userName == '未定') {
          mension = `[toall]${staff.userName}さん`
        } else if (staff.chatworkAccountId) {
          mension = `[To:${staff.chatworkAccountId}]${staff.userName}さん`
        } else {
          mension = `[To:]${staff.userName}さん`
        }

        if (!groups[staff.departmentId]) {
          groups[staff.departmentId] = { roomId: null, apiToken: null, mensions: [], entries: [] }
        }
        groups[staff.departmentId].mensions.push(mension)
        groups[staff.departmentId].entries.push({
          userName: staff.userName,
          url: `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}RequestPost?requestPostId=${staff.id}&mode=1`
        })
      }

      // 部署IDごとに1通ずつ送信
      const keys = Object.keys(groups)
      for (let i = 0; i < keys.length; i++) {
        const group = groups[keys[i]]

        // ルームID取得
        let dep = {}
        let department = ''

        // デンタツの場合
        if (isTransmission) {
          dep = this.$store.getters.transDepartmentList.find((t) => {
            return t.transDepartment == keys[i]
          })
        // デンタツ以外の場合
        } else {
          dep = this.$store.getters.departmentList.find((t) => {
            return t.departmentId == keys[i]
          })
        }

        if (dep && dep.chatworkRoomId && dep.chatworkApiToken) {
          group.roomId = dep.chatworkRoomId
          group.apiToken = dep.chatworkApiToken
        } else {
          if (dep && dep.name) department = dep.name
          await dialogs.showErrorDialog('チャット送信不可', `${department} のルームID・APIトークンが取得できなかったため、チャット送信できませんでした。`)
          continue
        }

        // 連名の場合は改行して並べる
        const mension = group.mensions.join('\r\n')
        // 宛先が複数の場合は、誰宛のメインタスクか分かるように氏名を添えて並べる
        let viewUrl = ''
        if (group.entries.length > 1) {
          viewUrl = '\r\n' + group.entries.map((e) => {
            return `${e.userName}さん：${e.url}`
          }).join('\r\n')
        } else {
          viewUrl = group.entries[0].url
        }

        let message = ''

        // デンタツ協力会社にメール送信成功の場合
        if (isTransmission && mail) {
          message = mension + '[info][title]デンタツ 協力会社へメール送信完了[/title]\nメインタスクから協力会社へメール送信しました。以下、メールの内容です。\n\n' + `${mail}\n●メインタスク：${viewUrl}[/info]`

        // デンタツの場合
        } else if (isTransmission) {
          const context = {
            mension,
            inquiry_title: requestPost.inquiry_title,
            clientPersonName: requestPost.clientPersonName,
            telephoneNumber: requestPost.telephoneNumber,
            dentatsuCategory: requestPost.dentatsuCategory,
            viewUrl: viewUrl,
            sender: requestPost.byUser,
            clientName: requestPost.clientName,
            employeeName: requestPost.employeeName || '',
            staffNumber: (requestPost.staffNumber || '')
          }
          const expression = '`' + REQUEST_POST_TRANSMISSION_FEATURES.REQUEST_POST_TRANSMISSION.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST_TRANSMISSION.messageTemplate + '`'
          message = utils.evaluate(context, expression)

        // デンタツ以外の場合
        } else {
          const context = {
            mension,
            category: requestPost.category,
            inquiry_title: requestPost.inquiry_title,
            estimationCleanCategory: requestPost.estimationCleanCategory || [],
            estimationInspectCategory: requestPost.estimationInspectCategory || [],
            estimationOtherCategory: requestPost.estimationOtherCategory || [],
            viewUrl: viewUrl,
            sender: requestPost.byUser
          }
          const expression = '`' + REQUEST_POST_FEATURES.REQUEST_POST.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST.messageTemplate + '`'
          message = utils.evaluate(context, expression)
        }

        if (changeLimit) {
          message = message.replace('● メインタスク', `※期限変更あり：${changeLimit}\n● メインタスク`)
        }

        await chatwork.sendChatWorkMssage(group.roomId, message, group.apiToken)
      }
    },

    /*
     * chatworkへ通知 送信
     */
    async sendChatWorkMessage(requestPost, requestPostId, changeLimit, mail) {
      // 雇い入れは件数が多いため通知しない
      if (requestPost.category && requestPost.category[0].includes('雇い入れ')) return

      if (requestPost.category.includes('デンタツ') || requestPost.category.includes('AKBS休み登録')) {
        if (REQUEST_POST_TRANSMISSION_FEATURES.REQUEST_POST_TRANSMISSION.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST_TRANSMISSION && REQUEST_POST_TRANSMISSION_FEATURES.REQUEST_POST_TRANSMISSION.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST_TRANSMISSION.enable) {
          let message = ''
          let mension = ''
          let viewUrl = `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}RequestPost?requestPostId=${requestPostId}&mode=1`
          const userList = this.$store.getters.userList

          // ログインしているユーザー名を取得
          const loginUser = this.$store.getters.user
          // ログインユーザーIDと担当者IDが同じ場合はchatwork通知は行わない
          if (requestPost.toStaffId && loginUser.id == requestPost.toStaffId) {
            return
          }
          // 担当者IDがないデータは、名前で比較。同じ場合はchatwork通知は行わない
          if (utils.deleteKana(loginUser.user_name).replace(/\s+/g, '') == utils.deleteKana(requestPost.toStaffName).replace(/\s+/g, '')) {
            return
          }

          // 担当者のチャット情報取得
          let toStaffId = ''
          let chat = null
          if (requestPost.toStaffName) {
            if (requestPost.toStaffId) {
              toStaffId = requestPost.toStaffId

            // 担当者IDがない場合、担当者名から担当者Id取得
            } else {
              toStaffId = utils.getUserIdByName(requestPost.toStaffName, userList)
            }
          }

          // チャットワーク情報を取得
          if (toStaffId) {
            let c = await backend.searchData('user/getAllDataByUser', {day: utils.getToday(), userId: toStaffId})
            chat = c.data.data
          }

          // デンタツの再通知の場合
          if (requestPost.category.includes('デンタツ') && requestPost.dentatsuCategory && requestPost.dentatsuCategory.includes('再通知')) {
            let toInfo = ''
            // 送信先
            // 未定、もしくは部署が受託の場合はTOALL
            if (requestPost.toStaffName == '未定') {
              mension = `[toall]`
            } else if (this.requestPost.toDepartment.indexOf('受託営業') > -1) {
              mension = `[toall]`
              toInfo = '※再通知のため、TO ALL にしています。'

            // それ以外では、本人と上司
            } else {
              mension = `[To:]`
              // 本人
              if (chat.chatworkAccountId) {
                mension = `[To:${chat.chatworkAccountId}]`
              }
              mension += `${requestPost.toStaffName}さん`

              // 上司を取得
              const boss = await backend.searchData('user/getBossChat', { userName: utils.deleteKana(requestPost.toStaffName) })
              if (boss.data.data.length && boss.data.data[0].userName) {
                let bossData = boss.data.data[0]
                // 上司が大野様以外の場合に上司にも送る
                if (String(bossData.userId) != String(OHNO_USER_ID)) {
                  mension += '\r\n'
                  if (bossData.chatworkAccountId) {
                    mension += `[To:${bossData.chatworkAccountId}]`
                  } else {
                    mension += '[To:]'
                  }
                  mension += `${bossData.userName}さん`
                  toInfo = '※再通知のため、To を担当者と上司にしています。'
                }
              }
            }
            const text = []
            if (requestPost.createDate) {
              text.push(`■ 初回登録日：${requestPost.createDate}`)
            }
            if (requestPost.dentatsuCategory) {
              text.push(`■ カテゴリー：${requestPost.dentatsuCategory.join('、')}`)
            }
            if (requestPost.inquiry_title) {
              text.push(`■ お問い合わせ内容：${requestPost.inquiry_title}`)
            }
            if (requestPost.clientName) {
              text.push(`■ お客様会社名（物件名）：${requestPost.clientName}`)
            }
            if (requestPost.clientPersonName) {
              text.push(`■ お客様名：${requestPost.clientPersonName}`)
            }
            if (requestPost.employeeName) {
              text.push(`■ 従業員名：${requestPost.employeeName}`)
            }
            if (requestPost.telephoneNumber) {
              text.push(`■ 電話番号：${requestPost.telephoneNumber}`)
            }
            text.push(`■ 依頼主：${requestPost.byUser}`)
            if (requestPost.chatMessage) {
              text.push('')
              text.push(`${requestPost.chatMessage}`)
            }
            text.push('')
            text.push(`●メインタスク：${viewUrl}`)
            text.push(`${toInfo}[/info]`)

            message = mension + '[info][title]デンタツ再通知です。[/title]' + text.join('\r\n')

          // デンタツ協力会社にメール送信成功の場合
          } else if (mail) {
            // 未定の場合
            if (requestPost.toStaffName == '未定') {
              mension = `[toall]${requestPost.toStaffName}さん`
            // 担当者あり、chatworkAccountIdがある場合
            } else if (chat.chatworkAccountId) {
              mension = `[To:${chat.chatworkAccountId}]${requestPost.toStaffName}さん`
            // 担当者あり、chatworkAccountIdがない場合
            } else {
              mension = `[To:]${requestPost.toStaffName}さん`
            }
            message = mension + '[info][title]デンタツ 協力会社へメール送信完了[/title]\nメインタスクから協力会社へメール送信しました。以下、メールの内容です。\n\n' + `${mail}\n●メインタスク：${viewUrl}[/info]`

          // それ以外の場合
          } else {
            // 未定の場合
            if (requestPost.toStaffName == '未定') {
              mension = `[toall]${requestPost.toStaffName}さん`
            // 担当者あり、chatworkAccountIdがある場合
            } else if (chat.chatworkAccountId) {
              mension = `[To:${chat.chatworkAccountId}]${requestPost.toStaffName}さん`
            // 担当者あり、chatworkAccountIdがない場合
            } else {
              mension = `[To:]${requestPost.toStaffName}さん`
            }

            if (!requestPost.employeeName) {
              requestPost.employeeName = ''
            }

            let context = ''
            let expression = ''

            if (requestPost.category.includes('デンタツ')) {
              context = {
                mension,
                inquiry_title: requestPost.inquiry_title,
                clientPersonName: requestPost.clientPersonName,
                telephoneNumber: requestPost.telephoneNumber,
                dentatsuCategory: requestPost.dentatsuCategory,
                viewUrl: viewUrl,
                sender: requestPost.byUser,
                clientName: requestPost.clientName,
                employeeName: requestPost.employeeName,
                staffNumber: (requestPost.staffNumber || '')
              }
              expression = '`' + REQUEST_POST_TRANSMISSION_FEATURES.REQUEST_POST_TRANSMISSION.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST_TRANSMISSION.messageTemplate + '`'
            } else {
              context = {
                mension,
                category: requestPost.category,
                inquiry_title: requestPost.inquiry_title,
                viewUrl: viewUrl,
                sender: requestPost.byUser
              }
              expression = '`' + REQUEST_POST_TRANSMISSION_FEATURES.REQUEST_POST_TRANSMISSION.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST_TRANSMISSION.messageTemplateAKBS + '`'
            }

            message = utils.evaluate(context, expression)
          }

          // デンタツ部署roomIDに送信
          let dentatsu = {}
          dentatsu = this.$store.getters.transDepartmentList.find((t) => {
            return t.departmentId == this.requestPost.toDepartmentId
          })

          if (!dentatsu.chatworkRoomId || dentatsu.chatworkRoomId == '') {
            await dialogs.showErrorDialog('チャット送信不可', 'ルームIDが取得できなかったため、チャット送信できませんでした。')
            return
          } else if (!dentatsu.chatworkApiToken || dentatsu.chatworkApiToken == '') {
            await dialogs.showErrorDialog('チャット送信不可', 'APIトークンが取得できなかったため、チャット送信できませんでした。')
            return
          }

          if (changeLimit) {
            message = message.replace('● メインタスク', `※期限変更あり：${changeLimit}\n● メインタスク`)
          }
          console.log(message)

          await chatwork.sendChatWorkMssage(
            dentatsu.chatworkRoomId,
            message,
            dentatsu.chatworkApiToken
          )
        }
      } else {
        if (REQUEST_POST_FEATURES.REQUEST_POST.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST && REQUEST_POST_FEATURES.REQUEST_POST.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST.enable) {
          let mension = ''
          let viewUrl = `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}RequestPost?requestPostId=${requestPostId}&mode=1`
          const userList = this.$store.getters.userList

          // ログインしているユーザー名を取得
          const loginUser = this.$store.getters.user
          // ログインユーザーIDと担当者IDが同じ場合はchatwork通知は行わない
          if (requestPost.toStaffId && loginUser.id == requestPost.toStaffId) {
            return
          }
          // 担当者IDがないデータは、名前で比較。同じ場合はchatwork通知は行わない
          if (utils.deleteKana(loginUser.user_name).replace(/\s+/g, '') == utils.deleteKana(requestPost.toStaffName).replace(/\s+/g, '')) {
            return
          }

          let toStaffId = ''
          let chat = null
          if (requestPost.toStaffName != '') {
            if (requestPost.toStaffId && requestPost.toStaffId != '') {
              toStaffId = requestPost.toStaffId

            // 担当者IDがない場合、担当者名から担当者Id取得
            } else {
              toStaffId = utils.getUserIdByName(requestPost.toStaffName, userList)
            }
          }

          // チャットワーク情報を取得
          if (toStaffId && toStaffId != '') {
            let c = await backend.searchData('user/getAllDataByUser', {day: utils.getToday(), userId: toStaffId})
            chat = c.data.data
          }

          if (chat.chatworkAccountId && chat.chatworkAccountId != '') {
            mension = `[To:${chat.chatworkAccountId}]${requestPost.toStaffName}さん`
          } else {
            if (requestPost.toStaffName == '未定') {
              mension = `[toall]${requestPost.toStaffName}さん`
            } else {
              mension = `[To:]${requestPost.toStaffName}さん`
            }
          }

          if (!chat.chatworkRoomId || chat.chatworkRoomId == '') {
            await dialogs.showErrorDialog('チャット送信不可', 'ルームIDが取得できなかったため、チャット送信できませんでした。')
            return
          } else if (!chat.chatworkApiTokenDepartment || chat.chatworkApiTokenDepartment == '') {
            await dialogs.showErrorDialog('チャット送信不可', 'APIトークンが取得できなかったため、チャット送信できませんでした。')
            return
          }

          const context = {
            mension,
            category: requestPost.category,
            inquiry_title: requestPost.inquiry_title,
            estimationCleanCategory: requestPost.estimationCleanCategory || [],
            estimationInspectCategory: requestPost.estimationInspectCategory || [],
            estimationOtherCategory: requestPost.estimationOtherCategory || [],
            viewUrl: viewUrl,
            sender: requestPost.byUser
          }

          // 非公開依頼の場合、URL削除、タイトル削除
          let expression = '`' + REQUEST_POST_FEATURES.REQUEST_POST.SEND_CHATWORK_MESSAGE_WHEN_REQUEST_POST.messageTemplate + '`'
          if (this.requestPost.category.includes('非公開依頼')) {
            expression = expression.replace('● メインタスク：${viewUrl}', '')
            context.inquiry_title = '※非公開のため詳細非表示'
          }

          // 社員の面接の場合、タイトル変更
          if (this.requestPost.category.includes('面接関連') && this.requestPost.interviewsRegularStaff) {
            let inte = ''
            if (requestPost.interviewsResult && requestPost.interviewsResult[0]) {
              inte = `（${requestPost.interviewsResult[0]}）`
            }
            context.inquiry_title = '※社員面接のため詳細非表示' + inte
          }

          let message = utils.evaluate(context, expression)

          if (changeLimit) {
            message = message.replace('● メインタスク', `※期限変更あり：${changeLimit}\n● メインタスク`)
          }
          console.log(message)

          await chatwork.sendChatWorkMssage(
            chat.chatworkRoomId,
            message,
            chat.chatworkApiTokenDepartment
          )
        }
      }
    },

    /**
     * 社員面接関連の場合、チャット送信
     */
    async interviewsSendChat() {
      // 面接関連、社員で採否決定
      if (this.requestPost.category.includes('面接関連') && this.requestPost.interviewsRegularStaff && this.requestPost.interviewsResult && this.requestPost.interviewsResult.length) {
        // 新卒
        if (this.requestPost.newGrad) {
          await this.$refs.InterviewsNewGradComponents.interviewsSendChat()
        } else {
          await this.$refs.InterviewsComponents.interviewsSendChat()
        }
      }
      return true
    },

    async setUserRetire() {
      // 社員で退職の場合
      if (this.isShowCategoryItem('雇い入れ（社員）') && this.requestPost.employmentRegularStaff && this.requestPost.employmentClass && this.requestPost.employmentClass[0] && this.requestPost.employmentClass[0].indexOf('社員退職') > -1) {
        // ユーザー情報に退職日と最終勤務日を入力
        if (this.requestPost.employmentUserId) {
          try {
            await backend.postData('user/saveRetireFromMain', { workEndDate: this.requestPost.employmentWorkEndDate, resignationDate: this.requestPost.employmentRetirementDate, id: this.requestPost.employmentUserId })
          } catch (error) {
            await dialogs.showErrorDialog('ユーザー情報更新失敗', 'ユーザー情報の「退職日」の更新に失敗しました。再度、更新ボタンを押してください。')
            return
          }
        } else {
          await dialogs.showErrorDialog('退職者の情報不足', '退職者のユーザーIDが取得できていないため、ユーザー情報に退職日を入力できません。ユーザー情報を直接修正するか、再度、退職者をドロップダウンから選択してください。')
          return
        }
      }
    },

    /**
     * 清掃員雇い入れ用チャット
     */
    async employmentSendChat(id, newFlag) {
      // 雇い入れ（清掃員）の退職の場合
      if ((this.isShowCategoryItem('雇い入れ') && !this.requestPost.employmentRegularStaff) || this.isShowCategoryItem('雇い入れ（清掃員）')) {
        await chatworkMessage.employmentDCChat(this, id, newFlag, this.requestPost)
      }
    },

    /**
     * 面接関連サブタスク自動登録
     * @param requestPostId リクエストポストID
     * @param requestNo 問い合わせNo
     */
    async saveInterviewsSubTask(requestPostId, requestNo) {
      // 社員の場合のみ
      if (!this.requestPost.interviewsRegularStaff) {
        return
      }

      // サブタスク
      const sub = []
      let isFinalTask = false

      let grad = '中途'
      if (this.requestPost.newGrad) {
        grad = '新卒'
      }

      // 採否決定の場合
      if (this.requestPost.interviewsResult[0].length) {
        // サブタスク登録されているか確認
        const savedSub = await taskRequestManager.getByRequestPostId(this, requestPostId, null)

        // 初期サブを完了にする
        await this.upDateInterviewsSubTaskInit(savedSub)

        // 面接関連のタスク依頼セットのリスト取得
        const mst1 = await taskRequestManager.getTaskSetMstByCategory(this, this.requestPost.category)
        const setMst = mst1.find((t) => {
          return t.name.indexOf('面接関連') > -1 && t.name.indexOf(this.requestPost.interviewsResult[0]) > -1 && t.name.indexOf(grad) > -1
        })

        if (setMst && setMst.group && setMst.group.length) {
          let displayOrder = 1
          if (savedSub && savedSub.length) displayOrder = savedSub.length + 1

          // サブタスクマスタ取得
          const mst2 = await taskRequestManager.getTaskMstByCategory(this, this.requestPost.category)
          if (mst2 && mst2.length) {
            // 担当者が決められていない場合は、人事部・未定にする
            let ch = { departmentName: '人事総務経理', toStaffName: '未定' }
            await taskRequestManager.setSubCharge(ch, ch, this.requestPost.toDepartment, this.requestPost.toDepartmentId, this.requestPost.toStaffId, this.requestPost.toStaffName, this.requestPost.byUserId, this.requestPost.byUser, this.$store.getters.departmentList, this.$store.getters.userDepartment, this.$store.getters.loginUserData)

            for (let i = 0; i < setMst.group.length; i++) {
              const s = setMst.group[i]
              for (let j = 0; j < mst2.length; j++) {
                const m = mst2[j]

                // すでに登録されている場合はスキップ
                if (savedSub && savedSub.length) {
                  const isSaved = savedSub.find((s) => {
                    return s.requestTask == m.name
                  })
                  if (isSaved && isSaved.requestTask) {
                    continue
                  }
                }

                // 該当のサブタスク
                if (s.task == m.name) {
                  const task = {
                    requestPostId: requestPostId,
                    taskRequestRequestNo: requestNo,
                    subTaskNo: '',
                    requestTask: m.name,
                    memo: m.memo,
                    finalCompletionTask: m.finalCompletionTask,
                    displayOrder: displayOrder++,
                    departmentName: ch.departmentName,
                    departmentId: ch.departmentId,
                    toStaffId: ch.toStaffId,
                    toStaffName: ch.toStaffName
                  }
                  // マスタにセットされている部署名、担当者をセット
                  await taskRequestManager.setSubCharge(m, task, this.requestPost.toDepartment, this.requestPost.toDepartmentId, this.requestPost.toStaffId, this.requestPost.toStaffName, this.requestPost.byUserId, this.requestPost.byUser, this.$store.getters.departmentList, this.$store.getters.userDepartment, this.$store.getters.loginUserData, this.$store.getters.loginUserData)
                  // サブの期限をセット
                  taskRequestManager.setSubLimitDate(task, m, this.requestPost)
                  // 最終完了タスクの場合
                  if (task.finalCompletionTask) {
                    // 他にも最終タスクがある場合、他のは空にする
                    if (isFinalTask) {
                      sub.forEach((s) => {
                        s.finalCompletionTask = ''
                      })
                    }
                    isFinalTask = true
                  }

                  // 詳細が設定されている場合
                  if (m.details && m.details.length) {
                    task.details = utils.clone(m.details)
                  }

                  // 最終完了タスクがなかった場合
                  if (i == setMst.group.length - 1 && !isFinalTask) {
                    task.finalCompletionTask = '1'
                  }
                  sub.push(task)
                }
              }
            }
          }
        }
        if (sub && sub.length) {
          // 保存
          for (let i = 0; i < sub.length; i++) {
            const s = sub[i]
            const saveRes = await taskRequestManager.register(this, s)
            if (!saveRes) {
              alert('サブタスク自動保存中にエラーが発生しました。')
              return
            }
          }

          // ログ保存
          logManager.recordingByRegist(this, true, 'サブタスク', 'サブタスク（お問い合わせ番号：' + requestNo + '）\r\n面接関連自動でサブタスク')

          // チャット送信
          for (let i = 0; i < sub.length; i++) {
            const s = sub[i]
            await taskRequestManager.isSendChatWorkSubTaskAndSend(this, this.requestPost, s)
          }
        }
      }
    },

    /**
     * 採否決定前の初期サブを登録
     */
    async saveInterviewsSubTaskInit(requestPostId, requestNo) {
      // 社員かつ、採否が決まっていない、かつ、まだ採用候補のチャットを送信していない場合
      if (this.requestPost.category.includes('面接関連') && this.requestPost.interviewsRegularStaff && (!this.requestPost.interviewsResult || !this.requestPost.interviewsResult.length) && !this.requestPost.sentChat) {
        // 保存されているサブタスクを取得
        const savedSub = await taskRequestManager.getByRequestPostId(this, requestPostId, null)

        const subForLog = []

        let displayOrder = 1

        // エナジャイザー確認タスク
        const taskName = 'エナジャイザー完了確認'
        let savedFlg = false

        // サブタスク内容
        const task = {
          requestPostId: requestPostId,
          taskRequestRequestNo: requestNo,
          subTaskNo: '',
          requestTask: taskName,
          finalCompletionTask: '',
          displayOrder,
          departmentName: this.requestPost.toDepartment,
          departmentId: this.requestPost.toDepartmentId,
          toStaffId: this.requestPost.toStaffId,
          toStaffName: this.requestPost.toStaffName,
          limitDate: moment().add(1, 'days').format('YYYY-MM-DD'),
          memo: '完了時に採用候補メッセージ送信可能です。\r\n※不採用決定時に未完了であれば自動で削除'
        }

        if (this.requestPost.enagizerLimit === 'limit' && this.requestPost.enagizerLimitDate) {
          if (this.requestPost.enagizerLimitDate > utils.getToday()) {
            task.limitDate = this.requestPost.enagizerLimitDate
          }
        }

        if (savedSub && savedSub.length) {
          displayOrder = savedSub.length + 1
          for (let i = 0; i < savedSub.length; i++) {
            const s = savedSub[i]
            // すでに登録済みなら何もしない
            if (s.requestTask === taskName) {
              savedFlg = true
              break
            }
          }
        }

        if (!savedFlg) {
          task.displayOrder = displayOrder
          displayOrder++
          let saveRes = await taskRequestManager.register(this, task)
          if (!saveRes) {
            alert('サブタスク自動保存中にエラーが発生しました。再度、更新ボタンを押してください。\r\n保存しようとしたサブタスク：' + taskName)
            return
          }
          subForLog.push(taskName)
        }

        const taskName2 = '採否決定'
        savedFlg = false

        // 採否決定サブも保存
        task.requestTask = taskName2
        task.memo = '採否が決まれば自動で完了します'
        task.finalCompletionTask = '1'
        task.displayOrder = displayOrder
        task.limitDate = moment().add(3, 'days').format('YYYY-MM-DD')

        if (savedSub && savedSub.length) {
          for (let i = 0; i < savedSub.length; i++) {
            const s = savedSub[i]
            // すでに登録済みなら何もしない
            if (s.requestTask === taskName2) {
              savedFlg = true
            }
            // 最終完了タスクが他にある場合
            if (s.finalCompletionTask === '1') {
              task.finalCompletionTask = ''
            }
          }
        }

        if (!savedFlg) {
          let saveRes = await taskRequestManager.register(this, task)
          if (!saveRes) {
            alert('サブタスク自動保存中にエラーが発生しました。再度、更新ボタンを押してください。\r\n保存しようとしたサブタスク：' + taskName2)
            return
          }

          subForLog.push(taskName2)
        }

        if (subForLog.length) {
          await dialogs.showInfoDialog('サブタスクも登録しました', subForLog.join('、') + 'のサブタスクも登録しました。')
        }
      }
    },

    /**
     * 採否決定後、初期サブを更新
     */
    async upDateInterviewsSubTaskInit(savedSub, isGetSub, isSelect) {
      // 面接関連かつ、社員の場合のみ
      if (!this.requestPost.category.includes('面接関連') || !this.requestPost.interviewsRegularStaff) return

      // サブタスクを取得する場合
      if (isGetSub) {
        savedSub = await taskRequestManager.getByRequestPostId(this, this.requestPost._id)
      }

      if (savedSub && savedSub.length) {
        // 対象のサブタスク
        const subs = ['エナジャイザー完了確認']

        // 採否が決定している場合は追加
        if (this.requestPost.interviewsResult && this.requestPost.interviewsResult.length) {
          subs.push('採否決定')
        }

        for (let i = 0; i < savedSub.length; i++) {
          const s = savedSub[i]
          // 保存済みのサブタスクに該当のサブが存在するか確認
          if (subs.includes(s.requestTask) && s.status == 'open') {
            s.status = 'done'
            s.doneDate = moment().format('YYYY-MM-DD HH:mm:ss')
            s.doneStaffName = this.$store.getters.user.user_name
            s.finalCompletionTask = ''

            // 採否未決定、採用候補チャットを送った場合
            if ((!this.requestPost.interviewsResult || !this.requestPost.interviewsResult.length) && this.requestPost.sendChat) {
              // エナジャイザー完了確認が完了していない場合
              if (s.requestTask === 'エナジャイザー完了確認') {
                const log = await dialogs.showConfirmDialog('【エナジャイザー完了確認】を完了しますか？', '採用候補チャットを送信済みですが、「エナジャイザー完了確認」 のサブタスクが未完了です。完了しますか？')
                if (log != 'YES') continue
              }

            // 不採用、エナジャイザー完了確認が完了していない場合
            } else if (this.requestPost.interviewsResult && this.requestPost.interviewsResult[0] == '社員不採用' && s.requestTask === 'エナジャイザー完了確認') {
              // タスクを削除
              await taskRequestManager.deleteTask2(this, s.subTaskNo)
              continue
            }

            await taskRequestManager.update(this, s)
          }
        }
      }

      if (isSelect) {
        const log = await dialogs.showConfirmDialog('処理完了', '一覧に遷移しますか？', '一覧へ', 'このまま')
        if (log == 'YES') {
          this.$router.push({ name: 'RequestPostList' })
        }
      }
    },

    /**
     * 社員面接で採否が決まっていれば、採否編集不可フラグを立てる
     */
    interviewsCannotEdit() {
      // 社員面接関連
      if (this.requestPost.category.includes('面接関連') && this.requestPost.interviewsRegularStaff) {
        if (this.requestPost.interviewsResult && this.requestPost.interviewsResult.length) {
          // 今回切り替わる場合
          if (!this.requestPost.interviewsResNotEditable) {
            this.requestPost.resultSetDate = moment().format('YYYY-MM-DD HH:mm')
          }
          this.requestPost.interviewsResNotEditable = true
        } else {
          this.requestPost.interviewsResNotEditable = false
        }
      // それ以外は社員フラグ、新卒フラグをfalseにする（誤ってカテゴリを選択した場合に備えて）
      } else {
        this.requestPost.interviewsRegularStaff = false
        this.requestPost.newGrad = false
      }
    },

    /**
     * フラグのチェック
     */
    checkEmploymentRegularStaff() {
      // 雇い入れ社員で社員フラグONの場合はそのまま
      if (this.requestPost.category.includes('雇い入れ（社員）') && this.requestPost.employmentRegularStaff) {
        return
      }
      // それ以外は社員フラグfalseにする（誤ってカテゴリを選択した場合に備えて）
      this.requestPost.employmentRegularStaff = false
      this.requestPost.employmentNewGrad = false
    },

    /**
     * 受注データを保存するために結合
     * @param data 受注データ
     */
    additionOrderData(data) {
      this.requestPost = Object.assign(this.requestPost, data)
    },

    /**
     * メインタスクを完了に変更
     */
    /**
     * 録音確認タスクの履歴（akbsRecords）が、開いたときから変わっていないか確かめる
     * AKBS の休み登録は同じ清掃員の未完了タスクに履歴を足すので、開いている間に増えることがある。古い内容で更新・完了すると足された分が消える
     * 変わっていたら知らせて開き直す（保存はしない）
     * @returns 変わっていたら true（呼び元は処理をやめる）
     */
    async akbsRecordsChanged() {
      if (!this.requestPost._id || !this.isShowCategoryItem('AKBS録音確認')) {
        return false
      }
      const latest = await requestPostManager.getRequestPost(this, this.requestPost._id)
      if (!latest) {
        return false
      }
      const before = JSON.stringify(this.requestPost.akbsRecords || [])
      const after = JSON.stringify(latest.akbsRecords || [])
      if (before === after) {
        return false
      }
      await dialogs.showInfoDialog('内容が変わっています', '内容が変わっています。メインタスクをリロードします。', 'OK')
      window.location.reload()
      return true
    },

    async statusDone() {
      // 同行の場合、完了不可
      if (this.requestPost.accompanyId) {
        await dialogs.showErrorDialog('完了不可', '同行報告書と紐づいているため手動で完了できません。')
        return
      }

      // リクエストポストIDを条件にサブタスクを全件取得
      let mainSubTasks = await taskRequestManager.getByRequestPostId(this, this.requestPost._id, null)
      // サブタスクに未完了タスクがある場合、完了ボタンは非アクティブ
      let result = mainSubTasks.every(function(val){
        return val.status == 'done'
      })
      if (!result) {
        await dialogs.showErrorDialog('サブタスクに未完了あり', 'サブタスクに未完了のものがあるので、メインタスク完了できません。')
        this.isCompleteButtunActive = false
        return
      }

      // 録音確認タスクは、開いている間に AKBS の休み登録で履歴が足されることがある。変わっていたら完了せずに開き直す
      if (await this.akbsRecordsChanged()) {
        return
      }

      const dialogResult = await dialogs.showConfirmDialog('タスクの完了（完了後は編集不可）', 'タスクを完了すると編集できなくなります。完了してよろしいですか？', 'はい', 'キャンセル')
      if (dialogResult === 'YES') {
        this.isSaving = true
        if (this.requestPost.type == 'apollo_request_post') {
          this.requestPost.status = 'done'
          const result = await requestPostManager.update(this, this.requestPost)
          if (result) {
            await requestPostManager.autoEmployTaskSave(this, { _id: result.id, ...this.requestPost })
            await dialogs.showSuccessDialog('タスクの完了', '完了にしました。')
            logManager.recording(this, logManager.Loglevel.INFO, 'メインタスク', 'ステータス完了', 'メインタスク（お問い合わせ番号：' + this.requestPost.requestNo + '）のステータスを完了しました。')
          } else {
            await dialogs.showErrorDialog('エラー', '完了にできませんでした。')
          }
        }
        this.isSaving = false
        this.$router.push({ name: 'RequestPostList' })
      }
    },

    // changeValidateContractDate(result, message) {
    //   this.contractDateResult = result
    //   this.contractDateMessage = message
    // },

    changeValidateContractEndDate(result, message) {
      this.contractEndDateResult = result
      this.contractEndDateMessage = message
    },

    changeValidateClassification(result, message) {
      this.classificationResult = result
      this.classificationMessage = message
    },

    changeValidateSpecialCleanWorkItem(result, message) {
      this.specialCleanWorkItemResult = result
      this.specialCleanWorkItemMessage = message
    },

    /**
     * 登録内容 取得（過去の受注データ）
     */
    getOrderSummary() {
      let ret = ''
      // 郵便番号
      let postalCode = '---'
      if (this.estimateData.buildingPostalCode && this.estimateData.buildingPostalCode != '') {
        postalCode = this.estimateData.buildingPostalCode
      }

      ret += '物件名：' + this.getOutputSummaryText(this.estimateData.buildingName)
      ret += '、　郵便番号：' + this.getOutputSummaryText(postalCode)
      ret += '、　物件住所：' + this.getOutputSummaryText(this.estimateData.buildingAddress2)
      ret += '、　契約日：' + this.getOutputSummaryText(this.requestPost.contractDate)
      ret += '、　契約終了日：' + this.getOutputSummaryText(this.requestPost.contractEndDate) + '\r\n'
      ret += '---------------------------------------------\r\n'

      // ラウンドサービス
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('1') > -1) {
        ret += '作業内容：ラウンドサービス'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.estimationRoundCount)
        ret += '、　開始日：' + this.getOutputSummaryText(this.requestPost.estimationRoundStartDate)
        ret += '、　作業曜日：' + this.getOutputSummaryText(this.requestPost.roundServiceWorkDays)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationRoundUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.estimationRoundSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationRoundPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.estimationRoundCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationRoundCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // ラウンドプラス
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('2') > -1) {
        let details = ''
        if (this.requestPost.estimationRoundPlusCategorySelect) {
          details = '（' + this.requestPost.estimationRoundPlusCategorySelect + '）'
        }
        ret += '作業内容：ラウンドプラス' + details
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.estimationRoundPlusCount, true)
        ret += '、　開始日：' + this.getOutputSummaryText(this.requestPost.estimationRoundPlusStartDate)
        if (this.requestPost.estimationRoundPlusWorkRemarks && this.requestPost.estimationRoundPlusWorkRemarks.length > 0) {
          this.requestPost.estimationRoundPlusWorkRemarks.forEach((sss, index) => {
            let idx = index + 1
            ret += '、　作業曜日【' + idx + '】：' + this.getOutputSummaryText(sss.workDays)
            ret += '、　作業開始時間【' + idx + '】：' + this.getOutputSummaryText(sss.startTime)
            ret += '、　作業終了時間【' + idx + '】：' + this.getOutputSummaryText(sss.endTime)
          });
        }
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationRoundPlusUnitPrice))

        // 発注明細が新仕様の場合
        if (this.requestPost.estimationRoundPlusPurchase && this.requestPost.estimationRoundPlusPurchase.length) {
          this.requestPost.estimationRoundPlusPurchase.forEach((p) => {
            let name = utils.deleteKana(p.typeName)
            // eslint-disable-next-line no-irregular-whitespace
            ret += `、　${name}（発注先名：${p.supplier}、 発注金額：${utils.numberToLocale(p.price)}）`
          })
        } else {
          let supplier = ''
          this.requestPost.estimationRoundPlusSupplier.forEach(sss => {
            if (supplier != '') {
              supplier += '、'
            }
            supplier += this.getOutputSummaryText(sss.supplier)
          });
          ret += '、　発注先名：' + supplier
          ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationRoundPlusPrice))
        }

        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.estimationRoundPlusCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationRoundPlusCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 日常清掃
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('3') > -1) {
        ret += '作業内容：日常清掃'
        if (this.requestPost.orderEstimationEverydays) {
          this.requestPost.orderEstimationEverydays.forEach(sss => {
            ret += '、　作業内容：日常清掃【' + this.getOutputSummaryText(sss.everydayCleanContents) + '】'
            ret += '、　清掃回数：' + this.getOutputSummaryText(sss.estimationEverydayCount)
            ret += '、　開始日：' + this.getOutputSummaryText(sss.everydayStartDate)
            if (sss.everydayCleanWorkDays) {
              let remarks = this.getSummaryWorkRemarks(sss.everydayCleanWorkDays)
              ret += remarks
            }
          });
        }
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationEverydayUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.estimationEverydaySupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationEverydayPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.estimationEverydayCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationEverydayCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 管理員業務
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('4') > -1) {
        ret += '作業内容：管理員業務'
        if (this.requestPost.orderManagerWorks) {
          this.requestPost.orderManagerWorks.forEach(sss => {
            ret += '、　作業内容：管理員業務【' + this.getOutputSummaryText(sss.managerWorkContents) + '】'
            ret += '、　清掃回数：' + this.getOutputSummaryText(sss.managerWorkCount)
            ret += '、　開始日：' + this.getOutputSummaryText(sss.managerWorkStartDate)
            if (sss.managerWorkDays) {
              let remarks = this.getSummaryWorkRemarks(sss.managerWorkDays)
              ret += remarks
            }
          });
        }
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.managerWorkUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.managerWorkSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.managerWorkPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.managerWorkCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.managerWorkCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 定期清掃
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('5') > -1) {
        ret += '作業内容：定期清掃'
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.regularCleanSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.regularCleanPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.regularCleanCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.regularCleanCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'

        if (this.requestPost.orderRegularCleans) {
          this.requestPost.orderRegularCleans.forEach(sss => {
            ret += '作業内容：定期清掃【' + this.getOutputSummaryText(sss.regularCleanContents) + '】'
            ret += '、　清掃回数：' + this.getOutputSummaryText(sss.regularCleanCount)
            ret += '、　初回作業年：' + this.getOutputSummaryText(sss.regularCleanFirstWorkYear)
            ret += '、　初回作業月：' + this.getOutputSummaryText(sss.regularCleanFirstWorkMonth)
            ret += '、　実施月：' + this.getOutputSummaryText(sss.regularCleanImplementationMonth)
            ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(sss.regularCleanUnitPrice))
            ret += '、　対象箇所：' + this.getOutputSummaryText(sss.regularCleanTargetArea)
            ret += '、　作業内容：' + this.getOutputSummaryText(sss.regularCleanDescriptionWork)
            ret += '、　カーペット：' + this.getOutputSummaryText(sss.regularCleanCarpet) + '\r\n'
            ret += '---------------------------------------------\r\n'
          });
        }
      }

      // フロントサポート
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('6') > -1) {
        ret += '作業内容：フロントサポート'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.frontSupportCount)
        ret += '、　開始日：' + this.getOutputSummaryText(this.requestPost.frontSupportStartDate)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.frontSupportFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.frontSupportFirstWorkMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.frontSupportUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.frontSupportSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.frontSupportPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.frontSupportCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.frontSupportCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // フロントサポートプラス
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('7') > -1) {
        ret += '作業内容：フロントサポートプラス'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.frontSupportPlusCount)
        ret += '、　開始日：' + this.getOutputSummaryText(this.requestPost.frontSupportPlusStartDate)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.frontSupportPlusFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.frontSupportPlusFirstWorkMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.frontSupportPlusUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.frontSupportPlusSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.frontSupportPlusPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.frontSupportPlusCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.frontSupportPlusCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // ラウンドトラッシュ
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('8') > -1) {
        ret += '作業内容：ラウンドトラッシュ'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.roundTrashCount)
        ret += '、　開始日：' + this.getOutputSummaryText(this.requestPost.roundTrashStartDate)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.roundTrashFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.roundTrashFirstWorkMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.roundTrashUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.roundTrashSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.roundTrashPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.roundTrashCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.roundTrashCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // クオリティレポート
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('9') > -1) {
        ret += '作業内容：クオリティレポート'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.qualityReportCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.qualityReportFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.qualityReportFirstWorkMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.qualityReportUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.qualityReportSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.qualityReportPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.qualityReportCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.qualityReportCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // ガラス清掃
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('10') > -1) {
        ret += '作業内容：ガラス清掃'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.glassCleanCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.glassCleanFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.glassCleanFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.glassCleanImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.glassCleanUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.glassCleanSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.glassCleanPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.glassCleanCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.glassCleanCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 排水管清掃
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('11') > -1) {
        ret += '作業内容：排水管清掃'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.estimationDorainPipeCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.estimationDorainPipeFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.estimationDorainPipeFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.estimationDorainPipeImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationDorainPipeUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.estimationDorainPipeSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationDorainPipePrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.estimationDorainPipeCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationDorainPipeCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 貯水槽清掃
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('12') > -1) {
        ret += '作業内容：貯水槽清掃'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.estimationWaterTankCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.estimationWaterTankFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.estimationWaterTankFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.estimationWaterTankImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationWaterTankUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.estimationWaterTankSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationWaterTankPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.estimationWaterTankCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.estimationWaterTankCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 植栽剪定
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('13') > -1) {
        ret += '作業内容：植栽剪定'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.plantingCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.plantingFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.plantingFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.plantingImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.plantingUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.plantingSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.plantingPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.plantingCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.plantingCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 特別清掃
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('14') > -1) {
        if (this.requestPost.orderSpecialCleans) {
          this.requestPost.orderSpecialCleans.forEach(sss => {
            ret += '作業内容：特別清掃【' + constants.getSpecialCleanWorkItemName(this.getOutputSummaryText(sss.specialCleanWorkItem)) + '】'
            ret += '、　清掃回数：' + this.getOutputSummaryText(sss.specialCleanCount)
            ret += '、　初回作業年：' + this.getOutputSummaryText(sss.specialCleanFirstWorkYear)
            ret += '、　初回作業月：' + this.getOutputSummaryText(sss.specialCleanFirstWorkMonth)
            ret += '、　実施月：' + this.getOutputSummaryText(sss.specialCleanImplementationMonth)
            ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(sss.specialCleanUnitPrice))
            ret += '、　発注先名：' + this.getOutputSummaryText(sss.specialCleanSupplier)
            ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(sss.specialCleanPrice))
            ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(sss.specialCleanCommissionFlag, true))
            ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(sss.specialCleanCommissionPrice, true)) + '\r\n'
            ret += '---------------------------------------------\r\n'
          });
        }
      }

      // 消防設備点検
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('15') > -1) {
        ret += '作業内容：消防設備点検'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.fireInspectCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.fireInspectFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.fireInspectFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.fireInspectMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.fireInspectUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.fireInspectSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.fireInspectPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.fireInspectCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.fireInspectCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 建築設備定期検査
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('16') > -1) {
        ret += '作業内容：建築設備定期検査'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.constructionEquipmentFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.constructionEquipmentInspectCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 特定建築物定期調査
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('17') > -1) {
        ret += '作業内容：特定建築物定期調査'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.specificInspectCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.specificInspectFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.specificInspectFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.specificInspectImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.specificInspectUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.specificInspectSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.specificInspectPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.specificInspectCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.specificInspectCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 共用部設備点検
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('18') > -1) {
        ret += '作業内容：共用部設備点検'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionFirstWorkMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.commonAreaFacilityInspectionCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // エレベーター保守点検
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('19') > -1) {
        ret += '作業内容：エレベーター保守点検'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.evInspectCount)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.evInspectImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.evInspectUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.evInspectSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.evInspectPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.evInspectCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.evInspectCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 増圧ポンプ点検
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('20') > -1) {
        ret += '作業内容：増圧ポンプ点検'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.pressPumpInspectCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.pressPumpInspectFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.pressPumpInspectFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.pressPumpInspectImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.pressPumpInspectUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.pressPumpInspectSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.pressPumpInspectPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.pressPumpInspectCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.pressPumpInspectCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 給排水ポンプ点検
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('21') > -1) {
        ret += '作業内容：給排水ポンプ点検'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.waterSupplyDrainagePumpInspectionCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 簡易専用水道
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('22') > -1) {
        ret += '作業内容：簡易専用水道'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.simpleWaterSupplyCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.simpleWaterSupplyFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.simpleWaterSupplyFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.simpleWaterSupplyImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.simpleWaterSupplyUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.simpleWaterSupplySupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.simpleWaterSupplyPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.simpleWaterSupplyCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.simpleWaterSupplyCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 管球対応
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('23') > -1) {
        ret += '作業内容：管球対応'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.tubeBulbSupportCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.tubeBulbSupportFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.tubeBulbSupportFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.tubeBulbSupportImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.tubeBulbSupportUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.tubeBulbSupportSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.tubeBulbSupportPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.tubeBulbSupportCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.tubeBulbSupportCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 粗大ごみ対応
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('24') > -1) {
        ret += '作業内容：粗大ごみ対応'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.bulkyWasteSupportCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.bulkyWasteSupportFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.bulkyWasteSupportFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.bulkyWasteSupportImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.bulkyWasteSupportUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.bulkyWasteSupportSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.bulkyWasteSupportPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.bulkyWasteSupportCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.bulkyWasteSupportCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 物品販売
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('25') > -1) {
        ret += '作業内容：物品販売'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.merchandiseSalesCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.merchandiseSalesFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.merchandiseSalesFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.merchandiseSalesImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.merchandiseSalesUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.merchandiseSalesSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.merchandiseSalesPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.merchandiseSalesCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.merchandiseSalesCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 緊急対応
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('26') > -1) {
        ret += '作業内容：緊急対応'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.emergencyResponseCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.emergencyResponseFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.emergencyResponseFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.emergencyResponseImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.emergencyResponseUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.emergencyResponseSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.emergencyResponsePrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.emergencyResponseCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.emergencyResponseCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 防火対象物点検
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('27') > -1) {
        ret += '作業内容：防火対象物点検'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.firePreventionObjectInspectionCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 汚水槽清掃
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('101') > -1) {
        ret += '作業内容：汚水槽清掃'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.sewageTankCleaningCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.sewageTankCleaningFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.sewageTankCleaningFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.sewageTankCleaningImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.sewageTankCleaningUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.sewageTankCleaningSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.sewageTankCleaningPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.sewageTankCleaningCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.sewageTankCleaningCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 防火設備定期検査
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('102') > -1) {
        ret += '作業内容：防火設備定期検査'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.fireProtectionInspectionCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.fireProtectionInspectionFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.fireProtectionInspectionFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.fireProtectionInspectionImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.fireProtectionInspectionUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.fireProtectionInspectionSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.fireProtectionInspectionPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.fireProtectionInspectionCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.fireProtectionInspectionCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // 連結送水管耐圧性能点検
      if (this.requestPost.estimationDetailsCategoryCode.indexOf('103') > -1) {
        ret += '作業内容：連結送水管耐圧性能点検'
        ret += '、　清掃回数：' + this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionCount)
        ret += '、　初回作業年：' + this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionFirstWorkYear)
        ret += '、　初回作業月：' + this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionFirstWorkMonth)
        ret += '、　実施月：' + this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionImplementationMonth)
        ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionUnitPrice))
        ret += '、　発注先名：' + this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionSupplier)
        ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionPrice))
        ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionCommissionFlag, true))
        ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(this.requestPost.connectingWaterPipePressureInspectionCommissionPrice, true)) + '\r\n'
        ret += '---------------------------------------------\r\n'
      }

      // スポット清掃
      if (this.requestPost.orderSpot && this.requestPost.orderSpot.length) {
        for (let i = 0; i < this.requestPost.orderSpot.length; i++) {
          const o = this.requestPost.orderSpot[i]
          ret += '作業内容：' + this.getOutputSummaryText(o.name)
          ret += '、　清掃回数：' + this.getOutputSummaryText(o.count)
          ret += '、　初回作業年：' + this.getOutputSummaryText(o.firstWorkYear)
          ret += '、　初回作業月：' + this.getOutputSummaryText(o.firstWorkMonth)
          ret += '、　実施月：' + this.getOutputSummaryText(o.implementationMonth)
          ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(o.unitPrice))
          ret += '、　発注先名：' + this.getOutputSummaryText(o.supplier)
          ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(o.orderPrice))
          ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(o.commissionFlag, true))
          ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(o.commissionPrice, true))
          ret += '、　対象箇所：' + this.getOutputSummaryText(o.spotArea)
          ret += '、　作業内容：' + this.getOutputSummaryText(o.spotContent)
          ret += '、　カーペット：' + this.getOutputSummaryText(o.spotCarpet) + '\r\n'
          ret += '---------------------------------------------\r\n'
        }
      }

      // カテゴリコードがないもの
      if (this.requestPost.orderOthers && this.requestPost.orderOthers.length) {
        for (let i = 0; i < this.requestPost.orderOthers.length; i++) {
          const o = this.requestPost.orderOthers[i]
          ret += '作業内容：' + this.getOutputSummaryText(o.name)
          ret += '、　清掃回数：' + this.getOutputSummaryText(o.count)
          ret += '、　初回作業年：' + this.getOutputSummaryText(o.firstWorkYear)
          ret += '、　初回作業月：' + this.getOutputSummaryText(o.firstWorkMonth)
          ret += '、　実施月：' + this.getOutputSummaryText(o.implementationMonth)
          ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(o.unitPrice))
          ret += '、　発注先名：' + this.getOutputSummaryText(o.supplier)
          ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(o.orderPrice))
          ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(o.commissionFlag, true))
          ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(o.commissionPrice, true)) + '\r\n'
          ret += '---------------------------------------------\r\n'
        }
      }

      return ret
    },

    /**
     * 登録内容 取得（新受注データ）全て配列
     */
    getOrderSummaryNew() {
      let ret = ''
      // 郵便番号
      let postalCode = '---'
      if (this.estimateData.buildingPostalCode && this.estimateData.buildingPostalCode != '') {
        postalCode = this.estimateData.buildingPostalCode
      }

      ret += '物件名：' + this.getOutputSummaryText(this.estimateData.buildingName)
      ret += '、　郵便番号：' + this.getOutputSummaryText(postalCode)
      ret += '、　物件住所：' + this.getOutputSummaryText(this.estimateData.buildingAddress2)
      ret += '、　契約日：' + this.getOutputSummaryText(this.requestPost.contractDate)
      ret += '、　契約終了日：' + this.getOutputSummaryText(this.requestPost.contractEndDate)
      ret += '、　均等請求：' + this.getCommissionFlagVal(this.getOutputSummaryText(this.requestPost.monthlyFeeFlag, true))
      ret += '\r\n---------------------------------------------\r\n'

      const PROPSET = constants.PROPSET

      for (let i = 0; i < PROPSET.length; i++) {
        const p = PROPSET[i]
        // 日常・管理・定期・特別
        if (['3', '4', '5', '14'].includes(p.code)) {
          ret = this.getSummaryVal2(p.val, ret)
        } else {
          ret = this.getSummaryVal(p.val, ret)
        }
      }
      return ret
    },

    /**
     * 登録内容生成
     * @param code カテゴリーコード
     * @param tar 対象プロパティー
     * @param ret 登録内容文字列
     */
    getSummaryVal(tar, ret) {
      // console.log(this.requestPost[tar])
      if (this.requestPost[tar] && this.requestPost[tar].length) {
        for (let i = 0; i < this.requestPost[tar].length; i++) {
          const r = this.requestPost[tar][i]

          if (['28', 'none'].includes(r.categoryCode)) {
            ret += '作業内容：' + r.content
          } else {
            ret += '作業内容：' + r.name
          }

          // RLSプラス
          if (['2'].includes(r.categoryCode)) {
            ret += '（' + r.content + '）'
            // 作業内容コードがあるもの
            if (r.workCode) {
              ret += '、　作業コード：' + this.getOutputSummaryText(r.workCode.code, false)
            }
          } else {
            // 作業内容コードがあるもの
            if (r.workCode) {
              ret += '、　作業コード：' + this.getOutputSummaryText(r.workCode.code, false)
            }

            if (r.count2) {
              ret += '、　清掃回数：' + this.getOutputSummaryText(r.count2, false)
            } else {
              ret += '、　清掃回数：' + this.getOutputSummaryText(r.dispCount, false)
            }

            // MRSのゴミ搬出回数
            if (r.categoryCode == '29') {
              ret += '、　ゴミ搬出回数：' + this.getOutputSummaryText(this.getMrsTrashCount(r), false)
            }

            if (r.startDate || r.startDate == '') {
              ret += '、　開始日：' + this.getOutputSummaryText(r.startDate, false)
            }

            if (r.workDays) {
              ret += '、　作業曜日：' + this.getOutputSummaryText(r.workDays, false)
            }

            if (r.photo) {
              let photo = '有'
              if (r.photoVal == '0') {
                photo = '無'
              }
              ret += '、　写真報告：' + photo
            }

            if (r.firstWorkYear || r.firstWorkYear == '') {
              ret += '、　初回作業年：' + this.getOutputSummaryText(r.firstWorkYear, false)
            }

            if (r.firstWorkMonth) {
              ret += '、　初回作業月：' + this.getOutputSummaryText(r.firstWorkMonth, false)
            }

            if (r.implementationMonth) {
              ret += '、　実施月：' + this.getOutputSummaryText(r.implementationMonth, false)
            }
          }

          // スポット清掃
          if (r.categoryCode == '28') {
            ret += '、　対象箇所：' + this.getOutputSummaryText(r.area)
            ret += '、　作業内容：' + this.getOutputSummaryText(r.workDetail)
          }

          if (['28'].includes(r.categoryCode)) {
            ret += '、\r\n'
          } else {
            ret += '、　'
          }

          ret += '受注単価：' + utils.numberToLocale(this.getOutputSummaryText(r.unitPrice, false))
          ret += '、　月額：' + utils.numberToLocale(this.getOutputSummaryText(r.monthlyFee, true))

          // RLSプラス以外の発注データ
          if (r.categoryCode != '2') {
            ret += '、　発注先名：' + this.getOutputSummaryText(r.supplier, false)
            ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(r.orderPrice, false))
          // RLSプラス
          } else {
            if (r.purchase) {
              r.purchase.forEach((p) => {
                let name = ''
                if (p.typeName) {
                  // 項目名
                  name = utils.deleteKana(p.typeName)

                  // 巡回清掃の場合
                  if (name.indexOf('巡回') > -1) {
                    ret += `\r\n（${name}➡`

                    // 開始日
                    if (r.startDate || r.startDate == '') {
                      ret += '　開始日：' + this.getOutputSummaryText(r.startDate, false)
                    }
                    // 清掃回数
                    ret += '、　清掃回数：' + this.getOutputSummaryText(r.count2, false)
                    // 写真報告
                    if (r.photo) {
                      let photo = '有'
                      if (r.photoVal == '0') {
                        photo = '無'
                      }
                      ret += '、　写真報告：' + photo
                    }
                    // 発注先
                    ret += '、　発注先名：' + p.supplier
                    // 発注金額
                    ret += '、　発注金額：' + utils.numberToLocale(p.price)
                    // 改行
                    ret += '）\r\n'
                  // 固定清掃の場合
                  } else if (name.indexOf('固定') > -1) {
                    ret += `（${name}➡`

                    if (r.specificTime) {
                      ret += '　時間指定：' + this.getCommissionFlagVal(this.getOutputSummaryText(r.specificTime, true) + '、')
                    }

                    // 作業曜日
                    if (r.remarks) {
                      for (let j = 0; j < r.remarks.length; j++) {
                        const m = r.remarks[j]
                        let num = j + 1
                        if (j) {
                          ret += '、'
                        }
                        ret += '　作業曜日【' + num + '】：' + this.getOutputSummaryText(m.workDays)
                        ret += this.getRemarkTimeSummary(m, num)
                      }
                    }
                    // 発注先
                    ret += '、　発注先名：' + p.supplier
                    // 発注金額
                    ret += '、　発注金額：' + utils.numberToLocale(p.price)
                    // 改行
                    ret += '）\r\n'
                  // 定期清掃の場合
                  } else {
                    ret += `（${name}➡`
                    // 初回年
                    if (r.firstWorkYear || r.firstWorkYear == '') {
                      ret += '　初回作業年：' + this.getOutputSummaryText(r.firstWorkYear, false)
                    }
                    // 初回月
                    if (r.firstWorkMonth) {
                      ret += '、　初回作業月：' + this.getOutputSummaryText(r.firstWorkMonth, false)
                    }
                    // 作業月
                    if (r.implementationMonth) {
                      ret += '、　作業月：' + this.getOutputSummaryText(r.implementationMonth, false)
                    }
                    // 発注先
                    ret += '、　発注先名：' + p.supplier
                    // 発注金額
                    ret += '、　発注金額：' + utils.numberToLocale(p.price)
                    // 改行
                    ret += '）\r\n'
                  }
                }
              })
            }
          }

          ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(r.commissionFlag, true))
          ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(r.commissionPrice, true)) + '\r\n'
          ret += '---------------------------------------------\r\n'
        }
      }
      return ret
    },

    /**
     * 登録内容生成（日常・管理・定期・特別）
     * @param code カテゴリーコード
     * @param tar 対象プロパティー
     * @param ret 登録内容文字列
     */
    getSummaryVal2(tar, ret) {
      // console.log(this.requestPost[tar])
      if (this.requestPost[tar] && this.requestPost[tar].length) {
        for (let i = 0; i < this.requestPost[tar].length; i++) {
          const r = this.requestPost[tar][i]

          ret += '作業内容：' + r.name

          // 作業内容コードがあるもの
          if (r.workCode) {
            ret += '、　作業コード：' + this.getOutputSummaryText(r.workCode.code, false)
          }

          for (let j = 0; j < r.details.length; j++) {
            const d = r.details[j]
            // 特別清掃で新しい仕様の調整費は表示しない
            if (r.categoryCode == '14' && d.newData && d.content.indexOf('調整費') > -1) {
              continue
            }

            if (r.categoryCode == '5') {
              ret += ''
            }
            else if (j >= 1) {
              ret += '、\r\n'
            } else {
              ret += '、　'
            }
            if (r.categoryCode == '5') {
              if (r.details.length > 1) {
                ret += '\r\n【' + (j + 1) + '】'
              }

            } else {
              ret += '作業内容：【' + d.content.replace(/\r\n/g, '') + '】'
            }

            // 日常・管理
            if (['3', '4'].includes(r.categoryCode)) {
              ret += '、　清掃回数：' + this.getOutputSummaryText(d.count2, false)

              if (d.specificTime) {
                ret += '、　時間指定：' + this.getCommissionFlagVal(this.getOutputSummaryText(d.specificTime, true))
              }

              ret += '、　開始日：' + this.getOutputSummaryText(d.startDate, false)
            } else {
              // 特別清掃
              if (r.categoryCode == '14') {
                // 作業内容コードがあるもの（古い仕様の特別清掃）
                if (d.workCode) {
                  ret += '、　作業コード：' + this.getOutputSummaryText(d.workCode.code, false)
                }
              }
              if (d.dispCount || d.dispCount == '') {
                ret += '、　清掃回数：' + this.getOutputSummaryText(d.dispCount, false)
              }
              ret += '、　初回作業年：' + this.getOutputSummaryText(d.firstWorkYear, false)
              ret += '、　初回作業月：' + this.getOutputSummaryText(d.firstWorkMonth, false)
              ret += '、　実施月：' + this.getOutputSummaryText(d.implementationMonth, false)
              if (d.unitPrice || d.unitPrice == '') {
                ret += '、　受注単価：' + utils.numberToLocale(this.getOutputSummaryText(d.unitPrice, false))
              }
              // 定期清掃
              if (r.categoryCode == '5') {
                ret += '、　対象箇所：' + this.getOutputSummaryText(d.area)
                ret += '、　作業内容：' + this.getOutputSummaryText(d.workDetail)
              }
            }

            if (d.remarks) {
              for (let k = 0; k < d.remarks.length; k++) {
                const m = d.remarks[k]
                let num = k + 1
                ret += '、\r\n作業曜日【' + num + '】：' + this.getOutputSummaryText(m.workDays)
                ret += this.getRemarkTimeSummary(m, num)
              }
            }
          }

          ret += '、\r\n'
          // 日常・管理
          if (['3', '4'].includes(r.categoryCode) || (r.categoryCode == '14' && (r.unitPrice || r.unitPrice == ''))) {
            if (r.categoryCode == '14' && (r.dispCount || r.dispCount == '')) {
              ret += '清掃回数：' + this.getOutputSummaryText(r.dispCount, false)
              ret += '、　'
            }
            ret += '受注単価：' + utils.numberToLocale(this.getOutputSummaryText(r.unitPrice, false))
            ret += '、　'
          }
          ret += '月額：' + utils.numberToLocale(this.getOutputSummaryText(r.monthlyFee, true))
          ret += '、　発注先名：' + this.getOutputSummaryText(r.supplier, false)
          ret += '、　発注金額：' + utils.numberToLocale(this.getOutputSummaryText(r.orderPrice, false))

          ret += '、　手数料有無：' + this.getCommissionFlagVal(this.getOutputSummaryText(r.commissionFlag, true))
          ret += '、　手数料金額：' + utils.numberToLocale(this.getOutputSummaryText(r.commissionPrice, true)) + '\r\n'
          ret += '---------------------------------------------\r\n'
        }
      }
      return ret
    },

    /**
     * 手数料有無フラグの値 取得
     */
    getCommissionFlagVal(flag) {
      // 値が「---」の場合は値をそのまま返す
      if(flag == '---') return flag
      if (flag && flag.length) {
        let val = ''
        if (flag[0] == '1') {
          val = '有'
        } else if (flag[0] == '0') {
          val = '無'
        }
        return val
      }
    },

    /**
     * 登録内容 変更
     */
    changeOrderSummary() {
      this.requestPost.orderSummary = this.getOrderSummary()
    },

    /**
     * 登録内容 作業曜日・時間の1行の時間の文
     * 曜日ごとの形（受注画面の新しい形。曜日ごとに時間が違うことがある）は、時間帯が同じ曜日をまとめて「作業時間【1】：月・水 8:00〜12:00、火 9:00〜13:00」
     * 以前の形は今までどおり「作業開始時間【1】：8:00、作業終了時間【1】：12:00」
     */
    getRemarkTimeSummary(m, num) {
      if (isDaysRemark(m)) {
        const times = groupDaysByTime(m).map(g => `${g.weeks.join('・')} ${g.startTime || '-'}〜${g.endTime || '-'}`)
        return '、　作業時間【' + num + '】：' + (times.length ? times.join('、') : '-')
      }
      return '、　作業開始時間【' + num + '】：' + this.getOutputSummaryText(m.startTime) + '、　作業終了時間【' + num + '】：' + this.getOutputSummaryText(m.endTime)
    },

    /**
     * 登録内容 作業曜日、曜日の値を取得
     */
    getSummaryWorkRemarks(remarks) {
      let ret = ''
      remarks.forEach((val, index) => {
        let idx = index + 1
        ret += '、　作業曜日【' + idx + '】：' + val.workDays
        ret += '、　作業開始時間【' + idx + '】：' + val.startTime
        ret += '、　作業終了時間【' + idx + '】：' + val.endTime
      });
      return ret
    },

    /**
     * MRSのゴミ搬出回数を取得（受注画面の表示と同じ）
     * 受注の行に保存していればそれ、無ければ（この項目を付ける前に保存した受注）見積りの詳細モーダルの値から
     * @param r 受注の行
     */
    getMrsTrashCount(r) {
      if (r.trashCount) {
        return r.trashCount
      }
      if (!this.estimateData || !this.estimateData.details) {
        return ''
      }
      const e = this.estimateData.details.find((d) => d.categoryCode == '29' && d.groupName == r.groupName)
      if (!e || !e.subItemModalData || !e.subItemModalData.selectedValue) {
        return ''
      }
      const val = e.subItemModalData.selectedValue[2]
      if (val === undefined || val === null || val === '') {
        return ''
      }
      if (val == '0') {
        return 'なし'
      }
      return `週 ${val} 回`
    },

    /**
     * 登録内容に出力するテキストを取得
     * @param props プロパティ
     * @param isInputFlag 入力可否フラグ
     */
    getOutputSummaryText(props, isInputFlag) {
      let val
      if (!props) {
        // プロパティが無い場合
        if (isInputFlag) {
          // 入力不可の項目の場合
          val = '---'
        } else {
          val = ''
        }
      } else {
        // プロパティがある場合
        if (typeof props === 'string') {
          // 文字列の場合
          if (isInputFlag && props == '') {
            // 入力不可の項目の場合で、値が空の場合
            val = '---'
          } else {
            val = props
          }
        } else if (Array.isArray(props)) {
          // 配列の場合
          if (isInputFlag && props.length == 0) {
            // 入力不可の項目の場合で、配列が空の場合
            val = '---'
          } else {
            val = props
          }
        } else {
          // オブジェクトの場合
          if (isInputFlag && Object.keys(props).length == 0) {
            // 入力不可の項目の場合で、オブジェクトが空の場合
            val = '---'
          } else {
            val = props
          }
        }
      }
      return val
    },

    /**
     * 発注処理 別タブで表示
     */
    async purchaseMail() {
      this.purchaseMailOpen = true
    },

    /**
     * 一度でも発注メールを送信したか判定
     */
    async checkAlreadySent() {
      if (this.orderData && this.orderData.orderNo) {
        const res = await purchaseManager.getHistoryByOrderNo(this, this.orderData.orderNo)
        if (res && res.length) {
          this.isAlreadySent = true
        }
      }
    },

    /*
     * お問い合わせカテゴリーを過去の文言を新しくする
     * @param category お問い合わせカテゴリー
     */
    setNewCategory(rp) {
      if (rp.category && rp.category.length) {
        for (let i = 0; i < rp.category.length; i++) {
          const ca = rp.category[i]
          if (ca == '契約依頼（発注・解約・変更）') {
            rp.category[i] = '変更処理（解約・変更）'
          } else if (ca == '受注処理一覧') {
            rp.category[i] = '受注処理（新規・金額変更）'
          } else if (ca == '雇い入れ') {
            if (rp.employmentRegularStaff == true) rp.category[i] = '雇い入れ（社員）'
            else rp.category[i] = '雇い入れ（清掃員）'
          }
        }
      }
      return rp.category
    },

    /*
     * お見積りカテゴリーを過去の文言を新しくする
     * @param category お見積りカテゴリー
     */
    setNewEstimateCategory(category) {
      if (category && category.length) {
        for (let i = 0; i < category.length; i++) {
          const ca = category[i]
          if (ca == '各種特別清掃') {
            category[i] = '特別清掃'
          }
        }
      }
      return category
    },

    /*
     * 雇い入れ 種別を過去の文言を新しくする
     * @param category 雇い入れ 種別
     */
     setNewEmploymentClass(employment) {
      if (employment && employment.length) {
        for (let i = 0; i < employment.length; i++) {
          const ca = employment[i]
          if (ca == '物件退職') {
            employment[i] = '契約変更'
          }
        }
      }
      return employment
    },

    /**
     * 担当者・依頼主にログインユーザーをセット
     */
    setDefaultStaff() {
      const loginUser = this.$store.getters.user
      this.requestPost.toStaffName = loginUser.user_name
      this.requestPost.toStaffId = loginUser.id
      this.requestPost.byUser = loginUser.user_name
      this.requestPost.byUserId = loginUser.id
    },

    /**
     * 受注データを生成
     */
    setOrderData() {
      // 見積の選択ダイアログ表示
      this.selectEstimateForOrder = true
    },

    /**
     * 受注する見積を選択イベント
     * @param est 選択した見積データ
     */
    async modalEstimateSelected(est) {
      // 見積の選択ダイアログ非表示
      this.selectEstimateForOrder = false
      // 見積データ
      this.estimateData = est
      // 見積に紐づくメインを取得
      const main = await requestPostManager.getRequestPost(this, est.requestPostId)

      // 選択した見積のデータを反映
      this.requestPost.category2 = ['社内']
      this.requestPost.requestNo = main.requestNo
      this.requestPost.siteCode = main.siteCode
      this.requestPost.siteName = est.buildingName
      this.requestPost.clientName = est.clientName
      this.requestPost.clientCode = est.clientCode
      this.requestPost.clientAddress1 = est.clientAddress1
      this.requestPost.clientAddress2 = est.clientAddress2
      this.requestPost.clientPersonName = est.clientPersonName
      // アポロ管財依頼先部署にログインユーザーの部署をセット
      const ud = this.$store.getters.loginUserData
      this.requestPost.toDepartment = ''
      if (ud.departmentName) {
        this.requestPost.toDepartment = ud.departmentName
      }
      this.requestPost.toDepartmentId = ''
      if (ud.departmentIdUser) {
        this.requestPost.toDepartmentId = ud.departmentIdUser
      }

      this.requestPost.limitDate = utils.addDays(utils.getToday(), 7)
      this.requestPost.kubunLimit = 1
      if (est.buildingName && est.buildingName != '') {
        this.requestPost.inquiry_title = est.buildingName + ' ' + '受注処理'
      } else {
        this.requestPost.inquiry_title = '受注処理'
      }
      // 受注フラグ
      this.isOrder = true
      // CSS判定_画面幅
      this.isCategory = false
      // お客様項目必須解除
      this.isClientRequired = false
      // スタッフリスト生成
      this.getStaffNameList(ud.departmentIdUser, false)
    },

    /**
     * 面接関連を選択イベント
     * @param emp 選択した面接関連タスクデータ
     */
    modalInterviewsSelected(emp) {
      // 面接関連の選択ダイアログ非表示
      this.selectInterviewsForEmployment = false
      this.interviewsId = null
      if (emp) {
        // 新規登録の際に使用する面接のID
        this.interviewsId = emp._id
      }

      // 面接のデータを雇い入れに反映
      this.requestPost = requestPostManager.setEmployFromInterview(this.$store.getters.user, emp, this.requestPost)

      // 社員の場合
      if (this.requestPost.employmentRegularStaff) {
        this.requestPost.limitDate = ''
        // タイトル
        this.getTitle2(this.requestPost)
      }

      this.category2Changed()
    },

    /**
     * 得意先コードと得意先名が合っているか
     * @param selectedClient 得意先コードから取得した情報
     */
    checkClientCode(selectedClient) {
      const name = selectedClient.clientName + ' ' + selectedClient.clientDepartmentName
      if (name == this.requestPost.clientName) {
        return true
      }
      return false
    },

    /**
     * 非公開依頼 参照権限 チェック
     * @param {*} requestPost リクエストポスト
     * @param {*} subTasks サブタスク
     */
    isPrivateAuthorized(requestPost, subTasks) {
      // 担当者もしくは依頼主
      if (requestPost.toStaffId == this.$store.getters.user.id || requestPost.byUserId == this.$store.getters.user.id) return true
      // サブ依頼担当者
      if (subTasks.find(task => task.toStaffId == this.$store.getters.user.id)) return true

      // 未定の場合は、同じ部署はOK
      let d = this.$store.getters.loginUserData
      if (requestPost.toStaffName == '未定') {
        if (d.departmentName == requestPost.toDepartment || d.departmentIdUser == requestPost.toDepartmentId) {
          return true
        }
      }
      return false
    },

    /**
     * 雇い入れ社員用 参照権限 チェック
     */
    async isRegularStaffAuthorized() {
      // 管理者権限、ログインユーザーの所属課長以上（兼任も含めて）が人事なら、true
      const dualPosition = this.$store.getters.dualPosition // 兼任含む部署
      let isEmployment = utils.isRegularStaffAuthorized(this.$store.getters.auth, dualPosition)
      if (!isEmployment) {
        // グループ4以上
        const group4 = utils.isGroup4(this.$store.getters.user.group_num)
        if (group4) {
          isEmployment = utils.isRegularStaffAuthorized2(dualPosition, this.mainDepartment, this.requestPost, this.$store.getters.user.id, this.$store.getters.user.user_name)
        }
      }
      return isEmployment
    },

    /**
     * 面接社員用 参照権限 チェック
     */
    async isRegularStaffInterviewAuthorized() {
      const rp = this.requestPost
      const dualPosition = this.$store.getters.dualPosition
      return utils.isRegularStaffInterviewAuthorized(this.$store.getters.user.id, this.$store.getters.user.user_name, rp.byUser, rp.toStaffName, rp.interviewsResult, dualPosition, rp.toDepartment, this.$store.getters.auth)
    },

    /**
     * 生年月日の初期値を取得
     *  60年前の1月1日
     */
    getInitBirthDate(){
      return String(moment().format('YYYY') - 60 + '-01-01')
    },

    /**
     * 面接のタイトル設定
     * @param val 対象データ
     */
    getTitle(val) {
      // 採否結果
      let res = ''
      // 名前
      let name = ''
      // 物件名
      let site = ''
      // 新卒
      let newGrad = ''
      // 新卒の一次結果
      let firstRes = ''
      // 卒業年
      let year = ''

      if (val && val.name) {
        name = val.name
      }
      if (val && val.site) {
        site = val.site
      }
      if (val.newGrad) {
        newGrad = '（新卒）'
        if (val.firstInterviewRes) {
          firstRes = `【${val.firstInterviewRes}】`
        }
        if (val.year) {
          year = `${val.year}年卒`
        }
      }
      if (val && val.interviewsResult && val.interviewsResult.length) {
        res = val.interviewsResult[0]
        firstRes = ''
      } else if (val.interviewsRegularStaff) {
        res = '社員採否未決'
      }

      this.requestPost.inquiry_title = newGrad + firstRes + res + '　' + name + '　' + site + year
      if (this.requestPost.inquiry_title) {
        this.requestPost.inquiry_title = this.requestPost.inquiry_title.trim()
      }
    },

    /**
     * 新規入社以外の雇い入れタイトル設定
     * @param val 対象データ
     */
    getTitle2(val) {
      // 種別
      let cl = ''
      // 名前
      let name = ''
      // 物件名
      let site = ''
      // 清掃員の契約変更詳細
      let detail = ''

      if (val && val.employmentClass && val.employmentClass.length) {
        cl = val.employmentClass[0]
      }
      if (val && val.employmentName) {
        name = val.employmentName
      }
      if (val && val.employmentBuildingName) {
        site = '　' + val.employmentBuildingName
      }
      if (val && cl == '契約変更') {
        if (val.modifyType == 1) {
          if (val.changeOnlyPrice) {
            detail = '（金額のみ変更）'
          } else {
            detail = '（契約内容変更）'
          }
        } else if (val.modifyType == 2) {
          detail = '（作業終了）'
        }
      }
      this.requestPost.inquiry_title = cl + '　' + name + site + detail
      if (this.requestPost.inquiry_title) {
        this.requestPost.inquiry_title = this.requestPost.inquiry_title.trim()
      }
    },

    /**
     * 清掃員リスト取得
     */
    async getAkbsStaffList() {
      this.allAkbsStaffList = []
      this.akbsStaffList = []
      const list = await backend.searchData('akbsTable/getInstructEmploymentStaff', null)
      if (list && list.data.data && list.data.data.length) {
        this.allAkbsStaffList = list.data.data
        this.akbsStaffList = list.data.data
      }
    },

    /**
     * 清掃員名選択
     */
    async staffSelected(e) {
      this.requestPost.staffNumber = e.staffDailyCleaning
      this.requestPost.telephoneNumber = e.numberMobilePhoneStaff
      if (!this.requestPost.telephoneNumber) {
        this.requestPost.telephoneNumber = e.numberPhoneStaff
      }
      await this.getEmploymentBuildingList(e)
    },

    /**
     * 清掃員名変更
     */
    async staffChanged() {
      if (!this.requestPost.employeeName) {
        this.requestPost.staffNumber = ''
        // this.requestPost.telephoneNumber = ''
        this.akbsStaffList = utils.clone(this.allAkbsStaffList)

        await this.getEmploymentBuildingList()
      }
    },

    /**
     * TEL変更イベント
     */
    changeTel() {
      this.akbsStaffList = utils.clone(this.allAkbsStaffList)
      if (this.requestPost.telephoneNumber) {
        const tel = this.requestPost.telephoneNumber.replace(/-/g, '')
        // 該当する清掃員を取得
        const akbsStaffList = this.allAkbsStaffList.filter((row) => {
          // 電話番号が未登録（null）の清掃員がいる
          const mobile = (row.numberMobilePhoneStaff || '').replace(/-/g, '')
          const phone = (row.numberPhoneStaff || '').replace(/-/g, '')
          return mobile.indexOf(tel) > -1 || phone.indexOf(tel) > -1
        })

        if (akbsStaffList && akbsStaffList.length) {
          this.akbsStaffList = akbsStaffList
          if (this.akbsStaffList.length == 1) {
            const e = this.akbsStaffList[0]
            this.requestPost.employeeName = e.kana
            this.requestPost.staffNumber = e.staffDailyCleaning
            this.getEmploymentBuildingList(e)
          }
        }
      }
    },

    /**
     * 物件リスト取得
     */
    async getEmploymentBuildingList(tar) {
      const param = {
        kana: this.requestPost.employeeName
      }
      if (tar && tar.kana) {
        param.kana = tar.kana
      }

      if (param.kana) {
        const list = await backend.searchData('akbsTable/getClientAndSiteList', param)
        if (list && list.data.data && list.data.data.length) {
          this.akbsBuildingList = list.data.data
          return
        }
      }
      this.akbsBuildingList = utils.clone(this.allAkbsBuildingList)
    },

    /**
     * 物件リスト全取得
     */
    async getAllEmploymentBuildingList() {
      const list = await backend.searchData('akbsTable/getClientAndSiteList', null)
      if (list && list.data.data && list.data.data.length) {
        this.allAkbsBuildingList = list.data.data
      } else {
        this.allAkbsBuildingList = []
      }
    },

    /**
     * 面接関連選択イベント
     */
    async InterviewsDialog() {
      this.requestPost.newGrad = false
      const ud = this.$store.getters.loginUserData

      let res = null
      // 面接関連メニューから入った場合
      if (this.$route.query.interviews) {
        res = this.$route.query.interviews
      } else {
        // 社員か清掃員か選択する
        res = await dialogs.showConfirmDialog3('当てはまるものを選択してください', '', '清掃員', '中途社員', '新卒社員')
      }

      // 清掃員の場合
      if (res == '1') {
        this.requestPost.interviewsRegularStaff = false
        this.requestPost.interviewsMedium = 'ハローワーク'
      // 正社員の場合
      } else {
        this.requestPost.interviewsRegularStaff = true
        this.requestPost.interviewer = this.$store.getters.user.user_name
        // 期限を2週間後
        this.requestPost.limitDate = moment().add(14, 'days').format('YYYY-MM-DD')
        this.requestPost.kubunLimit = 1
        // 面接日
        this.requestPost.interviewsDate = moment().format('YYYY-MM-DD')
        // 結果を送信する日付
        this.requestPost.sendResDate = moment().add(1, 'days').format('YYYY-MM-DD')

        // 新卒の場合
        if (res == '3') {
          this.requestPost.newGrad = true
          // 卒業予定年
          this.requestPost.gradYear = String(moment().add(1, 'year').year())
          // 面接官ID
          this.requestPost.interviewerId = this.$store.getters.user.id

          // 新卒の場合のみ部署を入れる
          if (ud.departmentIdUser) {
            // 希望部署
            this.requestPost.interviewsDepartmentId = [ud.departmentIdUser]
            // アポロ担当部署
            this.requestPost.toDepartment = ud.departmentName
            this.requestPost.toDepartmentId = ud.departmentIdUser
          }
        }
      }
      // 社内
      this.requestPost.category2 = ['社内']
      this.category2Changed()
    },

    /**
     * デンタツ詳細カテゴリー変更
     */
    async changeDentatsuCate() {
      if (this.requestPost.dentatsuCategory && this.requestPost.dentatsuCategory.includes('協力会社')) {
        if (!this.requestPost.mail || !Object.keys(this.requestPost.mail).length) {
          this.requestPost.mail = {
            to: [''],
            cc: [''],
            bcc: [''],
            subject: '',
            text: '',
            user: this.$store.getters.user.user_name,
            date: moment().format('YYYY-MM-DD'),
            time: moment().format('HH:mm'),
          }
          await this.changeToMail()

          // 問い合わせ内容に特定の文言がなければ追加
          if (!this.requestPost.inquiry_title || this.requestPost.inquiry_title.indexOf('必ずご返信くださいますよう') == -1) {
            this.requestPost.inquiry_title += '\r\n\r\n本メールを受信されましたら、必ずご返信くださいますようお願いいたします。\r\n何卒よろしくお願い申し上げます。'
          }
        }
        // 件名設定
        this.setDentatsuSubject()
      }
      this.canEdit = this.checkCanEdit()
    },

    /**
     * デンタツメール件名設定
     */
    setDentatsuSubject() {
      // デンタツ詳細カテゴリー
      let cate = ''
      // お客様会社名
      let site = ''
      if (this.requestPost.mail) {
        site = this.requestPost.mail.client1
        if (this.requestPost.mail.client2) {
          site += ' ' + this.requestPost.mail.client2
        }
      } else {
        site = this.requestPost.clientName
      }
      // お客様名
      let cust = this.requestPost.clientPersonName

      if (this.requestPost.dentatsuCategory && this.requestPost.dentatsuCategory.length) {
        const res = this.requestPost.dentatsuCategory.filter((d) => {
          return d != '協力会社'
        })
        if (res && res.length) {
          cate = '【' + res.join('・') + '】'
        }
      }

      const text = []
      if (cate) {
        text.push(cate)
      }
      if (site) {
        text.push(site)
      }
      if (cust) {
        text.push(cust)
      }
      if (this.requestPost.mail) {
        this.requestPost.mail.subject = text.join(' ')
      }
    },

    /**
     * お客様名変更
     */
    dentatsuClientName() {
      if (this.requestPost.dentatsuCategory && this.requestPost.dentatsuCategory.includes('協力会社')) {
        // 件名設定
        this.setDentatsuSubject()
      }
    },

    /**
     * デンタツお客様会社名（物件名）をデンタツメールに反映
     */
    async changeToMail() {
      if (this.requestPost.dentatsuCategory && this.requestPost.dentatsuCategory.includes('協力会社')) {
        await utils.wait(100)
        if (this.requestPost.clientName) {
          this.requestPost.mail.client1 = this.requestPost.clientName
        } else {
          this.requestPost.mail.client1 = ''
        }
        // 件名設定
        this.setDentatsuSubject()
        this.$refs.dentatsuMail.changeReload()
      }
      if (!this.requestPost.clientName) {
        this.requestPost.siteAddress = ''
      }
      this.reload++
    },

    /**
     * デンタツ物件選択イベント
     */
    async siteDentatsuSelectedForm (target) {
      this.changeToMail()
      await this.getSiteAddressAndUserBySite(target.cd)
    },

    /**
     * デンタツ物件選択イベント（モーダル）
     */
    async siteDentatsuSelected(target) {
      this.siteDentatsuModal = false
      this.requestPost.clientName = target.nameSite
      this.changeToMail()
      await this.getSiteAddressAndUserBySite(target.cdSite)
    },

    /**
     * 物件住所とそのエリア担当取得して、担当者に反映
     */
    async getSiteAddressAndUserBySite(siteCode) {
      if (!this.requestPost.employeeName) {
        return
      }
      // 住所取得
      let address = ''
      const res = await backend.searchData('akbsTable/getSiteAddressAndUserBySite', { siteCode })
      if (res && res.data.data) {
        address = res.data.data.address
      }
      this.requestPost.siteAddress = address
      this.reload++

      // まだ部署名が未入力の場合
      if (!this.requestPost.toDepartment) {
        // 勤怠管理課を入れる
        this.requestPost.toDepartment = 'デンタツ用_勤怠採用課'

        // 部署情報
        const depInfo = this.toDepartmentList.find((d) => {
          return d.name == this.requestPost.toDepartment
        })
        // 担当者リストなど生成
        this.toDepartmentSelected(depInfo)
        // デンタツ用_勤怠採用課の場合、未定をセット
        const mitei = this.toStaffNameList.find((ud) => {
          return (ud.userName == '未定')
        })
        if (mitei) {
          this.requestPost.toStaffId = mitei.userId
          this.requestPost.toStaffName = mitei.userName
        }
      }
    },

    /**
     * デンタツ「協力会社」メール送信前の入力チェック
     * 送信後の保存で必須項目に引っかかると、メールだけ送られてメインタスクが保存されないので、送信の前に確かめる
     */
    async validateBeforeDentatsuMail() {
      return !!await this.validation(false, true)
    },

    /**
     * デンタツ「協力会社」メール送信開始
     */
    sendingStart() {
      this.isSaving = true
      this.sending = true
    },

    /**
     * デンタツ「協力会社」メール送信終了
     * @param res 送信成功
     * @param {*} mail メールの内容
     */
    async sendmailRes(res, mail) {
      this.sending = false

      if (res) {
        this.isSendMail = true
        // 成功時、メインタスク保存
        await this.save(false, res, mail)
      } else {
        this.isSaving = false
      }
    },

    /**
     * 得意先メアド選択イベント
     */
    selectedMail(e) {
      this.requestPost.clientMail = ''
      this.requestPost.clientMail = e.mail
    },

    /**
     * お客様担当変更イベント
     */
    changeClientPersonName() {
      if (this.requestPost.clientPersonName) {
        let name = utils.deleteSpace(this.requestPost.clientPersonName)
        if (name.endsWith('様')) {
          name = name.slice(0, -1)
        }
        const res = this.mailListAll.filter((a) => {
          return utils.deleteSpace(a.name).indexOf(name) > -1
        })

        if (res && res.length) {
          this.mailList = res

          // 画面に入力されている得意先と裏で取得した得意先が同じ場合、得意先が同じものに絞る
          if (this.requestPost.clientName && this.requestPost.clientName1) {
            const front = this.requestPost.clientName.trim()
            const back = (this.requestPost.clientName1 + ' ' + this.requestPost.clientName2).trim()

            if (front == back) {
              const client1 = utils.zenkaku(this.requestPost.clientName1)
              this.mailList = this.mailList.filter((a) => {
                return a.clientName == client1
              })
            }
          }

          if (this.mailList && this.mailList.length) {
            return
          }
        }
      }
      this.mailList = utils.clone(this.mailListAll)
    },

    /**
     * 清掃員詳細画面
     */
    openAkbsStaff() {
      const akbs = PIGEON_CONFIG.akbsUrl + 'staffs/' + this.requestPost.staffNumber
      window.open(akbs, '_blank');
    },

    /**
     * 期限区分変更
     */
    changeKubunLimit(e) {
      let maxLimit = ''
      // 短期
      if (e == 1) {
        maxLimit = moment(this.requestPost.requestDate).add(1, 'months').format('YYYY-MM-DD')
        if (maxLimit < this.requestPost.limitDate) {
          this.requestPost.limitDate = ''
        }
      }
      this.reload++
    }
  }
}
</script>

<style>
#estimation-clean-category div button[type=button] {
  width: 19% !important;
}

#inquiry-category div button[type=button] {
  width: 19% !important;
}

div.rp-estimate {
  flex: 1
}

div.rp-no-estimate {
  display: none !important
}

.note-link {
  display: block;
  margin-top: -10px;
}

.dccode >>> input[type=text] {
  font-weight: bold !important;
}
</style>